export const rate = [
  {
    "2000": 0.92676,
    "2001": 0.92647,
    "2002": 0.9262,
    "2003": 0.92607,
    "2004": 0.92592,
    "2005": 0.92583,
    "2006": 0.92577,
    "2007": 0.92574,
    "2008": 0.92569,
    "2009": 0.92564,
    "2010": 0.9256,
    "2011": 0.92554,
    "2012": 0.92546,
    "2013": 0.92539,
    "2014": 0.92532,
    "2015": 0.92527,
    "2016": 0.92518,
    "2017": 0.92509,
    "2018": 0.92502,
    "2019": 0.92498,
    "2020": 0.9249,
    "2021": 0.92484,
    "2022": 0.92476,
    "2023": 0.92469,
    "2024": 0.92465,
    "GeoAreaCode": 4,
    "GeoAreaName": "Afghanistan"
  },
  {
    "2000": 0.99807,
    "2001": 0.99807,
    "2002": 0.99807,
    "2003": 0.99807,
    "2004": 0.99807,
    "2005": 0.99801,
    "2006": 0.99795,
    "2007": 0.9979,
    "2008": 0.99784,
    "2009": 0.99779,
    "2010": 0.99773,
    "2011": 0.99768,
    "2012": 0.99767,
    "2013": 0.99767,
    "2014": 0.99767,
    "2015": 0.9977,
    "2016": 0.9977,
    "2017": 0.9977,
    "2018": 0.99768,
    "2019": 0.99765,
    "2020": 0.99762,
    "2021": 0.99762,
    "2022": 0.99762,
    "2023": 0.99762,
    "2024": 0.99762,
    "GeoAreaCode": 248,
    "GeoAreaName": "Åland Islands"
  },
  {
    "2000": 0.9154,
    "2001": 0.91405,
    "2002": 0.91263,
    "2003": 0.9117,
    "2004": 0.91082,
    "2005": 0.9104,
    "2006": 0.91016,
    "2007": 0.90996,
    "2008": 0.90979,
    "2009": 0.90966,
    "2010": 0.90949,
    "2011": 0.90941,
    "2012": 0.90933,
    "2013": 0.90928,
    "2014": 0.90923,
    "2015": 0.90914,
    "2016": 0.90905,
    "2017": 0.90892,
    "2018": 0.9087,
    "2019": 0.90849,
    "2020": 0.90829,
    "2021": 0.908,
    "2022": 0.90789,
    "2023": 0.90772,
    "2024": 0.90751,
    "GeoAreaCode": 8,
    "GeoAreaName": "Albania"
  },
  {
    "2000": 0.92351,
    "2001": 0.92336,
    "2002": 0.9231,
    "2003": 0.9228,
    "2004": 0.92263,
    "2005": 0.92253,
    "2006": 0.92237,
    "2007": 0.92223,
    "2008": 0.92224,
    "2009": 0.92193,
    "2010": 0.9218,
    "2011": 0.92156,
    "2012": 0.92137,
    "2013": 0.92116,
    "2014": 0.92084,
    "2015": 0.92061,
    "2016": 0.92042,
    "2017": 0.92015,
    "2018": 0.91988,
    "2019": 0.9197,
    "2020": 0.91956,
    "2021": 0.91938,
    "2022": 0.9193,
    "2023": 0.91925,
    "2024": 0.91913,
    "GeoAreaCode": 12,
    "GeoAreaName": "Algeria"
  },
  {
    "2000": 0.87614,
    "2001": 0.8758,
    "2002": 0.87566,
    "2003": 0.87586,
    "2004": 0.87539,
    "2005": 0.8755,
    "2006": 0.87571,
    "2007": 0.87535,
    "2008": 0.87612,
    "2009": 0.87603,
    "2010": 0.87515,
    "2011": 0.8756,
    "2012": 0.87425,
    "2013": 0.87399,
    "2014": 0.87374,
    "2015": 0.87304,
    "2016": 0.8729,
    "2017": 0.87334,
    "2018": 0.87246,
    "2019": 0.87203,
    "2020": 0.87117,
    "2021": 0.8721,
    "2022": 0.87109,
    "2023": 0.8711,
    "2024": 0.871,
    "GeoAreaCode": 16,
    "GeoAreaName": "American Samoa"
  },
  {
    "2000": 0.96434,
    "2001": 0.96339,
    "2002": 0.96254,
    "2003": 0.96164,
    "2004": 0.9608,
    "2005": 0.96064,
    "2006": 0.96053,
    "2007": 0.96042,
    "2008": 0.96029,
    "2009": 0.96017,
    "2010": 0.96004,
    "2011": 0.95994,
    "2012": 0.95989,
    "2013": 0.95992,
    "2014": 0.96002,
    "2015": 0.95992,
    "2016": 0.95978,
    "2017": 0.95915,
    "2018": 0.95801,
    "2019": 0.95697,
    "2020": 0.95611,
    "2021": 0.95579,
    "2022": 0.95556,
    "2023": 0.95543,
    "2024": 0.95534,
    "GeoAreaCode": 20,
    "GeoAreaName": "Andorra"
  },
  {
    "2000": 0.93287,
    "2001": 0.93277,
    "2002": 0.93273,
    "2003": 0.93271,
    "2004": 0.93265,
    "2005": 0.93255,
    "2006": 0.9326,
    "2007": 0.93249,
    "2008": 0.93246,
    "2009": 0.93245,
    "2010": 0.93236,
    "2011": 0.93233,
    "2012": 0.9322,
    "2013": 0.93203,
    "2014": 0.9318,
    "2015": 0.93162,
    "2016": 0.93147,
    "2017": 0.93135,
    "2018": 0.93131,
    "2019": 0.93127,
    "2020": 0.93122,
    "2021": 0.93123,
    "2022": 0.93127,
    "2023": 0.93126,
    "2024": 0.93125,
    "GeoAreaCode": 24,
    "GeoAreaName": "Angola"
  },
  {
    "2000": 0.93081,
    "2001": 0.92945,
    "2002": 0.92771,
    "2003": 0.92597,
    "2004": 0.92442,
    "2005": 0.92299,
    "2006": 0.92133,
    "2007": 0.91996,
    "2008": 0.91843,
    "2009": 0.91714,
    "2010": 0.91563,
    "2011": 0.91394,
    "2012": 0.91248,
    "2013": 0.91098,
    "2014": 0.90911,
    "2015": 0.90741,
    "2016": 0.90619,
    "2017": 0.90433,
    "2018": 0.90291,
    "2019": 0.90164,
    "2020": 0.89994,
    "2021": 0.8983,
    "2022": 0.89614,
    "2023": 0.89487,
    "2024": 0.89305,
    "GeoAreaCode": 660,
    "GeoAreaName": "Anguilla"
  },
  {
    "2000": 0.91576,
    "2001": 0.91461,
    "2002": 0.91366,
    "2003": 0.91223,
    "2004": 0.91127,
    "2005": 0.91006,
    "2006": 0.90899,
    "2007": 0.90786,
    "2008": 0.90669,
    "2009": 0.90583,
    "2010": 0.90457,
    "2011": 0.9037,
    "2012": 0.90276,
    "2013": 0.90143,
    "2014": 0.90017,
    "2015": 0.89923,
    "2016": 0.89772,
    "2017": 0.89662,
    "2018": 0.89566,
    "2019": 0.89427,
    "2020": 0.8931,
    "2021": 0.89223,
    "2022": 0.89119,
    "2023": 0.89,
    "2024": 0.88911,
    "GeoAreaCode": 28,
    "GeoAreaName": "Antigua and Barbuda"
  },
  {
    "2000": 0.86178,
    "2001": 0.86138,
    "2002": 0.86123,
    "2003": 0.86084,
    "2004": 0.86065,
    "2005": 0.86034,
    "2006": 0.8602,
    "2007": 0.86004,
    "2008": 0.85982,
    "2009": 0.85971,
    "2010": 0.85954,
    "2011": 0.85945,
    "2012": 0.85931,
    "2013": 0.85938,
    "2014": 0.8593,
    "2015": 0.85933,
    "2016": 0.8592,
    "2017": 0.85916,
    "2018": 0.85909,
    "2019": 0.85904,
    "2020": 0.8589,
    "2021": 0.85878,
    "2022": 0.85875,
    "2023": 0.85868,
    "2024": 0.85866,
    "GeoAreaCode": 32,
    "GeoAreaName": "Argentina"
  },
  {
    "2000": 0.86156,
    "2001": 0.86134,
    "2002": 0.86111,
    "2003": 0.86063,
    "2004": 0.85916,
    "2005": 0.85687,
    "2006": 0.8547,
    "2007": 0.85176,
    "2008": 0.85012,
    "2009": 0.84881,
    "2010": 0.84766,
    "2011": 0.84719,
    "2012": 0.84677,
    "2013": 0.84621,
    "2014": 0.84582,
    "2015": 0.84538,
    "2016": 0.84459,
    "2017": 0.84415,
    "2018": 0.8434,
    "2019": 0.84267,
    "2020": 0.84192,
    "2021": 0.84141,
    "2022": 0.84071,
    "2023": 0.84015,
    "2024": 0.83949,
    "GeoAreaCode": 51,
    "GeoAreaName": "Armenia"
  },
  {
    "2000": 0.97314,
    "2001": 0.97333,
    "2002": 0.97331,
    "2003": 0.97343,
    "2004": 0.97342,
    "2005": 0.97335,
    "2006": 0.97389,
    "2007": 0.97418,
    "2008": 0.97427,
    "2009": 0.97458,
    "2010": 0.9747,
    "2011": 0.97488,
    "2012": 0.97499,
    "2013": 0.97508,
    "2014": 0.9751,
    "2015": 0.97514,
    "2016": 0.97517,
    "2017": 0.97526,
    "2018": 0.97528,
    "2019": 0.97531,
    "2020": 0.97535,
    "2021": 0.97538,
    "2022": 0.9754,
    "2023": 0.97548,
    "2024": 0.9755,
    "GeoAreaCode": 533,
    "GeoAreaName": "Aruba"
  },
  {
    "2000": 0.88399,
    "2001": 0.88035,
    "2002": 0.87748,
    "2003": 0.87459,
    "2004": 0.87117,
    "2005": 0.86828,
    "2006": 0.86554,
    "2007": 0.86273,
    "2008": 0.85947,
    "2009": 0.85714,
    "2010": 0.85479,
    "2011": 0.85155,
    "2012": 0.84939,
    "2013": 0.84601,
    "2014": 0.84247,
    "2015": 0.83966,
    "2016": 0.83713,
    "2017": 0.83409,
    "2018": 0.83079,
    "2019": 0.82781,
    "2020": 0.82571,
    "2021": 0.8222,
    "2022": 0.81931,
    "2023": 0.81665,
    "2024": 0.81359,
    "GeoAreaCode": 36,
    "GeoAreaName": "Australia"
  },
  {
    "2000": 0.86626,
    "2001": 0.86309,
    "2002": 0.86021,
    "2003": 0.85691,
    "2004": 0.85428,
    "2005": 0.851,
    "2006": 0.84809,
    "2007": 0.84538,
    "2008": 0.84274,
    "2009": 0.84056,
    "2010": 0.83781,
    "2011": 0.83532,
    "2012": 0.8322,
    "2013": 0.8292,
    "2014": 0.82644,
    "2015": 0.82412,
    "2016": 0.82071,
    "2017": 0.81844,
    "2018": 0.81569,
    "2019": 0.81234,
    "2020": 0.80942,
    "2021": 0.8071,
    "2022": 0.80416,
    "2023": 0.80098,
    "2024": 0.79814,
    "GeoAreaCode": 53,
    "GeoAreaName": "Australia and New Zealand"
  },
  {
    "2000": 0.89713,
    "2001": 0.8971,
    "2002": 0.89709,
    "2003": 0.89706,
    "2004": 0.89704,
    "2005": 0.89582,
    "2006": 0.89455,
    "2007": 0.89329,
    "2008": 0.89199,
    "2009": 0.89075,
    "2010": 0.88946,
    "2011": 0.88822,
    "2012": 0.88701,
    "2013": 0.88615,
    "2014": 0.8853,
    "2015": 0.88461,
    "2016": 0.88349,
    "2017": 0.88226,
    "2018": 0.88101,
    "2019": 0.87975,
    "2020": 0.87844,
    "2021": 0.87727,
    "2022": 0.87595,
    "2023": 0.87516,
    "2024": 0.87392,
    "GeoAreaCode": 40,
    "GeoAreaName": "Austria"
  },
  {
    "2000": 0.94285,
    "2001": 0.94215,
    "2002": 0.94165,
    "2003": 0.94121,
    "2004": 0.94095,
    "2005": 0.94067,
    "2006": 0.94034,
    "2007": 0.94043,
    "2008": 0.94045,
    "2009": 0.94046,
    "2010": 0.94045,
    "2011": 0.94044,
    "2012": 0.94048,
    "2013": 0.94052,
    "2014": 0.94085,
    "2015": 0.9409,
    "2016": 0.94099,
    "2017": 0.94099,
    "2018": 0.94101,
    "2019": 0.94103,
    "2020": 0.94103,
    "2021": 0.94127,
    "2022": 0.94108,
    "2023": 0.94173,
    "2024": 0.94192,
    "GeoAreaCode": 31,
    "GeoAreaName": "Azerbaijan"
  },
  {
    "2000": 0.73465,
    "2001": 0.73356,
    "2002": 0.73259,
    "2003": 0.73153,
    "2004": 0.73046,
    "2005": 0.72934,
    "2006": 0.72805,
    "2007": 0.72724,
    "2008": 0.7261,
    "2009": 0.72511,
    "2010": 0.72427,
    "2011": 0.72289,
    "2012": 0.72151,
    "2013": 0.72009,
    "2014": 0.71867,
    "2015": 0.71662,
    "2016": 0.71468,
    "2017": 0.71265,
    "2018": 0.71026,
    "2019": 0.70838,
    "2020": 0.70636,
    "2021": 0.70497,
    "2022": 0.7036,
    "2023": 0.70267,
    "2024": 0.70138,
    "GeoAreaCode": 44,
    "GeoAreaName": "Bahamas"
  },
  {
    "2000": 0.80238,
    "2001": 0.79942,
    "2002": 0.79621,
    "2003": 0.79311,
    "2004": 0.78996,
    "2005": 0.78681,
    "2006": 0.78394,
    "2007": 0.78108,
    "2008": 0.77837,
    "2009": 0.77619,
    "2010": 0.77375,
    "2011": 0.77113,
    "2012": 0.76822,
    "2013": 0.76439,
    "2014": 0.76131,
    "2015": 0.75864,
    "2016": 0.75616,
    "2017": 0.7529,
    "2018": 0.7501,
    "2019": 0.74714,
    "2020": 0.74424,
    "2021": 0.7414,
    "2022": 0.73839,
    "2023": 0.73596,
    "2024": 0.73279,
    "GeoAreaCode": 48,
    "GeoAreaName": "Bahrain"
  },
  {
    "2000": 0.83145,
    "2001": 0.82748,
    "2002": 0.82344,
    "2003": 0.82004,
    "2004": 0.81606,
    "2005": 0.81191,
    "2006": 0.80784,
    "2007": 0.80366,
    "2008": 0.79935,
    "2009": 0.79541,
    "2010": 0.79101,
    "2011": 0.78715,
    "2012": 0.78299,
    "2013": 0.77926,
    "2014": 0.77411,
    "2015": 0.77008,
    "2016": 0.76637,
    "2017": 0.76138,
    "2018": 0.7575,
    "2019": 0.75298,
    "2020": 0.74894,
    "2021": 0.74437,
    "2022": 0.74125,
    "2023": 0.73698,
    "2024": 0.7323,
    "GeoAreaCode": 50,
    "GeoAreaName": "Bangladesh"
  },
  {
    "2000": 0.89404,
    "2001": 0.89259,
    "2002": 0.89115,
    "2003": 0.88975,
    "2004": 0.88804,
    "2005": 0.88682,
    "2006": 0.88549,
    "2007": 0.88395,
    "2008": 0.88264,
    "2009": 0.88126,
    "2010": 0.87987,
    "2011": 0.8788,
    "2012": 0.87713,
    "2013": 0.87581,
    "2014": 0.87453,
    "2015": 0.87317,
    "2016": 0.87181,
    "2017": 0.87004,
    "2018": 0.86902,
    "2019": 0.86751,
    "2020": 0.86615,
    "2021": 0.86458,
    "2022": 0.86334,
    "2023": 0.86141,
    "2024": 0.86031,
    "GeoAreaCode": 52,
    "GeoAreaName": "Barbados"
  },
  {
    "2000": 0.94727,
    "2001": 0.94845,
    "2002": 0.94963,
    "2003": 0.95081,
    "2004": 0.95206,
    "2005": 0.95324,
    "2006": 0.95449,
    "2007": 0.95574,
    "2008": 0.95698,
    "2009": 0.95798,
    "2010": 0.95895,
    "2011": 0.96008,
    "2012": 0.96153,
    "2013": 0.96311,
    "2014": 0.96451,
    "2015": 0.96571,
    "2016": 0.9674,
    "2017": 0.96868,
    "2018": 0.96975,
    "2019": 0.97088,
    "2020": 0.97226,
    "2021": 0.97329,
    "2022": 0.97492,
    "2023": 0.97562,
    "2024": 0.97664,
    "GeoAreaCode": 112,
    "GeoAreaName": "Belarus"
  },
  {
    "2000": 0.98393,
    "2001": 0.98389,
    "2002": 0.98389,
    "2003": 0.9839,
    "2004": 0.98384,
    "2005": 0.98363,
    "2006": 0.98304,
    "2007": 0.98273,
    "2008": 0.98229,
    "2009": 0.98176,
    "2010": 0.98137,
    "2011": 0.98121,
    "2012": 0.98083,
    "2013": 0.98079,
    "2014": 0.98077,
    "2015": 0.98078,
    "2016": 0.98067,
    "2017": 0.98052,
    "2018": 0.98016,
    "2019": 0.97971,
    "2020": 0.97934,
    "2021": 0.97893,
    "2022": 0.97842,
    "2023": 0.9781,
    "2024": 0.97763,
    "GeoAreaCode": 56,
    "GeoAreaName": "Belgium"
  },
  {
    "2000": 0.80273,
    "2001": 0.80121,
    "2002": 0.79958,
    "2003": 0.7981,
    "2004": 0.79687,
    "2005": 0.79574,
    "2006": 0.79514,
    "2007": 0.79452,
    "2008": 0.79391,
    "2009": 0.79346,
    "2010": 0.79291,
    "2011": 0.79239,
    "2012": 0.79169,
    "2013": 0.79106,
    "2014": 0.79052,
    "2015": 0.78945,
    "2016": 0.78908,
    "2017": 0.78853,
    "2018": 0.7877,
    "2019": 0.78676,
    "2020": 0.78622,
    "2021": 0.78578,
    "2022": 0.78496,
    "2023": 0.78398,
    "2024": 0.78394,
    "GeoAreaCode": 84,
    "GeoAreaName": "Belize"
  },
  {
    "2000": 0.90944,
    "2001": 0.90935,
    "2002": 0.9093,
    "2003": 0.90926,
    "2004": 0.90932,
    "2005": 0.90939,
    "2006": 0.90951,
    "2007": 0.90953,
    "2008": 0.90956,
    "2009": 0.90962,
    "2010": 0.90957,
    "2011": 0.90959,
    "2012": 0.90957,
    "2013": 0.90955,
    "2014": 0.90955,
    "2015": 0.90955,
    "2016": 0.90958,
    "2017": 0.90956,
    "2018": 0.90957,
    "2019": 0.90958,
    "2020": 0.90958,
    "2021": 0.90959,
    "2022": 0.90959,
    "2023": 0.90957,
    "2024": 0.90957,
    "GeoAreaCode": 204,
    "GeoAreaName": "Benin"
  },
  {
    "2000": 0.62205,
    "2001": 0.62065,
    "2002": 0.6204,
    "2003": 0.61875,
    "2004": 0.6189,
    "2005": 0.61775,
    "2006": 0.61862,
    "2007": 0.61879,
    "2008": 0.61894,
    "2009": 0.61829,
    "2010": 0.61814,
    "2011": 0.6173,
    "2012": 0.61651,
    "2013": 0.61493,
    "2014": 0.61335,
    "2015": 0.61331,
    "2016": 0.6114,
    "2017": 0.61016,
    "2018": 0.60886,
    "2019": 0.60817,
    "2020": 0.60573,
    "2021": 0.60618,
    "2022": 0.60477,
    "2023": 0.60342,
    "2024": 0.60205,
    "GeoAreaCode": 60,
    "GeoAreaName": "Bermuda"
  },
  {
    "2000": 0.82184,
    "2001": 0.82166,
    "2002": 0.82153,
    "2003": 0.82153,
    "2004": 0.82159,
    "2005": 0.82156,
    "2006": 0.82155,
    "2007": 0.82147,
    "2008": 0.82157,
    "2009": 0.82155,
    "2010": 0.82167,
    "2011": 0.82184,
    "2012": 0.8219,
    "2013": 0.82173,
    "2014": 0.82185,
    "2015": 0.82207,
    "2016": 0.82203,
    "2017": 0.82209,
    "2018": 0.82203,
    "2019": 0.82207,
    "2020": 0.82223,
    "2021": 0.82224,
    "2022": 0.82225,
    "2023": 0.82218,
    "2024": 0.82218,
    "GeoAreaCode": 64,
    "GeoAreaName": "Bhutan"
  },
  {
    "2000": 0.86433,
    "2001": 0.86361,
    "2002": 0.86292,
    "2003": 0.8622,
    "2004": 0.86146,
    "2005": 0.8609,
    "2006": 0.86033,
    "2007": 0.85968,
    "2008": 0.85919,
    "2009": 0.85871,
    "2010": 0.85819,
    "2011": 0.85761,
    "2012": 0.85699,
    "2013": 0.85667,
    "2014": 0.85625,
    "2015": 0.85568,
    "2016": 0.85521,
    "2017": 0.8547,
    "2018": 0.85426,
    "2019": 0.85374,
    "2020": 0.8532,
    "2021": 0.85291,
    "2022": 0.85237,
    "2023": 0.852,
    "2024": 0.8516,
    "GeoAreaCode": 68,
    "GeoAreaName": "Bolivia"
  },
  {
    "2000": 0.91388,
    "2001": 0.91239,
    "2002": 0.91174,
    "2003": 0.91036,
    "2004": 0.90932,
    "2005": 0.90811,
    "2006": 0.90705,
    "2007": 0.90583,
    "2008": 0.90504,
    "2009": 0.90408,
    "2010": 0.90305,
    "2011": 0.90212,
    "2012": 0.90065,
    "2013": 0.89939,
    "2014": 0.89829,
    "2015": 0.89702,
    "2016": 0.89531,
    "2017": 0.89382,
    "2018": 0.89231,
    "2019": 0.89162,
    "2020": 0.8901,
    "2021": 0.88881,
    "2022": 0.88731,
    "2023": 0.88622,
    "2024": 0.88429,
    "GeoAreaCode": 535,
    "GeoAreaName": "Bonaire, Sint Eustatius and Saba"
  },
  {
    "2000": 0.89427,
    "2001": 0.89421,
    "2002": 0.8942,
    "2003": 0.89411,
    "2004": 0.89381,
    "2005": 0.89352,
    "2006": 0.89328,
    "2007": 0.89287,
    "2008": 0.89251,
    "2009": 0.8921,
    "2010": 0.89177,
    "2011": 0.89141,
    "2012": 0.89117,
    "2013": 0.891,
    "2014": 0.89086,
    "2015": 0.89081,
    "2016": 0.89047,
    "2017": 0.8902,
    "2018": 0.88992,
    "2019": 0.88945,
    "2020": 0.88904,
    "2021": 0.88866,
    "2022": 0.88828,
    "2023": 0.88789,
    "2024": 0.88755,
    "GeoAreaCode": 70,
    "GeoAreaName": "Bosnia and Herzegovina"
  },
  {
    "2000": 0.97737,
    "2001": 0.97732,
    "2002": 0.97723,
    "2003": 0.97716,
    "2004": 0.97712,
    "2005": 0.97701,
    "2006": 0.97689,
    "2007": 0.97675,
    "2008": 0.97662,
    "2009": 0.97651,
    "2010": 0.9764,
    "2011": 0.97628,
    "2012": 0.97618,
    "2013": 0.97617,
    "2014": 0.97616,
    "2015": 0.97616,
    "2016": 0.97614,
    "2017": 0.97613,
    "2018": 0.97611,
    "2019": 0.9761,
    "2020": 0.97609,
    "2021": 0.97609,
    "2022": 0.97609,
    "2023": 0.97609,
    "2024": 0.9761,
    "GeoAreaCode": 72,
    "GeoAreaName": "Botswana"
  },
  {
    "2000": 0.92719,
    "2001": 0.92772,
    "2002": 0.92784,
    "2003": 0.92828,
    "2004": 0.92876,
    "2005": 0.92926,
    "2006": 0.93014,
    "2007": 0.93065,
    "2008": 0.93135,
    "2009": 0.93193,
    "2010": 0.93194,
    "2011": 0.93267,
    "2012": 0.93308,
    "2013": 0.93351,
    "2014": 0.93396,
    "2015": 0.93439,
    "2016": 0.93486,
    "2017": 0.93545,
    "2018": 0.93586,
    "2019": 0.93603,
    "2020": 0.9363,
    "2021": 0.93665,
    "2022": 0.93674,
    "2023": 0.93682,
    "2024": 0.93718,
    "GeoAreaCode": 74,
    "GeoAreaName": "Bouvet Island"
  },
  {
    "2000": 0.89852,
    "2001": 0.89778,
    "2002": 0.89709,
    "2003": 0.89623,
    "2004": 0.89545,
    "2005": 0.89486,
    "2006": 0.89421,
    "2007": 0.89349,
    "2008": 0.89292,
    "2009": 0.89216,
    "2010": 0.89149,
    "2011": 0.89078,
    "2012": 0.89021,
    "2013": 0.8896,
    "2014": 0.88903,
    "2015": 0.88836,
    "2016": 0.88762,
    "2017": 0.88713,
    "2018": 0.88657,
    "2019": 0.886,
    "2020": 0.8856,
    "2021": 0.88484,
    "2022": 0.88449,
    "2023": 0.88397,
    "2024": 0.88345,
    "GeoAreaCode": 76,
    "GeoAreaName": "Brazil"
  },
  {
    "2000": 0.91703,
    "2001": 0.91113,
    "2002": 0.90597,
    "2003": 0.90181,
    "2004": 0.89746,
    "2005": 0.89235,
    "2006": 0.88857,
    "2007": 0.88404,
    "2008": 0.87998,
    "2009": 0.87599,
    "2010": 0.87071,
    "2011": 0.86652,
    "2012": 0.86123,
    "2013": 0.85674,
    "2014": 0.85038,
    "2015": 0.84596,
    "2016": 0.84053,
    "2017": 0.83544,
    "2018": 0.82974,
    "2019": 0.8254,
    "2020": 0.81977,
    "2021": 0.8153,
    "2022": 0.80915,
    "2023": 0.80496,
    "2024": 0.79985,
    "GeoAreaCode": 86,
    "GeoAreaName": "British Indian Ocean Territory"
  },
  {
    "2000": 0.78799,
    "2001": 0.78636,
    "2002": 0.7849,
    "2003": 0.78342,
    "2004": 0.78243,
    "2005": 0.78176,
    "2006": 0.78104,
    "2007": 0.78065,
    "2008": 0.78012,
    "2009": 0.77954,
    "2010": 0.77886,
    "2011": 0.77865,
    "2012": 0.77814,
    "2013": 0.77732,
    "2014": 0.77619,
    "2015": 0.77589,
    "2016": 0.77507,
    "2017": 0.77478,
    "2018": 0.77408,
    "2019": 0.77339,
    "2020": 0.77281,
    "2021": 0.772,
    "2022": 0.77156,
    "2023": 0.77111,
    "2024": 0.77039,
    "GeoAreaCode": 92,
    "GeoAreaName": "British Virgin Islands"
  },
  {
    "2000": 0.86577,
    "2001": 0.86438,
    "2002": 0.86351,
    "2003": 0.86272,
    "2004": 0.86218,
    "2005": 0.86165,
    "2006": 0.86113,
    "2007": 0.86051,
    "2008": 0.85985,
    "2009": 0.85904,
    "2010": 0.85817,
    "2011": 0.85732,
    "2012": 0.85652,
    "2013": 0.85557,
    "2014": 0.85487,
    "2015": 0.85449,
    "2016": 0.8541,
    "2017": 0.85362,
    "2018": 0.85309,
    "2019": 0.85269,
    "2020": 0.85239,
    "2021": 0.85211,
    "2022": 0.8517,
    "2023": 0.85127,
    "2024": 0.85114,
    "GeoAreaCode": 96,
    "GeoAreaName": "Brunei Darussalam"
  },
  {
    "2000": 0.94185,
    "2001": 0.94153,
    "2002": 0.94121,
    "2003": 0.94089,
    "2004": 0.94086,
    "2005": 0.94064,
    "2006": 0.94035,
    "2007": 0.94019,
    "2008": 0.9401,
    "2009": 0.93998,
    "2010": 0.93981,
    "2011": 0.93977,
    "2012": 0.93972,
    "2013": 0.93973,
    "2014": 0.93989,
    "2015": 0.93999,
    "2016": 0.94001,
    "2017": 0.93999,
    "2018": 0.93982,
    "2019": 0.93962,
    "2020": 0.93942,
    "2021": 0.93925,
    "2022": 0.93905,
    "2023": 0.9389,
    "2024": 0.93874,
    "GeoAreaCode": 100,
    "GeoAreaName": "Bulgaria"
  },
  {
    "2000": 0.98849,
    "2001": 0.98835,
    "2002": 0.9882,
    "2003": 0.98803,
    "2004": 0.98783,
    "2005": 0.98765,
    "2006": 0.98746,
    "2007": 0.98726,
    "2008": 0.98701,
    "2009": 0.98674,
    "2010": 0.98653,
    "2011": 0.98629,
    "2012": 0.98623,
    "2013": 0.98614,
    "2014": 0.98609,
    "2015": 0.98605,
    "2016": 0.98602,
    "2017": 0.98597,
    "2018": 0.98592,
    "2019": 0.9859,
    "2020": 0.98584,
    "2021": 0.98583,
    "2022": 0.98581,
    "2023": 0.98577,
    "2024": 0.98574,
    "GeoAreaCode": 854,
    "GeoAreaName": "Burkina Faso"
  },
  {
    "2000": 0.90045,
    "2001": 0.90043,
    "2002": 0.90041,
    "2003": 0.90039,
    "2004": 0.90037,
    "2005": 0.90033,
    "2006": 0.9003,
    "2007": 0.90027,
    "2008": 0.90025,
    "2009": 0.90023,
    "2010": 0.9002,
    "2011": 0.90018,
    "2012": 0.90016,
    "2013": 0.90015,
    "2014": 0.90013,
    "2015": 0.90013,
    "2016": 0.90011,
    "2017": 0.9001,
    "2018": 0.90009,
    "2019": 0.90008,
    "2020": 0.90007,
    "2021": 0.90006,
    "2022": 0.90006,
    "2023": 0.90005,
    "2024": 0.90005,
    "GeoAreaCode": 108,
    "GeoAreaName": "Burundi"
  },
  {
    "2000": 0.89725,
    "2001": 0.8973,
    "2002": 0.89758,
    "2003": 0.89853,
    "2004": 0.89943,
    "2005": 0.89977,
    "2006": 0.9006,
    "2007": 0.90169,
    "2008": 0.90206,
    "2009": 0.90315,
    "2010": 0.9035,
    "2011": 0.90386,
    "2012": 0.90427,
    "2013": 0.90471,
    "2014": 0.90486,
    "2015": 0.90527,
    "2016": 0.90536,
    "2017": 0.90548,
    "2018": 0.90559,
    "2019": 0.90579,
    "2020": 0.90599,
    "2021": 0.90616,
    "2022": 0.90638,
    "2023": 0.90645,
    "2024": 0.90668,
    "GeoAreaCode": 132,
    "GeoAreaName": "Cabo Verde"
  },
  {
    "2000": 0.85278,
    "2001": 0.85035,
    "2002": 0.84735,
    "2003": 0.84475,
    "2004": 0.84265,
    "2005": 0.84001,
    "2006": 0.83784,
    "2007": 0.83527,
    "2008": 0.8333,
    "2009": 0.8307,
    "2010": 0.82837,
    "2011": 0.82577,
    "2012": 0.82265,
    "2013": 0.81998,
    "2014": 0.81723,
    "2015": 0.81408,
    "2016": 0.81118,
    "2017": 0.80867,
    "2018": 0.80582,
    "2019": 0.8033,
    "2020": 0.8011,
    "2021": 0.79847,
    "2022": 0.79626,
    "2023": 0.79396,
    "2024": 0.79129,
    "GeoAreaCode": 116,
    "GeoAreaName": "Cambodia"
  },
  {
    "2000": 0.84861,
    "2001": 0.84848,
    "2002": 0.84839,
    "2003": 0.84831,
    "2004": 0.84816,
    "2005": 0.84797,
    "2006": 0.84773,
    "2007": 0.84745,
    "2008": 0.84706,
    "2009": 0.84681,
    "2010": 0.84658,
    "2011": 0.8463,
    "2012": 0.84599,
    "2013": 0.84571,
    "2014": 0.84549,
    "2015": 0.84509,
    "2016": 0.84488,
    "2017": 0.84458,
    "2018": 0.84421,
    "2019": 0.84397,
    "2020": 0.84375,
    "2021": 0.84346,
    "2022": 0.84316,
    "2023": 0.84288,
    "2024": 0.84261,
    "GeoAreaCode": 120,
    "GeoAreaName": "Cameroon"
  },
  {
    "2000": 0.97167,
    "2001": 0.97149,
    "2002": 0.97132,
    "2003": 0.97112,
    "2004": 0.9709,
    "2005": 0.97066,
    "2006": 0.9704,
    "2007": 0.97015,
    "2008": 0.96992,
    "2009": 0.96972,
    "2010": 0.96956,
    "2011": 0.9694,
    "2012": 0.96923,
    "2013": 0.96905,
    "2014": 0.96884,
    "2015": 0.96866,
    "2016": 0.96848,
    "2017": 0.96828,
    "2018": 0.96808,
    "2019": 0.96793,
    "2020": 0.96781,
    "2021": 0.96757,
    "2022": 0.96743,
    "2023": 0.96731,
    "2024": 0.96711,
    "GeoAreaCode": 124,
    "GeoAreaName": "Canada"
  },
  {
    "2000": 0.84113,
    "2001": 0.83999,
    "2002": 0.839,
    "2003": 0.83792,
    "2004": 0.83685,
    "2005": 0.83576,
    "2006": 0.83489,
    "2007": 0.83401,
    "2008": 0.8332,
    "2009": 0.8323,
    "2010": 0.83141,
    "2011": 0.83055,
    "2012": 0.82928,
    "2013": 0.82806,
    "2014": 0.82721,
    "2015": 0.82583,
    "2016": 0.82469,
    "2017": 0.82366,
    "2018": 0.82264,
    "2019": 0.82165,
    "2020": 0.82057,
    "2021": 0.81971,
    "2022": 0.81857,
    "2023": 0.81761,
    "2024": 0.81624,
    "GeoAreaCode": 136,
    "GeoAreaName": "Cayman Islands"
  },
  {
    "2000": 0.93763,
    "2001": 0.93753,
    "2002": 0.93746,
    "2003": 0.93743,
    "2004": 0.93734,
    "2005": 0.93727,
    "2006": 0.93729,
    "2007": 0.93719,
    "2008": 0.93725,
    "2009": 0.93713,
    "2010": 0.93708,
    "2011": 0.937,
    "2012": 0.93694,
    "2013": 0.93692,
    "2014": 0.9369,
    "2015": 0.9369,
    "2016": 0.9369,
    "2017": 0.93689,
    "2018": 0.9369,
    "2019": 0.93688,
    "2020": 0.93688,
    "2021": 0.93685,
    "2022": 0.93684,
    "2023": 0.93681,
    "2024": 0.93676,
    "GeoAreaCode": 140,
    "GeoAreaName": "Central African Republic"
  },
  {
    "2000": 0.75832,
    "2001": 0.75519,
    "2002": 0.75158,
    "2003": 0.74729,
    "2004": 0.74412,
    "2005": 0.7404,
    "2006": 0.73724,
    "2007": 0.73296,
    "2008": 0.72909,
    "2009": 0.72662,
    "2010": 0.7231,
    "2011": 0.71988,
    "2012": 0.71621,
    "2013": 0.71231,
    "2014": 0.70873,
    "2015": 0.70494,
    "2016": 0.70142,
    "2017": 0.69765,
    "2018": 0.69388,
    "2019": 0.69022,
    "2020": 0.68677,
    "2021": 0.68322,
    "2022": 0.67979,
    "2023": 0.67588,
    "2024": 0.67319,
    "GeoAreaCode": 62,
    "GeoAreaName": "Central and Southern Asia"
  },
  {
    "2000": 0.93239,
    "2001": 0.93043,
    "2002": 0.92851,
    "2003": 0.92672,
    "2004": 0.9254,
    "2005": 0.92451,
    "2006": 0.92385,
    "2007": 0.92343,
    "2008": 0.92307,
    "2009": 0.9227,
    "2010": 0.92234,
    "2011": 0.922,
    "2012": 0.92165,
    "2013": 0.92127,
    "2014": 0.92082,
    "2015": 0.92039,
    "2016": 0.9199,
    "2017": 0.91965,
    "2018": 0.91917,
    "2019": 0.91878,
    "2020": 0.91835,
    "2021": 0.91812,
    "2022": 0.91774,
    "2023": 0.91739,
    "2024": 0.91704,
    "GeoAreaCode": 143,
    "GeoAreaName": "Central Asia"
  },
  {
    "2000": 0.92041,
    "2001": 0.92009,
    "2002": 0.91973,
    "2003": 0.91935,
    "2004": 0.91889,
    "2005": 0.91853,
    "2006": 0.91817,
    "2007": 0.91772,
    "2008": 0.91715,
    "2009": 0.91679,
    "2010": 0.91631,
    "2011": 0.91589,
    "2012": 0.91555,
    "2013": 0.91524,
    "2014": 0.91493,
    "2015": 0.91471,
    "2016": 0.91444,
    "2017": 0.91422,
    "2018": 0.91402,
    "2019": 0.91366,
    "2020": 0.91342,
    "2021": 0.91321,
    "2022": 0.91294,
    "2023": 0.91274,
    "2024": 0.91257,
    "GeoAreaCode": 148,
    "GeoAreaName": "Chad"
  },
  {
    "2000": 0.83092,
    "2001": 0.82809,
    "2002": 0.82496,
    "2003": 0.8215,
    "2004": 0.81839,
    "2005": 0.8151,
    "2006": 0.81199,
    "2007": 0.80886,
    "2008": 0.80583,
    "2009": 0.80296,
    "2010": 0.80027,
    "2011": 0.7972,
    "2012": 0.79412,
    "2013": 0.79101,
    "2014": 0.7874,
    "2015": 0.7841,
    "2016": 0.78081,
    "2017": 0.77744,
    "2018": 0.77514,
    "2019": 0.77123,
    "2020": 0.7683,
    "2021": 0.76583,
    "2022": 0.76177,
    "2023": 0.75857,
    "2024": 0.7552,
    "GeoAreaCode": 152,
    "GeoAreaName": "Chile"
  },
  {
    "2000": 0.80206,
    "2001": 0.79879,
    "2002": 0.79543,
    "2003": 0.79235,
    "2004": 0.78858,
    "2005": 0.78564,
    "2006": 0.78222,
    "2007": 0.77871,
    "2008": 0.77588,
    "2009": 0.77252,
    "2010": 0.76956,
    "2011": 0.76695,
    "2012": 0.76331,
    "2013": 0.76023,
    "2014": 0.75662,
    "2015": 0.7532,
    "2016": 0.7506,
    "2017": 0.74716,
    "2018": 0.74403,
    "2019": 0.74062,
    "2020": 0.7372,
    "2021": 0.73364,
    "2022": 0.73105,
    "2023": 0.72795,
    "2024": 0.72383,
    "GeoAreaCode": 156,
    "GeoAreaName": "China"
  },
  {
    "2000": 0.89603,
    "2001": 0.89563,
    "2002": 0.89521,
    "2003": 0.89477,
    "2004": 0.89436,
    "2005": 0.89401,
    "2006": 0.89361,
    "2007": 0.89339,
    "2008": 0.89315,
    "2009": 0.8928,
    "2010": 0.8926,
    "2011": 0.89217,
    "2012": 0.89176,
    "2013": 0.8913,
    "2014": 0.89086,
    "2015": 0.89056,
    "2016": 0.89007,
    "2017": 0.88966,
    "2018": 0.88914,
    "2019": 0.88886,
    "2020": 0.88851,
    "2021": 0.88804,
    "2022": 0.8875,
    "2023": 0.88717,
    "2024": 0.88665,
    "GeoAreaCode": 344,
    "GeoAreaName": "China, Hong Kong Special Administrative Region"
  },
  {
    "2000": 0.84045,
    "2001": 0.83975,
    "2002": 0.83906,
    "2003": 0.83836,
    "2004": 0.83767,
    "2005": 0.83697,
    "2006": 0.83628,
    "2007": 0.83558,
    "2008": 0.83558,
    "2009": 0.83489,
    "2010": 0.83431,
    "2011": 0.83361,
    "2012": 0.83282,
    "2013": 0.83213,
    "2014": 0.83124,
    "2015": 0.83059,
    "2016": 0.8299,
    "2017": 0.82888,
    "2018": 0.82832,
    "2019": 0.82749,
    "2020": 0.82679,
    "2021": 0.82601,
    "2022": 0.82564,
    "2023": 0.82453,
    "2024": 0.82422,
    "GeoAreaCode": 446,
    "GeoAreaName": "China, Macao Special Administrative Region"
  },
  {
    "2000": 0.64524,
    "2001": 0.6388,
    "2002": 0.63498,
    "2003": 0.63211,
    "2004": 0.62895,
    "2005": 0.6217,
    "2006": 0.61439,
    "2007": 0.60573,
    "2008": 0.59673,
    "2009": 0.58881,
    "2010": 0.58048,
    "2011": 0.57184,
    "2012": 0.56246,
    "2013": 0.55335,
    "2014": 0.54393,
    "2015": 0.5353,
    "2016": 0.52545,
    "2017": 0.51495,
    "2018": 0.50775,
    "2019": 0.49992,
    "2020": 0.48762,
    "2021": 0.47987,
    "2022": 0.47051,
    "2023": 0.46333,
    "2024": 0.45233,
    "GeoAreaCode": 162,
    "GeoAreaName": "Christmas Island"
  },
  {
    "2000": 0.8413,
    "2001": 0.83739,
    "2002": 0.83498,
    "2003": 0.83128,
    "2004": 0.82817,
    "2005": 0.82472,
    "2006": 0.82144,
    "2007": 0.81793,
    "2008": 0.81485,
    "2009": 0.81161,
    "2010": 0.80833,
    "2011": 0.80547,
    "2012": 0.80217,
    "2013": 0.79816,
    "2014": 0.79404,
    "2015": 0.79075,
    "2016": 0.78724,
    "2017": 0.78404,
    "2018": 0.78019,
    "2019": 0.77674,
    "2020": 0.77369,
    "2021": 0.77004,
    "2022": 0.76668,
    "2023": 0.76347,
    "2024": 0.7589,
    "GeoAreaCode": 166,
    "GeoAreaName": "Cocos (Keeling) Islands"
  },
  {
    "2000": 0.76388,
    "2001": 0.76252,
    "2002": 0.76112,
    "2003": 0.75971,
    "2004": 0.75853,
    "2005": 0.75736,
    "2006": 0.75616,
    "2007": 0.75517,
    "2008": 0.75393,
    "2009": 0.75283,
    "2010": 0.75189,
    "2011": 0.75066,
    "2012": 0.74951,
    "2013": 0.74851,
    "2014": 0.74729,
    "2015": 0.74602,
    "2016": 0.74492,
    "2017": 0.74369,
    "2018": 0.74254,
    "2019": 0.74155,
    "2020": 0.74026,
    "2021": 0.739,
    "2022": 0.73786,
    "2023": 0.7365,
    "2024": 0.7359,
    "GeoAreaCode": 170,
    "GeoAreaName": "Colombia"
  },
  {
    "2000": 0.8249,
    "2001": 0.82023,
    "2002": 0.81638,
    "2003": 0.81184,
    "2004": 0.80779,
    "2005": 0.80352,
    "2006": 0.80077,
    "2007": 0.79676,
    "2008": 0.7931,
    "2009": 0.78872,
    "2010": 0.78565,
    "2011": 0.78071,
    "2012": 0.77748,
    "2013": 0.77367,
    "2014": 0.76737,
    "2015": 0.76383,
    "2016": 0.75763,
    "2017": 0.75431,
    "2018": 0.7487,
    "2019": 0.7452,
    "2020": 0.74126,
    "2021": 0.73651,
    "2022": 0.73023,
    "2023": 0.72806,
    "2024": 0.72311,
    "GeoAreaCode": 174,
    "GeoAreaName": "Comoros"
  },
  {
    "2000": 0.96765,
    "2001": 0.96756,
    "2002": 0.96755,
    "2003": 0.96745,
    "2004": 0.96744,
    "2005": 0.96746,
    "2006": 0.96752,
    "2007": 0.96748,
    "2008": 0.96743,
    "2009": 0.96745,
    "2010": 0.96736,
    "2011": 0.96733,
    "2012": 0.96724,
    "2013": 0.96716,
    "2014": 0.96711,
    "2015": 0.96702,
    "2016": 0.96711,
    "2017": 0.96711,
    "2018": 0.96707,
    "2019": 0.96706,
    "2020": 0.9671,
    "2021": 0.96693,
    "2022": 0.96693,
    "2023": 0.96684,
    "2024": 0.96675,
    "GeoAreaCode": 178,
    "GeoAreaName": "Congo"
  },
  {
    "2000": 0.8244,
    "2001": 0.82375,
    "2002": 0.8231,
    "2003": 0.82253,
    "2004": 0.82241,
    "2005": 0.82189,
    "2006": 0.82183,
    "2007": 0.82202,
    "2008": 0.82066,
    "2009": 0.81932,
    "2010": 0.81734,
    "2011": 0.81505,
    "2012": 0.81293,
    "2013": 0.81099,
    "2014": 0.8085,
    "2015": 0.80649,
    "2016": 0.80397,
    "2017": 0.80146,
    "2018": 0.79877,
    "2019": 0.79696,
    "2020": 0.79511,
    "2021": 0.79271,
    "2022": 0.79117,
    "2023": 0.78751,
    "2024": 0.78522,
    "GeoAreaCode": 184,
    "GeoAreaName": "Cook Islands"
  },
  {
    "2000": 0.86504,
    "2001": 0.86323,
    "2002": 0.86178,
    "2003": 0.86041,
    "2004": 0.8594,
    "2005": 0.85829,
    "2006": 0.85737,
    "2007": 0.85671,
    "2008": 0.85614,
    "2009": 0.85545,
    "2010": 0.85499,
    "2011": 0.85421,
    "2012": 0.85314,
    "2013": 0.85263,
    "2014": 0.85177,
    "2015": 0.851,
    "2016": 0.85,
    "2017": 0.84902,
    "2018": 0.84827,
    "2019": 0.84712,
    "2020": 0.84667,
    "2021": 0.84576,
    "2022": 0.84458,
    "2023": 0.84379,
    "2024": 0.84311,
    "GeoAreaCode": 188,
    "GeoAreaName": "Costa Rica"
  },
  {
    "2000": 0.91096,
    "2001": 0.91086,
    "2002": 0.91084,
    "2003": 0.91072,
    "2004": 0.9107,
    "2005": 0.91061,
    "2006": 0.91052,
    "2007": 0.91045,
    "2008": 0.91028,
    "2009": 0.91024,
    "2010": 0.91022,
    "2011": 0.9101,
    "2012": 0.91009,
    "2013": 0.9101,
    "2014": 0.91003,
    "2015": 0.91008,
    "2016": 0.91007,
    "2017": 0.91004,
    "2018": 0.9099,
    "2019": 0.90988,
    "2020": 0.90981,
    "2021": 0.9098,
    "2022": 0.90972,
    "2023": 0.90975,
    "2024": 0.90977,
    "GeoAreaCode": 384,
    "GeoAreaName": "Côte d'Ivoire"
  },
  {
    "2000": 0.89852,
    "2001": 0.89819,
    "2002": 0.8979,
    "2003": 0.89751,
    "2004": 0.89726,
    "2005": 0.89679,
    "2006": 0.89633,
    "2007": 0.89587,
    "2008": 0.89544,
    "2009": 0.89495,
    "2010": 0.89447,
    "2011": 0.894,
    "2012": 0.89354,
    "2013": 0.89311,
    "2014": 0.8927,
    "2015": 0.89229,
    "2016": 0.89178,
    "2017": 0.89126,
    "2018": 0.8906,
    "2019": 0.89005,
    "2020": 0.88949,
    "2021": 0.88898,
    "2022": 0.88848,
    "2023": 0.88821,
    "2024": 0.88783,
    "GeoAreaCode": 191,
    "GeoAreaName": "Croatia"
  },
  {
    "2000": 0.70523,
    "2001": 0.70405,
    "2002": 0.70286,
    "2003": 0.70162,
    "2004": 0.70045,
    "2005": 0.69924,
    "2006": 0.69819,
    "2007": 0.69672,
    "2008": 0.69536,
    "2009": 0.69414,
    "2010": 0.69273,
    "2011": 0.6915,
    "2012": 0.69006,
    "2013": 0.68892,
    "2014": 0.6879,
    "2015": 0.6865,
    "2016": 0.68518,
    "2017": 0.68411,
    "2018": 0.68293,
    "2019": 0.68175,
    "2020": 0.68045,
    "2021": 0.67935,
    "2022": 0.67821,
    "2023": 0.6772,
    "2024": 0.67562,
    "GeoAreaCode": 192,
    "GeoAreaName": "Cuba"
  },
  {
    "2000": 0.91743,
    "2001": 0.916,
    "2002": 0.91492,
    "2003": 0.91325,
    "2004": 0.91218,
    "2005": 0.91081,
    "2006": 0.91002,
    "2007": 0.90887,
    "2008": 0.90833,
    "2009": 0.90719,
    "2010": 0.90627,
    "2011": 0.90461,
    "2012": 0.90382,
    "2013": 0.90228,
    "2014": 0.90111,
    "2015": 0.89975,
    "2016": 0.89848,
    "2017": 0.89699,
    "2018": 0.89574,
    "2019": 0.8941,
    "2020": 0.89311,
    "2021": 0.89197,
    "2022": 0.89046,
    "2023": 0.88923,
    "2024": 0.88803,
    "GeoAreaCode": 531,
    "GeoAreaName": "Curaçao"
  },
  {
    "2000": 0.91426,
    "2001": 0.91427,
    "2002": 0.91433,
    "2003": 0.91442,
    "2004": 0.9145,
    "2005": 0.91452,
    "2006": 0.91453,
    "2007": 0.91454,
    "2008": 0.91454,
    "2009": 0.91453,
    "2010": 0.91452,
    "2011": 0.91453,
    "2012": 0.91455,
    "2013": 0.91551,
    "2014": 0.91654,
    "2015": 0.91756,
    "2016": 0.9183,
    "2017": 0.9183,
    "2018": 0.91832,
    "2019": 0.91819,
    "2020": 0.91809,
    "2021": 0.91806,
    "2022": 0.91805,
    "2023": 0.91806,
    "2024": 0.91806,
    "GeoAreaCode": 196,
    "GeoAreaName": "Cyprus"
  },
  {
    "2000": 0.97769,
    "2001": 0.97765,
    "2002": 0.97762,
    "2003": 0.97762,
    "2004": 0.97762,
    "2005": 0.97714,
    "2006": 0.97655,
    "2007": 0.97594,
    "2008": 0.97535,
    "2009": 0.97478,
    "2010": 0.97412,
    "2011": 0.97365,
    "2012": 0.97338,
    "2013": 0.97302,
    "2014": 0.9729,
    "2015": 0.97268,
    "2016": 0.97243,
    "2017": 0.97201,
    "2018": 0.97148,
    "2019": 0.97095,
    "2020": 0.97019,
    "2021": 0.96957,
    "2022": 0.96899,
    "2023": 0.96853,
    "2024": 0.96806,
    "GeoAreaCode": 203,
    "GeoAreaName": "Czechia"
  },
  {
    "2000": 0.91803,
    "2001": 0.91682,
    "2002": 0.91557,
    "2003": 0.91447,
    "2004": 0.91398,
    "2005": 0.91352,
    "2006": 0.91272,
    "2007": 0.91243,
    "2008": 0.91175,
    "2009": 0.91131,
    "2010": 0.91078,
    "2011": 0.9104,
    "2012": 0.90985,
    "2013": 0.90906,
    "2014": 0.9089,
    "2015": 0.90802,
    "2016": 0.90723,
    "2017": 0.90677,
    "2018": 0.9062,
    "2019": 0.90559,
    "2020": 0.90486,
    "2021": 0.9041,
    "2022": 0.90357,
    "2023": 0.90324,
    "2024": 0.90194,
    "GeoAreaCode": 408,
    "GeoAreaName": "Democratic People's Republic of Korea"
  },
  {
    "2000": 0.88363,
    "2001": 0.88362,
    "2002": 0.88362,
    "2003": 0.88362,
    "2004": 0.88356,
    "2005": 0.8835,
    "2006": 0.88346,
    "2007": 0.88343,
    "2008": 0.88338,
    "2009": 0.88335,
    "2010": 0.88322,
    "2011": 0.88325,
    "2012": 0.88319,
    "2013": 0.88315,
    "2014": 0.8832,
    "2015": 0.88317,
    "2016": 0.88314,
    "2017": 0.88316,
    "2018": 0.88314,
    "2019": 0.88308,
    "2020": 0.88303,
    "2021": 0.88305,
    "2022": 0.88306,
    "2023": 0.88293,
    "2024": 0.883,
    "GeoAreaCode": 180,
    "GeoAreaName": "Congo, Democratic Republic of"
  },
  {
    "2000": 0.98027,
    "2001": 0.97997,
    "2002": 0.97969,
    "2003": 0.97946,
    "2004": 0.97948,
    "2005": 0.97947,
    "2006": 0.97956,
    "2007": 0.9796,
    "2008": 0.97963,
    "2009": 0.97963,
    "2010": 0.97964,
    "2011": 0.97971,
    "2012": 0.97977,
    "2013": 0.97992,
    "2014": 0.98013,
    "2015": 0.98039,
    "2016": 0.98056,
    "2017": 0.98069,
    "2018": 0.98076,
    "2019": 0.98078,
    "2020": 0.98082,
    "2021": 0.98084,
    "2022": 0.98088,
    "2023": 0.98095,
    "2024": 0.98097,
    "GeoAreaCode": 208,
    "GeoAreaName": "Denmark"
  },
  {
    "2000": 0.8737,
    "2001": 0.87076,
    "2002": 0.86806,
    "2003": 0.86564,
    "2004": 0.86287,
    "2005": 0.86053,
    "2006": 0.85776,
    "2007": 0.85558,
    "2008": 0.8536,
    "2009": 0.85147,
    "2010": 0.8494,
    "2011": 0.84673,
    "2012": 0.84372,
    "2013": 0.8412,
    "2014": 0.83887,
    "2015": 0.83568,
    "2016": 0.83262,
    "2017": 0.83055,
    "2018": 0.82753,
    "2019": 0.82578,
    "2020": 0.82275,
    "2021": 0.81912,
    "2022": 0.81742,
    "2023": 0.81473,
    "2024": 0.81195,
    "GeoAreaCode": 262,
    "GeoAreaName": "Djibouti"
  },
  {
    "2000": 0.72519,
    "2001": 0.72331,
    "2002": 0.72147,
    "2003": 0.71976,
    "2004": 0.71833,
    "2005": 0.71688,
    "2006": 0.71576,
    "2007": 0.71477,
    "2008": 0.71378,
    "2009": 0.71284,
    "2010": 0.71196,
    "2011": 0.71103,
    "2012": 0.70977,
    "2013": 0.70889,
    "2014": 0.70789,
    "2015": 0.70655,
    "2016": 0.70478,
    "2017": 0.70265,
    "2018": 0.70052,
    "2019": 0.69801,
    "2020": 0.69643,
    "2021": 0.69429,
    "2022": 0.69328,
    "2023": 0.69213,
    "2024": 0.69112,
    "GeoAreaCode": 212,
    "GeoAreaName": "Dominica"
  },
  {
    "2000": 0.75674,
    "2001": 0.75543,
    "2002": 0.75413,
    "2003": 0.7528,
    "2004": 0.75144,
    "2005": 0.75043,
    "2006": 0.74926,
    "2007": 0.74792,
    "2008": 0.74702,
    "2009": 0.74595,
    "2010": 0.74465,
    "2011": 0.74386,
    "2012": 0.74257,
    "2013": 0.74143,
    "2014": 0.74013,
    "2015": 0.7394,
    "2016": 0.73789,
    "2017": 0.73697,
    "2018": 0.73575,
    "2019": 0.7346,
    "2020": 0.73359,
    "2021": 0.7322,
    "2022": 0.73122,
    "2023": 0.73014,
    "2024": 0.72873,
    "GeoAreaCode": 214,
    "GeoAreaName": "Dominican Republic"
  },
  {
    "2000": 0.80046,
    "2001": 0.79667,
    "2002": 0.79167,
    "2003": 0.78814,
    "2004": 0.78395,
    "2005": 0.77984,
    "2006": 0.77578,
    "2007": 0.77183,
    "2008": 0.76776,
    "2009": 0.76502,
    "2010": 0.76102,
    "2011": 0.75745,
    "2012": 0.753,
    "2013": 0.74855,
    "2014": 0.74433,
    "2015": 0.73988,
    "2016": 0.73546,
    "2017": 0.73107,
    "2018": 0.72727,
    "2019": 0.72305,
    "2020": 0.71858,
    "2021": 0.71508,
    "2022": 0.7106,
    "2023": 0.70711,
    "2024": 0.70258,
    "GeoAreaCode": 753,
    "GeoAreaName": "Eastern and South-Eastern Asia"
  },
  {
    "2000": 0.79651,
    "2001": 0.79266,
    "2002": 0.78917,
    "2003": 0.78569,
    "2004": 0.78229,
    "2005": 0.77844,
    "2006": 0.77479,
    "2007": 0.77095,
    "2008": 0.7673,
    "2009": 0.76465,
    "2010": 0.76153,
    "2011": 0.75796,
    "2012": 0.75441,
    "2013": 0.75059,
    "2014": 0.74711,
    "2015": 0.74307,
    "2016": 0.7395,
    "2017": 0.73528,
    "2018": 0.73178,
    "2019": 0.72824,
    "2020": 0.72468,
    "2021": 0.72033,
    "2022": 0.71686,
    "2023": 0.71287,
    "2024": 0.71011,
    "GeoAreaCode": 30,
    "GeoAreaName": "Eastern Asia"
  },
  {
    "2000": 0.76207,
    "2001": 0.75706,
    "2002": 0.75205,
    "2003": 0.74685,
    "2004": 0.74231,
    "2005": 0.73722,
    "2006": 0.73242,
    "2007": 0.72771,
    "2008": 0.72334,
    "2009": 0.71866,
    "2010": 0.71432,
    "2011": 0.71007,
    "2012": 0.7052,
    "2013": 0.70061,
    "2014": 0.6955,
    "2015": 0.69138,
    "2016": 0.68613,
    "2017": 0.68135,
    "2018": 0.67723,
    "2019": 0.67203,
    "2020": 0.66694,
    "2021": 0.66286,
    "2022": 0.65856,
    "2023": 0.65321,
    "2024": 0.64866,
    "GeoAreaCode": 218,
    "GeoAreaName": "Ecuador"
  },
  {
    "2000": 0.96102,
    "2001": 0.9585,
    "2002": 0.95555,
    "2003": 0.95305,
    "2004": 0.95065,
    "2005": 0.948,
    "2006": 0.94543,
    "2007": 0.9431,
    "2008": 0.94096,
    "2009": 0.93845,
    "2010": 0.93616,
    "2011": 0.9337,
    "2012": 0.93114,
    "2013": 0.92875,
    "2014": 0.92722,
    "2015": 0.92411,
    "2016": 0.922,
    "2017": 0.91943,
    "2018": 0.91757,
    "2019": 0.91514,
    "2020": 0.91269,
    "2021": 0.9109,
    "2022": 0.90743,
    "2023": 0.90492,
    "2024": 0.90336,
    "GeoAreaCode": 818,
    "GeoAreaName": "Egypt"
  },
  {
    "2000": 0.83928,
    "2001": 0.83785,
    "2002": 0.8362,
    "2003": 0.83485,
    "2004": 0.83337,
    "2005": 0.83174,
    "2006": 0.83037,
    "2007": 0.82891,
    "2008": 0.82756,
    "2009": 0.82634,
    "2010": 0.82525,
    "2011": 0.82388,
    "2012": 0.82251,
    "2013": 0.82108,
    "2014": 0.81988,
    "2015": 0.81814,
    "2016": 0.81706,
    "2017": 0.8156,
    "2018": 0.8142,
    "2019": 0.81282,
    "2020": 0.81136,
    "2021": 0.81014,
    "2022": 0.80887,
    "2023": 0.8076,
    "2024": 0.80584,
    "GeoAreaCode": 222,
    "GeoAreaName": "El Salvador"
  },
  {
    "2000": 0.81595,
    "2001": 0.81577,
    "2002": 0.81568,
    "2003": 0.81558,
    "2004": 0.81553,
    "2005": 0.81546,
    "2006": 0.81545,
    "2007": 0.8154,
    "2008": 0.8154,
    "2009": 0.8154,
    "2010": 0.81537,
    "2011": 0.81533,
    "2012": 0.81529,
    "2013": 0.81524,
    "2014": 0.8152,
    "2015": 0.81514,
    "2016": 0.8151,
    "2017": 0.81505,
    "2018": 0.81504,
    "2019": 0.81499,
    "2020": 0.81504,
    "2021": 0.81503,
    "2022": 0.81508,
    "2023": 0.81508,
    "2024": 0.81511,
    "GeoAreaCode": 226,
    "GeoAreaName": "Equatorial Guinea"
  },
  {
    "2000": 0.94087,
    "2001": 0.93814,
    "2002": 0.93588,
    "2003": 0.93309,
    "2004": 0.93066,
    "2005": 0.92755,
    "2006": 0.92537,
    "2007": 0.92271,
    "2008": 0.92043,
    "2009": 0.9181,
    "2010": 0.916,
    "2011": 0.91349,
    "2012": 0.91071,
    "2013": 0.90807,
    "2014": 0.90595,
    "2015": 0.90355,
    "2016": 0.90121,
    "2017": 0.89853,
    "2018": 0.89521,
    "2019": 0.89385,
    "2020": 0.89083,
    "2021": 0.889,
    "2022": 0.88579,
    "2023": 0.88472,
    "2024": 0.88104,
    "GeoAreaCode": 232,
    "GeoAreaName": "Eritrea"
  },
  {
    "2000": 0.98626,
    "2001": 0.98613,
    "2002": 0.98601,
    "2003": 0.98588,
    "2004": 0.98576,
    "2005": 0.98559,
    "2006": 0.98542,
    "2007": 0.98526,
    "2008": 0.98509,
    "2009": 0.98494,
    "2010": 0.9848,
    "2011": 0.98471,
    "2012": 0.98471,
    "2013": 0.98471,
    "2014": 0.9849,
    "2015": 0.98509,
    "2016": 0.98522,
    "2017": 0.98522,
    "2018": 0.98522,
    "2019": 0.98519,
    "2020": 0.98516,
    "2021": 0.98516,
    "2022": 0.98516,
    "2023": 0.98516,
    "2024": 0.98516,
    "GeoAreaCode": 233,
    "GeoAreaName": "Estonia"
  },
  {
    "2000": 0.81427,
    "2001": 0.81424,
    "2002": 0.81422,
    "2003": 0.81419,
    "2004": 0.81416,
    "2005": 0.81412,
    "2006": 0.81407,
    "2007": 0.81404,
    "2008": 0.81399,
    "2009": 0.81394,
    "2010": 0.81389,
    "2011": 0.81385,
    "2012": 0.81382,
    "2013": 0.8138,
    "2014": 0.81378,
    "2015": 0.81376,
    "2016": 0.81375,
    "2017": 0.81373,
    "2018": 0.81372,
    "2019": 0.81371,
    "2020": 0.8137,
    "2021": 0.81368,
    "2022": 0.81367,
    "2023": 0.81366,
    "2024": 0.81365,
    "GeoAreaCode": 748,
    "GeoAreaName": "Eswatini"
  },
  {
    "2000": 0.85105,
    "2001": 0.85093,
    "2002": 0.8505,
    "2003": 0.85018,
    "2004": 0.84989,
    "2005": 0.84956,
    "2006": 0.84909,
    "2007": 0.8488,
    "2008": 0.84862,
    "2009": 0.84826,
    "2010": 0.84806,
    "2011": 0.84784,
    "2012": 0.84745,
    "2013": 0.84748,
    "2014": 0.84728,
    "2015": 0.84701,
    "2016": 0.84696,
    "2017": 0.8468,
    "2018": 0.84653,
    "2019": 0.84663,
    "2020": 0.84652,
    "2021": 0.84627,
    "2022": 0.84609,
    "2023": 0.84608,
    "2024": 0.84578,
    "GeoAreaCode": 231,
    "GeoAreaName": "Ethiopia"
  },
  {
    "2000": 0.91383,
    "2001": 0.91078,
    "2002": 0.90765,
    "2003": 0.90443,
    "2004": 0.90089,
    "2005": 0.89738,
    "2006": 0.89355,
    "2007": 0.88994,
    "2008": 0.88612,
    "2009": 0.88262,
    "2010": 0.87942,
    "2011": 0.87514,
    "2012": 0.87118,
    "2013": 0.86787,
    "2014": 0.86418,
    "2015": 0.85993,
    "2016": 0.85696,
    "2017": 0.85278,
    "2018": 0.84923,
    "2019": 0.84587,
    "2020": 0.84238,
    "2021": 0.8377,
    "2022": 0.83522,
    "2023": 0.83156,
    "2024": 0.82699,
    "GeoAreaCode": 150,
    "GeoAreaName": "Europe"
  },
  {
    "2000": 0.86809,
    "2001": 0.86663,
    "2002": 0.8652,
    "2003": 0.86369,
    "2004": 0.86203,
    "2005": 0.86038,
    "2006": 0.85897,
    "2007": 0.85738,
    "2008": 0.85547,
    "2009": 0.85401,
    "2010": 0.85257,
    "2011": 0.85095,
    "2012": 0.84955,
    "2013": 0.84818,
    "2014": 0.84675,
    "2015": 0.84526,
    "2016": 0.84373,
    "2017": 0.8421,
    "2018": 0.84038,
    "2019": 0.839,
    "2020": 0.83779,
    "2021": 0.83623,
    "2022": 0.83466,
    "2023": 0.83298,
    "2024": 0.83163,
    "GeoAreaCode": 513,
    "GeoAreaName": "Europe and Northern America"
  },
  {
    "2000": 0.72377,
    "2001": 0.72375,
    "2002": 0.72399,
    "2003": 0.72462,
    "2004": 0.72619,
    "2005": 0.72817,
    "2006": 0.73153,
    "2007": 0.73401,
    "2008": 0.73668,
    "2009": 0.73856,
    "2010": 0.73944,
    "2011": 0.73952,
    "2012": 0.73962,
    "2013": 0.73963,
    "2014": 0.73978,
    "2015": 0.73997,
    "2016": 0.73993,
    "2017": 0.7402,
    "2018": 0.74027,
    "2019": 0.74029,
    "2020": 0.74033,
    "2021": 0.74048,
    "2022": 0.7405,
    "2023": 0.74048,
    "2024": 0.74054,
    "GeoAreaCode": 238,
    "GeoAreaName": "Falkland Islands (Malvinas)"
  },
  {
    "2000": 0.8667,
    "2001": 0.86568,
    "2002": 0.86519,
    "2003": 0.86612,
    "2004": 0.86586,
    "2005": 0.86614,
    "2006": 0.8666,
    "2007": 0.86703,
    "2008": 0.86771,
    "2009": 0.86761,
    "2010": 0.86804,
    "2011": 0.86995,
    "2012": 0.8717,
    "2013": 0.8723,
    "2014": 0.87287,
    "2015": 0.87353,
    "2016": 0.8729,
    "2017": 0.87332,
    "2018": 0.8747,
    "2019": 0.87475,
    "2020": 0.87606,
    "2021": 0.87611,
    "2022": 0.87655,
    "2023": 0.87676,
    "2024": 0.87679,
    "GeoAreaCode": 234,
    "GeoAreaName": "Faroe Islands"
  },
  {
    "2000": 0.73701,
    "2001": 0.73518,
    "2002": 0.7334,
    "2003": 0.73099,
    "2004": 0.72937,
    "2005": 0.72776,
    "2006": 0.7259,
    "2007": 0.72364,
    "2008": 0.7222,
    "2009": 0.72103,
    "2010": 0.71921,
    "2011": 0.71729,
    "2012": 0.71572,
    "2013": 0.71265,
    "2014": 0.71085,
    "2015": 0.70918,
    "2016": 0.70728,
    "2017": 0.70523,
    "2018": 0.70342,
    "2019": 0.70128,
    "2020": 0.69901,
    "2021": 0.69731,
    "2022": 0.69573,
    "2023": 0.69282,
    "2024": 0.69189,
    "GeoAreaCode": 242,
    "GeoAreaName": "Fiji"
  },
  {
    "2000": 0.99141,
    "2001": 0.99139,
    "2002": 0.99137,
    "2003": 0.99134,
    "2004": 0.99132,
    "2005": 0.99121,
    "2006": 0.9911,
    "2007": 0.99099,
    "2008": 0.99088,
    "2009": 0.99078,
    "2010": 0.99068,
    "2011": 0.99058,
    "2012": 0.99058,
    "2013": 0.99058,
    "2014": 0.99068,
    "2015": 0.99078,
    "2016": 0.99082,
    "2017": 0.99082,
    "2018": 0.99082,
    "2019": 0.99079,
    "2020": 0.99076,
    "2021": 0.99076,
    "2022": 0.99076,
    "2023": 0.99076,
    "2024": 0.99076,
    "GeoAreaCode": 246,
    "GeoAreaName": "Finland"
  },
  {
    "2000": 0.94732,
    "2001": 0.94337,
    "2002": 0.93957,
    "2003": 0.93515,
    "2004": 0.93042,
    "2005": 0.92406,
    "2006": 0.91796,
    "2007": 0.91135,
    "2008": 0.90601,
    "2009": 0.90132,
    "2010": 0.89666,
    "2011": 0.89217,
    "2012": 0.88778,
    "2013": 0.88398,
    "2014": 0.87936,
    "2015": 0.87541,
    "2016": 0.87029,
    "2017": 0.86581,
    "2018": 0.86105,
    "2019": 0.85524,
    "2020": 0.8511,
    "2021": 0.84679,
    "2022": 0.84309,
    "2023": 0.83774,
    "2024": 0.83407,
    "GeoAreaCode": 250,
    "GeoAreaName": "France"
  },
  {
    "2000": 0.97961,
    "2001": 0.9792,
    "2002": 0.97881,
    "2003": 0.97845,
    "2004": 0.9774,
    "2005": 0.97606,
    "2006": 0.97431,
    "2007": 0.97223,
    "2008": 0.97018,
    "2009": 0.96833,
    "2010": 0.96618,
    "2011": 0.96422,
    "2012": 0.96195,
    "2013": 0.9601,
    "2014": 0.95817,
    "2015": 0.95596,
    "2016": 0.95387,
    "2017": 0.95186,
    "2018": 0.94998,
    "2019": 0.94793,
    "2020": 0.94619,
    "2021": 0.94432,
    "2022": 0.94228,
    "2023": 0.94073,
    "2024": 0.93896,
    "GeoAreaCode": 254,
    "GeoAreaName": "French Guiana"
  },
  {
    "2000": 0.75118,
    "2001": 0.74897,
    "2002": 0.7468,
    "2003": 0.74515,
    "2004": 0.74285,
    "2005": 0.74101,
    "2006": 0.73849,
    "2007": 0.73642,
    "2008": 0.73493,
    "2009": 0.7327,
    "2010": 0.73055,
    "2011": 0.72826,
    "2012": 0.72567,
    "2013": 0.72393,
    "2014": 0.72156,
    "2015": 0.71913,
    "2016": 0.71695,
    "2017": 0.71399,
    "2018": 0.71205,
    "2019": 0.70991,
    "2020": 0.70794,
    "2021": 0.70552,
    "2022": 0.70375,
    "2023": 0.69978,
    "2024": 0.69899,
    "GeoAreaCode": 258,
    "GeoAreaName": "French Polynesia"
  },
  {
    "2000": 0.87911,
    "2001": 0.87673,
    "2002": 0.87484,
    "2003": 0.87249,
    "2004": 0.87022,
    "2005": 0.86798,
    "2006": 0.86596,
    "2007": 0.86457,
    "2008": 0.86227,
    "2009": 0.86054,
    "2010": 0.85861,
    "2011": 0.85643,
    "2012": 0.8542,
    "2013": 0.85124,
    "2014": 0.8493,
    "2015": 0.84689,
    "2016": 0.84445,
    "2017": 0.84198,
    "2018": 0.83943,
    "2019": 0.83762,
    "2020": 0.83529,
    "2021": 0.83276,
    "2022": 0.83121,
    "2023": 0.8279,
    "2024": 0.82523,
    "GeoAreaCode": 260,
    "GeoAreaName": "French Southern Territories"
  },
  {
    "2000": 0.95454,
    "2001": 0.95429,
    "2002": 0.95426,
    "2003": 0.95416,
    "2004": 0.95415,
    "2005": 0.95413,
    "2006": 0.95409,
    "2007": 0.95407,
    "2008": 0.95394,
    "2009": 0.95382,
    "2010": 0.95375,
    "2011": 0.95367,
    "2012": 0.9536,
    "2013": 0.95358,
    "2014": 0.95358,
    "2015": 0.95359,
    "2016": 0.9536,
    "2017": 0.95354,
    "2018": 0.9535,
    "2019": 0.95348,
    "2020": 0.95351,
    "2021": 0.95346,
    "2022": 0.95342,
    "2023": 0.95343,
    "2024": 0.95341,
    "GeoAreaCode": 266,
    "GeoAreaName": "Gabon"
  },
  {
    "2000": 0.96179,
    "2001": 0.96177,
    "2002": 0.96176,
    "2003": 0.96171,
    "2004": 0.96165,
    "2005": 0.96159,
    "2006": 0.96152,
    "2007": 0.96144,
    "2008": 0.96139,
    "2009": 0.96133,
    "2010": 0.96128,
    "2011": 0.96123,
    "2012": 0.96119,
    "2013": 0.96117,
    "2014": 0.96114,
    "2015": 0.96111,
    "2016": 0.96108,
    "2017": 0.96106,
    "2018": 0.96103,
    "2019": 0.96101,
    "2020": 0.961,
    "2021": 0.96098,
    "2022": 0.96097,
    "2023": 0.96097,
    "2024": 0.96097,
    "GeoAreaCode": 270,
    "GeoAreaName": "Gambia"
  },
  {
    "2000": 0.95925,
    "2001": 0.95893,
    "2002": 0.95864,
    "2003": 0.95823,
    "2004": 0.95691,
    "2005": 0.95418,
    "2006": 0.94971,
    "2007": 0.94508,
    "2008": 0.94272,
    "2009": 0.94148,
    "2010": 0.93994,
    "2011": 0.93908,
    "2012": 0.93816,
    "2013": 0.93724,
    "2014": 0.93625,
    "2015": 0.93542,
    "2016": 0.93456,
    "2017": 0.93382,
    "2018": 0.93278,
    "2019": 0.93191,
    "2020": 0.93096,
    "2021": 0.9302,
    "2022": 0.92932,
    "2023": 0.92856,
    "2024": 0.92782,
    "GeoAreaCode": 268,
    "GeoAreaName": "Georgia"
  },
  {
    "2000": 0.98216,
    "2001": 0.98204,
    "2002": 0.98194,
    "2003": 0.98172,
    "2004": 0.98164,
    "2005": 0.98126,
    "2006": 0.9807,
    "2007": 0.98021,
    "2008": 0.97972,
    "2009": 0.97922,
    "2010": 0.97874,
    "2011": 0.97831,
    "2012": 0.97806,
    "2013": 0.97785,
    "2014": 0.9778,
    "2015": 0.97769,
    "2016": 0.97753,
    "2017": 0.97719,
    "2018": 0.97678,
    "2019": 0.97633,
    "2020": 0.9758,
    "2021": 0.97524,
    "2022": 0.9749,
    "2023": 0.97441,
    "2024": 0.97399,
    "GeoAreaCode": 276,
    "GeoAreaName": "Germany"
  },
  {
    "2000": 0.83875,
    "2001": 0.8387,
    "2002": 0.83881,
    "2003": 0.83869,
    "2004": 0.83846,
    "2005": 0.83821,
    "2006": 0.83792,
    "2007": 0.83739,
    "2008": 0.83701,
    "2009": 0.83658,
    "2010": 0.83634,
    "2011": 0.83597,
    "2012": 0.8357,
    "2013": 0.83541,
    "2014": 0.8351,
    "2015": 0.83477,
    "2016": 0.8344,
    "2017": 0.83421,
    "2018": 0.83386,
    "2019": 0.83343,
    "2020": 0.83316,
    "2021": 0.83281,
    "2022": 0.8326,
    "2023": 0.83232,
    "2024": 0.83204,
    "GeoAreaCode": 288,
    "GeoAreaName": "Ghana"
  },
  {
    "2000": 0.94383,
    "2001": 0.94248,
    "2002": 0.94136,
    "2003": 0.94052,
    "2004": 0.93973,
    "2005": 0.93965,
    "2006": 0.93955,
    "2007": 0.93942,
    "2008": 0.93931,
    "2009": 0.93919,
    "2010": 0.93909,
    "2011": 0.93897,
    "2012": 0.9385,
    "2013": 0.93726,
    "2014": 0.93583,
    "2015": 0.93424,
    "2016": 0.93272,
    "2017": 0.93128,
    "2018": 0.93011,
    "2019": 0.92864,
    "2020": 0.92763,
    "2021": 0.92736,
    "2022": 0.92725,
    "2023": 0.92718,
    "2024": 0.92711,
    "GeoAreaCode": 292,
    "GeoAreaName": "Gibraltar"
  },
  {
    "2000": 0.87069,
    "2001": 0.87074,
    "2002": 0.87086,
    "2003": 0.87122,
    "2004": 0.87142,
    "2005": 0.87156,
    "2006": 0.87172,
    "2007": 0.87169,
    "2008": 0.87178,
    "2009": 0.87188,
    "2010": 0.87205,
    "2011": 0.87176,
    "2012": 0.87142,
    "2013": 0.87093,
    "2014": 0.8703,
    "2015": 0.86971,
    "2016": 0.86903,
    "2017": 0.86842,
    "2018": 0.86771,
    "2019": 0.86708,
    "2020": 0.86669,
    "2021": 0.86655,
    "2022": 0.86629,
    "2023": 0.86619,
    "2024": 0.86605,
    "GeoAreaCode": 300,
    "GeoAreaName": "Greece"
  },
  {
    "2000": 0.93696,
    "2001": 0.93583,
    "2002": 0.93446,
    "2003": 0.933,
    "2004": 0.93185,
    "2005": 0.93059,
    "2006": 0.92948,
    "2007": 0.92854,
    "2008": 0.92781,
    "2009": 0.92696,
    "2010": 0.92617,
    "2011": 0.92479,
    "2012": 0.92274,
    "2013": 0.91989,
    "2014": 0.91694,
    "2015": 0.91445,
    "2016": 0.91253,
    "2017": 0.91064,
    "2018": 0.90934,
    "2019": 0.90884,
    "2020": 0.9081,
    "2021": 0.90727,
    "2022": 0.90653,
    "2023": 0.906,
    "2024": 0.90515,
    "GeoAreaCode": 304,
    "GeoAreaName": "Greenland"
  },
  {
    "2000": 0.64503,
    "2001": 0.64376,
    "2002": 0.64249,
    "2003": 0.64125,
    "2004": 0.64028,
    "2005": 0.63919,
    "2006": 0.63808,
    "2007": 0.63684,
    "2008": 0.63581,
    "2009": 0.63506,
    "2010": 0.63366,
    "2011": 0.63246,
    "2012": 0.63118,
    "2013": 0.63004,
    "2014": 0.62911,
    "2015": 0.62749,
    "2016": 0.62617,
    "2017": 0.62505,
    "2018": 0.62371,
    "2019": 0.62273,
    "2020": 0.62158,
    "2021": 0.62038,
    "2022": 0.61919,
    "2023": 0.61808,
    "2024": 0.61703,
    "GeoAreaCode": 308,
    "GeoAreaName": "Grenada"
  },
  {
    "2000": 0.5865,
    "2001": 0.5865,
    "2002": 0.5865,
    "2003": 0.5865,
    "2004": 0.5865,
    "2005": 0.5865,
    "2006": 0.58651,
    "2007": 0.58651,
    "2008": 0.58651,
    "2009": 0.58652,
    "2010": 0.58652,
    "2011": 0.58652,
    "2012": 0.58652,
    "2013": 0.58652,
    "2014": 0.58652,
    "2015": 0.58652,
    "2016": 0.58652,
    "2017": 0.58652,
    "2018": 0.58652,
    "2019": 0.58652,
    "2020": 0.58652,
    "2021": 0.58652,
    "2022": 0.58653,
    "2023": 0.58653,
    "2024": 0.58653,
    "GeoAreaCode": 312,
    "GeoAreaName": "Guadeloupe"
  },
  {
    "2000": 0.62851,
    "2001": 0.61594,
    "2002": 0.60445,
    "2003": 0.59488,
    "2004": 0.58609,
    "2005": 0.57422,
    "2006": 0.56008,
    "2007": 0.54961,
    "2008": 0.53905,
    "2009": 0.52694,
    "2010": 0.51501,
    "2011": 0.50397,
    "2012": 0.49324,
    "2013": 0.48115,
    "2014": 0.47217,
    "2015": 0.46307,
    "2016": 0.45086,
    "2017": 0.44031,
    "2018": 0.42897,
    "2019": 0.4152,
    "2020": 0.40127,
    "2021": 0.38912,
    "2022": 0.37736,
    "2023": 0.36766,
    "2024": 0.35335,
    "GeoAreaCode": 316,
    "GeoAreaName": "Guam"
  },
  {
    "2000": 0.74609,
    "2001": 0.74426,
    "2002": 0.74266,
    "2003": 0.74104,
    "2004": 0.73968,
    "2005": 0.73848,
    "2006": 0.73718,
    "2007": 0.73643,
    "2008": 0.73513,
    "2009": 0.73417,
    "2010": 0.73347,
    "2011": 0.73185,
    "2012": 0.73054,
    "2013": 0.7296,
    "2014": 0.72806,
    "2015": 0.72666,
    "2016": 0.72544,
    "2017": 0.72394,
    "2018": 0.72305,
    "2019": 0.72151,
    "2020": 0.72034,
    "2021": 0.71884,
    "2022": 0.71788,
    "2023": 0.71651,
    "2024": 0.71532,
    "GeoAreaCode": 320,
    "GeoAreaName": "Guatemala"
  },
  {
    "2000": 0.94444,
    "2001": 0.94368,
    "2002": 0.94263,
    "2003": 0.94176,
    "2004": 0.94142,
    "2005": 0.94122,
    "2006": 0.94171,
    "2007": 0.94223,
    "2008": 0.94269,
    "2009": 0.94331,
    "2010": 0.94345,
    "2011": 0.94391,
    "2012": 0.94416,
    "2013": 0.94419,
    "2014": 0.94449,
    "2015": 0.94428,
    "2016": 0.94472,
    "2017": 0.94471,
    "2018": 0.9451,
    "2019": 0.94546,
    "2020": 0.9456,
    "2021": 0.9459,
    "2022": 0.94605,
    "2023": 0.94624,
    "2024": 0.94655,
    "GeoAreaCode": 831,
    "GeoAreaName": "Guernsey"
  },
  {
    "2000": 0.89709,
    "2001": 0.89692,
    "2002": 0.89684,
    "2003": 0.89663,
    "2004": 0.89644,
    "2005": 0.89614,
    "2006": 0.89592,
    "2007": 0.89556,
    "2008": 0.8954,
    "2009": 0.89515,
    "2010": 0.89511,
    "2011": 0.89495,
    "2012": 0.89496,
    "2013": 0.8949,
    "2014": 0.89484,
    "2015": 0.89474,
    "2016": 0.89462,
    "2017": 0.8946,
    "2018": 0.89449,
    "2019": 0.89438,
    "2020": 0.89436,
    "2021": 0.89419,
    "2022": 0.89414,
    "2023": 0.89408,
    "2024": 0.89407,
    "GeoAreaCode": 324,
    "GeoAreaName": "Guinea"
  },
  {
    "2000": 0.91016,
    "2001": 0.91009,
    "2002": 0.91003,
    "2003": 0.90993,
    "2004": 0.90984,
    "2005": 0.90974,
    "2006": 0.90965,
    "2007": 0.90954,
    "2008": 0.90946,
    "2009": 0.90938,
    "2010": 0.9093,
    "2011": 0.90925,
    "2012": 0.9092,
    "2013": 0.90915,
    "2014": 0.9091,
    "2015": 0.90908,
    "2016": 0.90904,
    "2017": 0.90901,
    "2018": 0.90899,
    "2019": 0.90895,
    "2020": 0.90893,
    "2021": 0.90891,
    "2022": 0.90887,
    "2023": 0.90884,
    "2024": 0.90883,
    "GeoAreaCode": 624,
    "GeoAreaName": "Guinea-Bissau"
  },
  {
    "2000": 0.89827,
    "2001": 0.898,
    "2002": 0.89762,
    "2003": 0.89717,
    "2004": 0.89648,
    "2005": 0.89561,
    "2006": 0.89439,
    "2007": 0.89339,
    "2008": 0.89229,
    "2009": 0.89132,
    "2010": 0.88994,
    "2011": 0.88879,
    "2012": 0.88751,
    "2013": 0.88652,
    "2014": 0.88551,
    "2015": 0.88443,
    "2016": 0.88326,
    "2017": 0.88227,
    "2018": 0.88112,
    "2019": 0.88013,
    "2020": 0.87905,
    "2021": 0.87788,
    "2022": 0.87688,
    "2023": 0.87566,
    "2024": 0.8747,
    "GeoAreaCode": 328,
    "GeoAreaName": "Guyana"
  },
  {
    "2000": 0.75104,
    "2001": 0.74978,
    "2002": 0.74833,
    "2003": 0.74703,
    "2004": 0.74576,
    "2005": 0.74476,
    "2006": 0.74356,
    "2007": 0.74249,
    "2008": 0.74157,
    "2009": 0.74032,
    "2010": 0.73934,
    "2011": 0.73822,
    "2012": 0.73712,
    "2013": 0.73593,
    "2014": 0.7347,
    "2015": 0.7339,
    "2016": 0.73281,
    "2017": 0.73156,
    "2018": 0.73053,
    "2019": 0.72939,
    "2020": 0.72834,
    "2021": 0.72721,
    "2022": 0.72624,
    "2023": 0.7253,
    "2024": 0.7241,
    "GeoAreaCode": 332,
    "GeoAreaName": "Haiti"
  },
  {
    "2000": 0.91922,
    "2001": 0.91951,
    "2002": 0.91903,
    "2003": 0.91889,
    "2004": 0.91913,
    "2005": 0.919,
    "2006": 0.91965,
    "2007": 0.92034,
    "2008": 0.9211,
    "2009": 0.92146,
    "2010": 0.92199,
    "2011": 0.92251,
    "2012": 0.92352,
    "2013": 0.92366,
    "2014": 0.92438,
    "2015": 0.92481,
    "2016": 0.92497,
    "2017": 0.92546,
    "2018": 0.92565,
    "2019": 0.92548,
    "2020": 0.92587,
    "2021": 0.92596,
    "2022": 0.92621,
    "2023": 0.92625,
    "2024": 0.92672,
    "GeoAreaCode": 334,
    "GeoAreaName": "Heard Island and McDonald Islands"
  },
  {
    "2000": 0.91628,
    "2001": 0.91626,
    "2002": 0.91625,
    "2003": 0.91623,
    "2004": 0.91623,
    "2005": 0.91185,
    "2006": 0.90746,
    "2007": 0.90308,
    "2008": 0.89869,
    "2009": 0.89428,
    "2010": 0.88987,
    "2011": 0.88547,
    "2012": 0.87995,
    "2013": 0.8723,
    "2014": 0.86679,
    "2015": 0.85908,
    "2016": 0.85254,
    "2017": 0.84596,
    "2018": 0.84147,
    "2019": 0.83709,
    "2020": 0.8327,
    "2021": 0.82828,
    "2022": 0.8239,
    "2023": 0.82109,
    "2024": 0.81677,
    "GeoAreaCode": 336,
    "GeoAreaName": "Holy See"
  },
  {
    "2000": 0.77468,
    "2001": 0.7729,
    "2002": 0.77114,
    "2003": 0.76951,
    "2004": 0.76812,
    "2005": 0.76666,
    "2006": 0.76523,
    "2007": 0.76407,
    "2008": 0.76283,
    "2009": 0.76179,
    "2010": 0.76052,
    "2011": 0.75935,
    "2012": 0.75815,
    "2013": 0.75697,
    "2014": 0.75567,
    "2015": 0.7546,
    "2016": 0.75337,
    "2017": 0.75205,
    "2018": 0.75044,
    "2019": 0.74945,
    "2020": 0.74783,
    "2021": 0.7468,
    "2022": 0.74521,
    "2023": 0.74397,
    "2024": 0.74324,
    "GeoAreaCode": 340,
    "GeoAreaName": "Honduras"
  },
  {
    "2000": 0.91224,
    "2001": 0.91218,
    "2002": 0.91218,
    "2003": 0.91219,
    "2004": 0.91211,
    "2005": 0.9121,
    "2006": 0.91203,
    "2007": 0.91201,
    "2008": 0.91197,
    "2009": 0.91193,
    "2010": 0.91188,
    "2011": 0.9119,
    "2012": 0.91198,
    "2013": 0.91216,
    "2014": 0.9124,
    "2015": 0.91276,
    "2016": 0.91296,
    "2017": 0.91304,
    "2018": 0.913,
    "2019": 0.91291,
    "2020": 0.91279,
    "2021": 0.91264,
    "2022": 0.91257,
    "2023": 0.91252,
    "2024": 0.9124,
    "GeoAreaCode": 348,
    "GeoAreaName": "Hungary"
  },
  {
    "2000": 0.88931,
    "2001": 0.88844,
    "2002": 0.88763,
    "2003": 0.88747,
    "2004": 0.88747,
    "2005": 0.88761,
    "2006": 0.88898,
    "2007": 0.89048,
    "2008": 0.8908,
    "2009": 0.89176,
    "2010": 0.8919,
    "2011": 0.89107,
    "2012": 0.88956,
    "2013": 0.88754,
    "2014": 0.88525,
    "2015": 0.88473,
    "2016": 0.88431,
    "2017": 0.88373,
    "2018": 0.88344,
    "2019": 0.88371,
    "2020": 0.88381,
    "2021": 0.88384,
    "2022": 0.88411,
    "2023": 0.88421,
    "2024": 0.88437,
    "GeoAreaCode": 352,
    "GeoAreaName": "Iceland"
  },
  {
    "2000": 0.7565,
    "2001": 0.75284,
    "2002": 0.74879,
    "2003": 0.74508,
    "2004": 0.74114,
    "2005": 0.73749,
    "2006": 0.73388,
    "2007": 0.72992,
    "2008": 0.72612,
    "2009": 0.72319,
    "2010": 0.71946,
    "2011": 0.71553,
    "2012": 0.7119,
    "2013": 0.7081,
    "2014": 0.70447,
    "2015": 0.70082,
    "2016": 0.69677,
    "2017": 0.69336,
    "2018": 0.6887,
    "2019": 0.68567,
    "2020": 0.68171,
    "2021": 0.67791,
    "2022": 0.67463,
    "2023": 0.66989,
    "2024": 0.66628,
    "GeoAreaCode": 356,
    "GeoAreaName": "India"
  },
  {
    "2000": 0.84751,
    "2001": 0.84317,
    "2002": 0.83935,
    "2003": 0.83513,
    "2004": 0.83083,
    "2005": 0.82697,
    "2006": 0.82312,
    "2007": 0.81877,
    "2008": 0.81543,
    "2009": 0.81229,
    "2010": 0.80854,
    "2011": 0.80431,
    "2012": 0.80023,
    "2013": 0.79638,
    "2014": 0.79223,
    "2015": 0.78772,
    "2016": 0.78306,
    "2017": 0.77988,
    "2018": 0.77505,
    "2019": 0.7713,
    "2020": 0.76737,
    "2021": 0.76354,
    "2022": 0.75911,
    "2023": 0.75552,
    "2024": 0.7522,
    "GeoAreaCode": 360,
    "GeoAreaName": "Indonesia"
  },
  {
    "2000": 0.9253,
    "2001": 0.92224,
    "2002": 0.91935,
    "2003": 0.91632,
    "2004": 0.91282,
    "2005": 0.91017,
    "2006": 0.90755,
    "2007": 0.90459,
    "2008": 0.90141,
    "2009": 0.8987,
    "2010": 0.89594,
    "2011": 0.89357,
    "2012": 0.89065,
    "2013": 0.88832,
    "2014": 0.88557,
    "2015": 0.88246,
    "2016": 0.87983,
    "2017": 0.87846,
    "2018": 0.87524,
    "2019": 0.8721,
    "2020": 0.86958,
    "2021": 0.86695,
    "2022": 0.86419,
    "2023": 0.86112,
    "2024": 0.85864,
    "GeoAreaCode": 364,
    "GeoAreaName": "Iran (Islamic Republic of)"
  },
  {
    "2000": 0.84751,
    "2001": 0.84486,
    "2002": 0.84164,
    "2003": 0.83881,
    "2004": 0.83649,
    "2005": 0.83414,
    "2006": 0.83185,
    "2007": 0.82904,
    "2008": 0.82676,
    "2009": 0.82476,
    "2010": 0.82195,
    "2011": 0.81915,
    "2012": 0.81719,
    "2013": 0.81503,
    "2014": 0.81248,
    "2015": 0.81015,
    "2016": 0.80843,
    "2017": 0.80589,
    "2018": 0.80376,
    "2019": 0.8011,
    "2020": 0.79869,
    "2021": 0.79603,
    "2022": 0.79399,
    "2023": 0.79144,
    "2024": 0.78908,
    "GeoAreaCode": 368,
    "GeoAreaName": "Iraq"
  },
  {
    "2000": 0.87671,
    "2001": 0.87625,
    "2002": 0.87605,
    "2003": 0.87528,
    "2004": 0.87525,
    "2005": 0.87535,
    "2006": 0.87534,
    "2007": 0.8759,
    "2008": 0.87621,
    "2009": 0.87646,
    "2010": 0.87686,
    "2011": 0.87698,
    "2012": 0.87722,
    "2013": 0.87717,
    "2014": 0.87721,
    "2015": 0.87731,
    "2016": 0.87722,
    "2017": 0.87733,
    "2018": 0.87735,
    "2019": 0.8777,
    "2020": 0.87768,
    "2021": 0.87792,
    "2022": 0.87805,
    "2023": 0.87817,
    "2024": 0.87836,
    "GeoAreaCode": 372,
    "GeoAreaName": "Ireland"
  },
  {
    "2000": 0.97275,
    "2001": 0.97121,
    "2002": 0.96966,
    "2003": 0.96812,
    "2004": 0.96658,
    "2005": 0.96626,
    "2006": 0.96594,
    "2007": 0.96562,
    "2008": 0.9653,
    "2009": 0.96528,
    "2010": 0.96525,
    "2011": 0.96522,
    "2012": 0.96519,
    "2013": 0.96479,
    "2014": 0.96439,
    "2015": 0.96398,
    "2016": 0.96358,
    "2017": 0.96358,
    "2018": 0.96358,
    "2019": 0.96358,
    "2020": 0.96358,
    "2021": 0.96358,
    "2022": 0.96358,
    "2023": 0.96358,
    "2024": 0.96358,
    "GeoAreaCode": 833,
    "GeoAreaName": "Isle of Man"
  },
  {
    "2000": 0.72291,
    "2001": 0.72264,
    "2002": 0.72246,
    "2003": 0.72236,
    "2004": 0.72224,
    "2005": 0.72216,
    "2006": 0.72215,
    "2007": 0.72215,
    "2008": 0.72221,
    "2009": 0.72222,
    "2010": 0.72227,
    "2011": 0.7225,
    "2012": 0.72252,
    "2013": 0.72265,
    "2014": 0.72305,
    "2015": 0.72359,
    "2016": 0.724,
    "2017": 0.72421,
    "2018": 0.72459,
    "2019": 0.72458,
    "2020": 0.72457,
    "2021": 0.72457,
    "2022": 0.72456,
    "2023": 0.72456,
    "2024": 0.72455,
    "GeoAreaCode": 376,
    "GeoAreaName": "Israel"
  },
  {
    "2000": 0.91043,
    "2001": 0.90989,
    "2002": 0.90936,
    "2003": 0.90898,
    "2004": 0.90849,
    "2005": 0.9066,
    "2006": 0.90472,
    "2007": 0.90283,
    "2008": 0.90091,
    "2009": 0.89901,
    "2010": 0.89707,
    "2011": 0.89519,
    "2012": 0.89328,
    "2013": 0.89138,
    "2014": 0.88928,
    "2015": 0.88724,
    "2016": 0.88521,
    "2017": 0.88304,
    "2018": 0.88076,
    "2019": 0.87864,
    "2020": 0.87644,
    "2021": 0.87456,
    "2022": 0.87269,
    "2023": 0.87147,
    "2024": 0.87002,
    "GeoAreaCode": 380,
    "GeoAreaName": "Italy"
  },
  {
    "2000": 0.68267,
    "2001": 0.68067,
    "2002": 0.679,
    "2003": 0.67721,
    "2004": 0.67559,
    "2005": 0.6739,
    "2006": 0.67253,
    "2007": 0.67101,
    "2008": 0.66974,
    "2009": 0.66827,
    "2010": 0.66689,
    "2011": 0.66532,
    "2012": 0.66377,
    "2013": 0.66242,
    "2014": 0.66101,
    "2015": 0.65948,
    "2016": 0.65771,
    "2017": 0.65608,
    "2018": 0.65448,
    "2019": 0.65257,
    "2020": 0.65048,
    "2021": 0.64953,
    "2022": 0.64782,
    "2023": 0.64637,
    "2024": 0.64464,
    "GeoAreaCode": 388,
    "GeoAreaName": "Jamaica"
  },
  {
    "2000": 0.82285,
    "2001": 0.8195,
    "2002": 0.81675,
    "2003": 0.81379,
    "2004": 0.81054,
    "2005": 0.8074,
    "2006": 0.80462,
    "2007": 0.80221,
    "2008": 0.79914,
    "2009": 0.7958,
    "2010": 0.79315,
    "2011": 0.78983,
    "2012": 0.78624,
    "2013": 0.78306,
    "2014": 0.77972,
    "2015": 0.77584,
    "2016": 0.77301,
    "2017": 0.7695,
    "2018": 0.76633,
    "2019": 0.76261,
    "2020": 0.75879,
    "2021": 0.75638,
    "2022": 0.75296,
    "2023": 0.74855,
    "2024": 0.74628,
    "GeoAreaCode": 392,
    "GeoAreaName": "Japan"
  },
  {
    "2000": 0.95188,
    "2001": 0.95168,
    "2002": 0.95075,
    "2003": 0.95042,
    "2004": 0.95041,
    "2005": 0.95022,
    "2006": 0.95059,
    "2007": 0.95151,
    "2008": 0.95235,
    "2009": 0.95279,
    "2010": 0.95317,
    "2011": 0.95344,
    "2012": 0.95371,
    "2013": 0.95383,
    "2014": 0.95372,
    "2015": 0.95367,
    "2016": 0.9536,
    "2017": 0.95367,
    "2018": 0.95418,
    "2019": 0.95458,
    "2020": 0.95485,
    "2021": 0.95504,
    "2022": 0.95568,
    "2023": 0.95577,
    "2024": 0.95592,
    "GeoAreaCode": 832,
    "GeoAreaName": "Jersey"
  },
  {
    "2000": 0.9628,
    "2001": 0.96211,
    "2002": 0.96157,
    "2003": 0.96139,
    "2004": 0.96137,
    "2005": 0.96154,
    "2006": 0.96162,
    "2007": 0.96182,
    "2008": 0.96185,
    "2009": 0.96181,
    "2010": 0.96179,
    "2011": 0.96174,
    "2012": 0.96171,
    "2013": 0.96165,
    "2014": 0.96164,
    "2015": 0.96162,
    "2016": 0.96158,
    "2017": 0.96153,
    "2018": 0.96149,
    "2019": 0.96144,
    "2020": 0.96139,
    "2021": 0.96133,
    "2022": 0.96132,
    "2023": 0.96128,
    "2024": 0.96126,
    "GeoAreaCode": 400,
    "GeoAreaName": "Jordan"
  },
  {
    "2000": 0.90288,
    "2001": 0.90038,
    "2002": 0.8981,
    "2003": 0.89609,
    "2004": 0.89426,
    "2005": 0.8932,
    "2006": 0.89238,
    "2007": 0.89208,
    "2008": 0.89155,
    "2009": 0.89116,
    "2010": 0.8906,
    "2011": 0.89014,
    "2012": 0.88978,
    "2013": 0.88926,
    "2014": 0.88858,
    "2015": 0.88799,
    "2016": 0.88731,
    "2017": 0.88684,
    "2018": 0.88642,
    "2019": 0.88591,
    "2020": 0.88549,
    "2021": 0.88485,
    "2022": 0.88457,
    "2023": 0.88384,
    "2024": 0.88364,
    "GeoAreaCode": 398,
    "GeoAreaName": "Kazakhstan"
  },
  {
    "2000": 0.84226,
    "2001": 0.83914,
    "2002": 0.83588,
    "2003": 0.83246,
    "2004": 0.82912,
    "2005": 0.82652,
    "2006": 0.82337,
    "2007": 0.82042,
    "2008": 0.81748,
    "2009": 0.81446,
    "2010": 0.81156,
    "2011": 0.80875,
    "2012": 0.80593,
    "2013": 0.80276,
    "2014": 0.79938,
    "2015": 0.79645,
    "2016": 0.79224,
    "2017": 0.79006,
    "2018": 0.78625,
    "2019": 0.78393,
    "2020": 0.78045,
    "2021": 0.77777,
    "2022": 0.77453,
    "2023": 0.77145,
    "2024": 0.76833,
    "GeoAreaCode": 404,
    "GeoAreaName": "Kenya"
  },
  {
    "2000": 0.81769,
    "2001": 0.81534,
    "2002": 0.8113,
    "2003": 0.80806,
    "2004": 0.80592,
    "2005": 0.80378,
    "2006": 0.80122,
    "2007": 0.79998,
    "2008": 0.79697,
    "2009": 0.79488,
    "2010": 0.79249,
    "2011": 0.78901,
    "2012": 0.78656,
    "2013": 0.78373,
    "2014": 0.77995,
    "2015": 0.77777,
    "2016": 0.77358,
    "2017": 0.76963,
    "2018": 0.76755,
    "2019": 0.76475,
    "2020": 0.76137,
    "2021": 0.75768,
    "2022": 0.75462,
    "2023": 0.75206,
    "2024": 0.74999,
    "GeoAreaCode": 296,
    "GeoAreaName": "Kiribati"
  },
  {
    "2000": 0.91593,
    "2001": 0.91303,
    "2002": 0.91001,
    "2003": 0.90738,
    "2004": 0.90537,
    "2005": 0.90219,
    "2006": 0.8996,
    "2007": 0.8981,
    "2008": 0.89609,
    "2009": 0.8936,
    "2010": 0.89155,
    "2011": 0.88853,
    "2012": 0.88681,
    "2013": 0.88538,
    "2014": 0.88372,
    "2015": 0.88219,
    "2016": 0.88029,
    "2017": 0.87804,
    "2018": 0.87636,
    "2019": 0.87389,
    "2020": 0.87126,
    "2021": 0.86924,
    "2022": 0.86644,
    "2023": 0.86423,
    "2024": 0.86217,
    "GeoAreaCode": 414,
    "GeoAreaName": "Kuwait"
  },
  {
    "2000": 0.90947,
    "2001": 0.9043,
    "2002": 0.90036,
    "2003": 0.89626,
    "2004": 0.89273,
    "2005": 0.89212,
    "2006": 0.89169,
    "2007": 0.8915,
    "2008": 0.89137,
    "2009": 0.89118,
    "2010": 0.89102,
    "2011": 0.89076,
    "2012": 0.89054,
    "2013": 0.89028,
    "2014": 0.89001,
    "2015": 0.88976,
    "2016": 0.88948,
    "2017": 0.88924,
    "2018": 0.889,
    "2019": 0.88879,
    "2020": 0.88856,
    "2021": 0.88832,
    "2022": 0.88813,
    "2023": 0.88795,
    "2024": 0.88766,
    "GeoAreaCode": 417,
    "GeoAreaName": "Kyrgyzstan"
  },
  {
    "2000": 0.80923,
    "2001": 0.80807,
    "2002": 0.80711,
    "2003": 0.80602,
    "2004": 0.80507,
    "2005": 0.80387,
    "2006": 0.80295,
    "2007": 0.80202,
    "2008": 0.80092,
    "2009": 0.79994,
    "2010": 0.79902,
    "2011": 0.79801,
    "2012": 0.79703,
    "2013": 0.79608,
    "2014": 0.79518,
    "2015": 0.79432,
    "2016": 0.7934,
    "2017": 0.79262,
    "2018": 0.79172,
    "2019": 0.79082,
    "2020": 0.78978,
    "2021": 0.78899,
    "2022": 0.78799,
    "2023": 0.78709,
    "2024": 0.78622,
    "GeoAreaCode": 432,
    "GeoAreaName": "Landlocked developing countries (LLDCs)"
  },
  {
    "2000": 0.83294,
    "2001": 0.83251,
    "2002": 0.83216,
    "2003": 0.83185,
    "2004": 0.83138,
    "2005": 0.8311,
    "2006": 0.83067,
    "2007": 0.83028,
    "2008": 0.8301,
    "2009": 0.82972,
    "2010": 0.8295,
    "2011": 0.82914,
    "2012": 0.82888,
    "2013": 0.82847,
    "2014": 0.82825,
    "2015": 0.82786,
    "2016": 0.82746,
    "2017": 0.82712,
    "2018": 0.82679,
    "2019": 0.82669,
    "2020": 0.82633,
    "2021": 0.82614,
    "2022": 0.8259,
    "2023": 0.82572,
    "2024": 0.82547,
    "GeoAreaCode": 418,
    "GeoAreaName": "Lao People's Democratic Republic"
  },
  {
    "2000": 0.77782,
    "2001": 0.7759,
    "2002": 0.77424,
    "2003": 0.77262,
    "2004": 0.77086,
    "2005": 0.76916,
    "2006": 0.76754,
    "2007": 0.76582,
    "2008": 0.76429,
    "2009": 0.76284,
    "2010": 0.76109,
    "2011": 0.75947,
    "2012": 0.75772,
    "2013": 0.75608,
    "2014": 0.75445,
    "2015": 0.75295,
    "2016": 0.75132,
    "2017": 0.74959,
    "2018": 0.748,
    "2019": 0.74628,
    "2020": 0.74475,
    "2021": 0.74318,
    "2022": 0.74135,
    "2023": 0.73996,
    "2024": 0.73793,
    "GeoAreaCode": 419,
    "GeoAreaName": "Latin America and the Caribbean"
  },
  {
    "2000": 0.98909,
    "2001": 0.98904,
    "2002": 0.98898,
    "2003": 0.98892,
    "2004": 0.98886,
    "2005": 0.98872,
    "2006": 0.98858,
    "2007": 0.98844,
    "2008": 0.9883,
    "2009": 0.9882,
    "2010": 0.9881,
    "2011": 0.9881,
    "2012": 0.9881,
    "2013": 0.98811,
    "2014": 0.98832,
    "2015": 0.98853,
    "2016": 0.98863,
    "2017": 0.98863,
    "2018": 0.98863,
    "2019": 0.98858,
    "2020": 0.98853,
    "2021": 0.98853,
    "2022": 0.98853,
    "2023": 0.98853,
    "2024": 0.98853,
    "GeoAreaCode": 428,
    "GeoAreaName": "Latvia"
  },
  {
    "2000": 0.81618,
    "2001": 0.81265,
    "2002": 0.80954,
    "2003": 0.8064,
    "2004": 0.80287,
    "2005": 0.79952,
    "2006": 0.79646,
    "2007": 0.79283,
    "2008": 0.79007,
    "2009": 0.78688,
    "2010": 0.78415,
    "2011": 0.78092,
    "2012": 0.77691,
    "2013": 0.77386,
    "2014": 0.77008,
    "2015": 0.76679,
    "2016": 0.76349,
    "2017": 0.7598,
    "2018": 0.75582,
    "2019": 0.75303,
    "2020": 0.74948,
    "2021": 0.74567,
    "2022": 0.74328,
    "2023": 0.73921,
    "2024": 0.73534,
    "GeoAreaCode": 199,
    "GeoAreaName": "Least Developed Countries (LDCs)"
  },
  {
    "2000": 0.95577,
    "2001": 0.95557,
    "2002": 0.95541,
    "2003": 0.95528,
    "2004": 0.95523,
    "2005": 0.95518,
    "2006": 0.95514,
    "2007": 0.95511,
    "2008": 0.95508,
    "2009": 0.95506,
    "2010": 0.95503,
    "2011": 0.95503,
    "2012": 0.95503,
    "2013": 0.95668,
    "2014": 0.95842,
    "2015": 0.96013,
    "2016": 0.9618,
    "2017": 0.96188,
    "2018": 0.96189,
    "2019": 0.96186,
    "2020": 0.96183,
    "2021": 0.96181,
    "2022": 0.96179,
    "2023": 0.96178,
    "2024": 0.96175,
    "GeoAreaCode": 422,
    "GeoAreaName": "Lebanon"
  },
  {
    "2000": 0.94499,
    "2001": 0.94415,
    "2002": 0.94328,
    "2003": 0.94244,
    "2004": 0.94163,
    "2005": 0.94158,
    "2006": 0.94155,
    "2007": 0.94153,
    "2008": 0.94151,
    "2009": 0.9415,
    "2010": 0.94149,
    "2011": 0.94147,
    "2012": 0.94143,
    "2013": 0.9414,
    "2014": 0.94136,
    "2015": 0.94131,
    "2016": 0.94125,
    "2017": 0.94121,
    "2018": 0.94116,
    "2019": 0.94111,
    "2020": 0.94108,
    "2021": 0.94105,
    "2022": 0.94103,
    "2023": 0.94101,
    "2024": 0.94099,
    "GeoAreaCode": 426,
    "GeoAreaName": "Lesotho"
  },
  {
    "2000": 0.91569,
    "2001": 0.91571,
    "2002": 0.91563,
    "2003": 0.91571,
    "2004": 0.9156,
    "2005": 0.91559,
    "2006": 0.91547,
    "2007": 0.91531,
    "2008": 0.91533,
    "2009": 0.9153,
    "2010": 0.91512,
    "2011": 0.91512,
    "2012": 0.91502,
    "2013": 0.91497,
    "2014": 0.91496,
    "2015": 0.91494,
    "2016": 0.91493,
    "2017": 0.91485,
    "2018": 0.91484,
    "2019": 0.91477,
    "2020": 0.91471,
    "2021": 0.91477,
    "2022": 0.91481,
    "2023": 0.9148,
    "2024": 0.91475,
    "GeoAreaCode": 430,
    "GeoAreaName": "Liberia"
  },
  {
    "2000": 0.98025,
    "2001": 0.97984,
    "2002": 0.97916,
    "2003": 0.97875,
    "2004": 0.9786,
    "2005": 0.9785,
    "2006": 0.97845,
    "2007": 0.97845,
    "2008": 0.97834,
    "2009": 0.97793,
    "2010": 0.97762,
    "2011": 0.97691,
    "2012": 0.97673,
    "2013": 0.97627,
    "2014": 0.97622,
    "2015": 0.97624,
    "2016": 0.97628,
    "2017": 0.97614,
    "2018": 0.97623,
    "2019": 0.97618,
    "2020": 0.97597,
    "2021": 0.97609,
    "2022": 0.97616,
    "2023": 0.97606,
    "2024": 0.97603,
    "GeoAreaCode": 434,
    "GeoAreaName": "Libya"
  },
  {
    "2000": 0.98449,
    "2001": 0.98449,
    "2002": 0.98449,
    "2003": 0.98449,
    "2004": 0.98449,
    "2005": 0.98424,
    "2006": 0.98396,
    "2007": 0.98369,
    "2008": 0.98341,
    "2009": 0.98313,
    "2010": 0.98285,
    "2011": 0.98259,
    "2012": 0.98257,
    "2013": 0.98247,
    "2014": 0.98247,
    "2015": 0.98246,
    "2016": 0.98237,
    "2017": 0.98222,
    "2018": 0.98199,
    "2019": 0.98165,
    "2020": 0.98139,
    "2021": 0.98115,
    "2022": 0.98088,
    "2023": 0.98062,
    "2024": 0.98042,
    "GeoAreaCode": 438,
    "GeoAreaName": "Liechtenstein"
  },
  {
    "2000": 0.98874,
    "2001": 0.9887,
    "2002": 0.98865,
    "2003": 0.98861,
    "2004": 0.98857,
    "2005": 0.98853,
    "2006": 0.9885,
    "2007": 0.98846,
    "2008": 0.98845,
    "2009": 0.98845,
    "2010": 0.98845,
    "2011": 0.98845,
    "2012": 0.98846,
    "2013": 0.98891,
    "2014": 0.98936,
    "2015": 0.98981,
    "2016": 0.99015,
    "2017": 0.99015,
    "2018": 0.99015,
    "2019": 0.9901,
    "2020": 0.99005,
    "2021": 0.99005,
    "2022": 0.99005,
    "2023": 0.99005,
    "2024": 0.99005,
    "GeoAreaCode": 440,
    "GeoAreaName": "Lithuania"
  },
  {
    "2000": 0.98549,
    "2001": 0.98552,
    "2002": 0.98552,
    "2003": 0.98553,
    "2004": 0.98552,
    "2005": 0.98527,
    "2006": 0.98473,
    "2007": 0.98431,
    "2008": 0.98381,
    "2009": 0.98335,
    "2010": 0.98275,
    "2011": 0.98242,
    "2012": 0.98227,
    "2013": 0.98231,
    "2014": 0.98233,
    "2015": 0.98237,
    "2016": 0.98228,
    "2017": 0.98212,
    "2018": 0.98176,
    "2019": 0.98132,
    "2020": 0.98086,
    "2021": 0.98048,
    "2022": 0.98003,
    "2023": 0.97948,
    "2024": 0.97914,
    "GeoAreaCode": 442,
    "GeoAreaName": "Luxembourg"
  },
  {
    "2000": 0.82309,
    "2001": 0.81973,
    "2002": 0.81628,
    "2003": 0.81188,
    "2004": 0.80867,
    "2005": 0.80462,
    "2006": 0.80095,
    "2007": 0.79747,
    "2008": 0.79426,
    "2009": 0.79119,
    "2010": 0.78817,
    "2011": 0.78498,
    "2012": 0.78107,
    "2013": 0.77695,
    "2014": 0.7738,
    "2015": 0.76949,
    "2016": 0.76628,
    "2017": 0.76272,
    "2018": 0.75947,
    "2019": 0.75473,
    "2020": 0.75171,
    "2021": 0.74802,
    "2022": 0.74417,
    "2023": 0.74107,
    "2024": 0.73758,
    "GeoAreaCode": 450,
    "GeoAreaName": "Madagascar"
  },
  {
    "2000": 0.80662,
    "2001": 0.80653,
    "2002": 0.80653,
    "2003": 0.80657,
    "2004": 0.80669,
    "2005": 0.80665,
    "2006": 0.80679,
    "2007": 0.80691,
    "2008": 0.807,
    "2009": 0.80712,
    "2010": 0.80721,
    "2011": 0.80725,
    "2012": 0.80725,
    "2013": 0.80733,
    "2014": 0.80732,
    "2015": 0.80731,
    "2016": 0.80733,
    "2017": 0.80744,
    "2018": 0.80744,
    "2019": 0.80747,
    "2020": 0.80755,
    "2021": 0.80762,
    "2022": 0.80764,
    "2023": 0.80767,
    "2024": 0.80772,
    "GeoAreaCode": 454,
    "GeoAreaName": "Malawi"
  },
  {
    "2000": 0.78113,
    "2001": 0.77716,
    "2002": 0.77305,
    "2003": 0.76937,
    "2004": 0.766,
    "2005": 0.76209,
    "2006": 0.75888,
    "2007": 0.75509,
    "2008": 0.75143,
    "2009": 0.74799,
    "2010": 0.74425,
    "2011": 0.74097,
    "2012": 0.73701,
    "2013": 0.73357,
    "2014": 0.72944,
    "2015": 0.72562,
    "2016": 0.72064,
    "2017": 0.71771,
    "2018": 0.71351,
    "2019": 0.71025,
    "2020": 0.70649,
    "2021": 0.70312,
    "2022": 0.69942,
    "2023": 0.69529,
    "2024": 0.69199,
    "GeoAreaCode": 458,
    "GeoAreaName": "Malaysia"
  },
  {
    "2000": 0.9313,
    "2001": 0.92664,
    "2002": 0.92246,
    "2003": 0.91769,
    "2004": 0.91416,
    "2005": 0.90984,
    "2006": 0.90743,
    "2007": 0.90414,
    "2008": 0.90181,
    "2009": 0.89902,
    "2010": 0.89594,
    "2011": 0.89198,
    "2012": 0.88928,
    "2013": 0.88423,
    "2014": 0.87919,
    "2015": 0.87556,
    "2016": 0.87064,
    "2017": 0.86687,
    "2018": 0.86203,
    "2019": 0.85756,
    "2020": 0.85329,
    "2021": 0.84898,
    "2022": 0.84449,
    "2023": 0.84239,
    "2024": 0.83747,
    "GeoAreaCode": 462,
    "GeoAreaName": "Maldives"
  },
  {
    "2000": 0.98417,
    "2001": 0.98389,
    "2002": 0.98362,
    "2003": 0.98324,
    "2004": 0.98291,
    "2005": 0.98244,
    "2006": 0.98195,
    "2007": 0.98142,
    "2008": 0.98097,
    "2009": 0.98067,
    "2010": 0.98033,
    "2011": 0.98006,
    "2012": 0.97983,
    "2013": 0.97962,
    "2014": 0.97943,
    "2015": 0.97932,
    "2016": 0.97914,
    "2017": 0.97902,
    "2018": 0.97886,
    "2019": 0.97875,
    "2020": 0.97857,
    "2021": 0.97842,
    "2022": 0.97827,
    "2023": 0.97817,
    "2024": 0.97803,
    "GeoAreaCode": 466,
    "GeoAreaName": "Mali"
  },
  {
    "2000": 0.93038,
    "2001": 0.92847,
    "2002": 0.9265,
    "2003": 0.92472,
    "2004": 0.92361,
    "2005": 0.92361,
    "2006": 0.92361,
    "2007": 0.92353,
    "2008": 0.92345,
    "2009": 0.92344,
    "2010": 0.92336,
    "2011": 0.9233,
    "2012": 0.9233,
    "2013": 0.9233,
    "2014": 0.9233,
    "2015": 0.92333,
    "2016": 0.92336,
    "2017": 0.92338,
    "2018": 0.92338,
    "2019": 0.92338,
    "2020": 0.92338,
    "2021": 0.92338,
    "2022": 0.92338,
    "2023": 0.92338,
    "2024": 0.92338,
    "GeoAreaCode": 470,
    "GeoAreaName": "Malta"
  },
  {
    "2000": 0.89347,
    "2001": 0.89046,
    "2002": 0.88772,
    "2003": 0.88456,
    "2004": 0.88066,
    "2005": 0.87753,
    "2006": 0.87475,
    "2007": 0.87235,
    "2008": 0.86886,
    "2009": 0.86545,
    "2010": 0.86166,
    "2011": 0.85781,
    "2012": 0.85522,
    "2013": 0.85042,
    "2014": 0.84773,
    "2015": 0.8437,
    "2016": 0.84056,
    "2017": 0.83705,
    "2018": 0.83351,
    "2019": 0.83178,
    "2020": 0.82837,
    "2021": 0.82417,
    "2022": 0.82052,
    "2023": 0.81697,
    "2024": 0.8137,
    "GeoAreaCode": 584,
    "GeoAreaName": "Marshall Islands"
  },
  {
    "2000": 0.77995,
    "2001": 0.77884,
    "2002": 0.77753,
    "2003": 0.77547,
    "2004": 0.77302,
    "2005": 0.76982,
    "2006": 0.76503,
    "2007": 0.76097,
    "2008": 0.75605,
    "2009": 0.75063,
    "2010": 0.74646,
    "2011": 0.74166,
    "2012": 0.73659,
    "2013": 0.73236,
    "2014": 0.7274,
    "2015": 0.72359,
    "2016": 0.71876,
    "2017": 0.71525,
    "2018": 0.71109,
    "2019": 0.7073,
    "2020": 0.70317,
    "2021": 0.69924,
    "2022": 0.69413,
    "2023": 0.69055,
    "2024": 0.68512,
    "GeoAreaCode": 474,
    "GeoAreaName": "Martinique"
  },
  {
    "2000": 0.97731,
    "2001": 0.97707,
    "2002": 0.97675,
    "2003": 0.97635,
    "2004": 0.97594,
    "2005": 0.97547,
    "2006": 0.97498,
    "2007": 0.97444,
    "2008": 0.974,
    "2009": 0.97371,
    "2010": 0.97341,
    "2011": 0.97313,
    "2012": 0.9729,
    "2013": 0.97264,
    "2014": 0.97238,
    "2015": 0.97216,
    "2016": 0.97193,
    "2017": 0.97169,
    "2018": 0.97149,
    "2019": 0.97125,
    "2020": 0.97107,
    "2021": 0.97085,
    "2022": 0.9707,
    "2023": 0.97052,
    "2024": 0.97039,
    "GeoAreaCode": 478,
    "GeoAreaName": "Mauritania"
  },
  {
    "2000": 0.51881,
    "2001": 0.51259,
    "2002": 0.50697,
    "2003": 0.50099,
    "2004": 0.4949,
    "2005": 0.48974,
    "2006": 0.48393,
    "2007": 0.47897,
    "2008": 0.47524,
    "2009": 0.47137,
    "2010": 0.46668,
    "2011": 0.46311,
    "2012": 0.45713,
    "2013": 0.45131,
    "2014": 0.44305,
    "2015": 0.43805,
    "2016": 0.43123,
    "2017": 0.42479,
    "2018": 0.41729,
    "2019": 0.41148,
    "2020": 0.40583,
    "2021": 0.39907,
    "2022": 0.3928,
    "2023": 0.38534,
    "2024": 0.38002,
    "GeoAreaCode": 480,
    "GeoAreaName": "Mauritius"
  },
  {
    "2000": 0.90879,
    "2001": 0.90526,
    "2002": 0.90158,
    "2003": 0.89838,
    "2004": 0.89459,
    "2005": 0.89084,
    "2006": 0.88791,
    "2007": 0.8844,
    "2008": 0.88115,
    "2009": 0.87853,
    "2010": 0.87567,
    "2011": 0.87208,
    "2012": 0.8691,
    "2013": 0.86557,
    "2014": 0.86205,
    "2015": 0.85812,
    "2016": 0.85456,
    "2017": 0.85142,
    "2018": 0.84724,
    "2019": 0.84391,
    "2020": 0.8405,
    "2021": 0.83813,
    "2022": 0.8341,
    "2023": 0.83058,
    "2024": 0.82661,
    "GeoAreaCode": 175,
    "GeoAreaName": "Mayotte"
  },
  {
    "2000": 0.73122,
    "2001": 0.72878,
    "2002": 0.72681,
    "2003": 0.72451,
    "2004": 0.72242,
    "2005": 0.72019,
    "2006": 0.71858,
    "2007": 0.71635,
    "2008": 0.71463,
    "2009": 0.71242,
    "2010": 0.71055,
    "2011": 0.70852,
    "2012": 0.70653,
    "2013": 0.70467,
    "2014": 0.70245,
    "2015": 0.70071,
    "2016": 0.69855,
    "2017": 0.69628,
    "2018": 0.69417,
    "2019": 0.69217,
    "2020": 0.68962,
    "2021": 0.68739,
    "2022": 0.68597,
    "2023": 0.68395,
    "2024": 0.68162,
    "GeoAreaCode": 484,
    "GeoAreaName": "Mexico"
  },
  {
    "2000": 0.74829,
    "2001": 0.74457,
    "2002": 0.74029,
    "2003": 0.73669,
    "2004": 0.7327,
    "2005": 0.72848,
    "2006": 0.72442,
    "2007": 0.71989,
    "2008": 0.71648,
    "2009": 0.71277,
    "2010": 0.70907,
    "2011": 0.7054,
    "2012": 0.70092,
    "2013": 0.69657,
    "2014": 0.69268,
    "2015": 0.6886,
    "2016": 0.68385,
    "2017": 0.68009,
    "2018": 0.67594,
    "2019": 0.67167,
    "2020": 0.66801,
    "2021": 0.66399,
    "2022": 0.65941,
    "2023": 0.65556,
    "2024": 0.65186,
    "GeoAreaCode": 583,
    "GeoAreaName": "Micronesia (Federated States of)"
  },
  {
    "2000": 0.9059,
    "2001": 0.90573,
    "2002": 0.9056,
    "2003": 0.90574,
    "2004": 0.90591,
    "2005": 0.90593,
    "2006": 0.90591,
    "2007": 0.90582,
    "2008": 0.90582,
    "2009": 0.90582,
    "2010": 0.90582,
    "2011": 0.90582,
    "2012": 0.90395,
    "2013": 0.90274,
    "2014": 0.89966,
    "2015": 0.89658,
    "2016": 0.8935,
    "2017": 0.89093,
    "2018": 0.88838,
    "2019": 0.88581,
    "2020": 0.88326,
    "2021": 0.88325,
    "2022": 0.88325,
    "2023": 0.88325,
    "2024": 0.88325,
    "GeoAreaCode": 492,
    "GeoAreaName": "Monaco"
  },
  {
    "2000": 0.96166,
    "2001": 0.96114,
    "2002": 0.96071,
    "2003": 0.96041,
    "2004": 0.95995,
    "2005": 0.95948,
    "2006": 0.95914,
    "2007": 0.95868,
    "2008": 0.95822,
    "2009": 0.95799,
    "2010": 0.95767,
    "2011": 0.95734,
    "2012": 0.95705,
    "2013": 0.95662,
    "2014": 0.95621,
    "2015": 0.95592,
    "2016": 0.95554,
    "2017": 0.95525,
    "2018": 0.95498,
    "2019": 0.9547,
    "2020": 0.95442,
    "2021": 0.95415,
    "2022": 0.95391,
    "2023": 0.9536,
    "2024": 0.95333,
    "GeoAreaCode": 496,
    "GeoAreaName": "Mongolia"
  },
  {
    "2000": 0.85472,
    "2001": 0.85289,
    "2002": 0.85107,
    "2003": 0.84947,
    "2004": 0.84808,
    "2005": 0.84751,
    "2006": 0.84676,
    "2007": 0.8463,
    "2008": 0.84589,
    "2009": 0.8458,
    "2010": 0.84539,
    "2011": 0.84492,
    "2012": 0.8445,
    "2013": 0.84434,
    "2014": 0.84415,
    "2015": 0.844,
    "2016": 0.84368,
    "2017": 0.84338,
    "2018": 0.84295,
    "2019": 0.84249,
    "2020": 0.84202,
    "2021": 0.8416,
    "2022": 0.84119,
    "2023": 0.84084,
    "2024": 0.8403,
    "GeoAreaCode": 499,
    "GeoAreaName": "Montenegro"
  },
  {
    "2000": 0.57561,
    "2001": 0.57441,
    "2002": 0.58923,
    "2003": 0.60834,
    "2004": 0.6226,
    "2005": 0.62413,
    "2006": 0.62409,
    "2007": 0.62313,
    "2008": 0.62235,
    "2009": 0.62135,
    "2010": 0.62036,
    "2011": 0.61938,
    "2012": 0.61829,
    "2013": 0.61737,
    "2014": 0.61606,
    "2015": 0.61523,
    "2016": 0.61395,
    "2017": 0.61278,
    "2018": 0.61197,
    "2019": 0.6105,
    "2020": 0.6096,
    "2021": 0.6078,
    "2022": 0.6074,
    "2023": 0.60547,
    "2024": 0.60476,
    "GeoAreaCode": 500,
    "GeoAreaName": "Montserrat"
  },
  {
    "2000": 0.91177,
    "2001": 0.91098,
    "2002": 0.91021,
    "2003": 0.90906,
    "2004": 0.9081,
    "2005": 0.90695,
    "2006": 0.90562,
    "2007": 0.90442,
    "2008": 0.90309,
    "2009": 0.90159,
    "2010": 0.90027,
    "2011": 0.89896,
    "2012": 0.89774,
    "2013": 0.89641,
    "2014": 0.89519,
    "2015": 0.8942,
    "2016": 0.89288,
    "2017": 0.89182,
    "2018": 0.89052,
    "2019": 0.88926,
    "2020": 0.88811,
    "2021": 0.88716,
    "2022": 0.88594,
    "2023": 0.88504,
    "2024": 0.88354,
    "GeoAreaCode": 504,
    "GeoAreaName": "Morocco"
  },
  {
    "2000": 0.85256,
    "2001": 0.84972,
    "2002": 0.84661,
    "2003": 0.84388,
    "2004": 0.84056,
    "2005": 0.8373,
    "2006": 0.83486,
    "2007": 0.83199,
    "2008": 0.82905,
    "2009": 0.82664,
    "2010": 0.8242,
    "2011": 0.82098,
    "2012": 0.81825,
    "2013": 0.81499,
    "2014": 0.81223,
    "2015": 0.80889,
    "2016": 0.80604,
    "2017": 0.80314,
    "2018": 0.80013,
    "2019": 0.79697,
    "2020": 0.79366,
    "2021": 0.79117,
    "2022": 0.78803,
    "2023": 0.78492,
    "2024": 0.7816,
    "GeoAreaCode": 508,
    "GeoAreaName": "Mozambique"
  },
  {
    "2000": 0.85588,
    "2001": 0.85285,
    "2002": 0.85007,
    "2003": 0.84752,
    "2004": 0.84431,
    "2005": 0.84171,
    "2006": 0.83899,
    "2007": 0.83648,
    "2008": 0.8338,
    "2009": 0.83123,
    "2010": 0.82876,
    "2011": 0.82579,
    "2012": 0.82312,
    "2013": 0.8198,
    "2014": 0.81668,
    "2015": 0.81439,
    "2016": 0.81061,
    "2017": 0.80809,
    "2018": 0.80543,
    "2019": 0.80235,
    "2020": 0.79943,
    "2021": 0.79621,
    "2022": 0.79358,
    "2023": 0.79113,
    "2024": 0.78868,
    "GeoAreaCode": 104,
    "GeoAreaName": "Myanmar"
  },
  {
    "2000": 0.97419,
    "2001": 0.97406,
    "2002": 0.97392,
    "2003": 0.97379,
    "2004": 0.97365,
    "2005": 0.97356,
    "2006": 0.97347,
    "2007": 0.97339,
    "2008": 0.9733,
    "2009": 0.97323,
    "2010": 0.97318,
    "2011": 0.97312,
    "2012": 0.97306,
    "2013": 0.97298,
    "2014": 0.9729,
    "2015": 0.97283,
    "2016": 0.97275,
    "2017": 0.97268,
    "2018": 0.97259,
    "2019": 0.97253,
    "2020": 0.97249,
    "2021": 0.97247,
    "2022": 0.97247,
    "2023": 0.97247,
    "2024": 0.97247,
    "GeoAreaCode": 516,
    "GeoAreaName": "Namibia"
  },
  {
    "2000": 0.88423,
    "2001": 0.88055,
    "2002": 0.87653,
    "2003": 0.87432,
    "2004": 0.87055,
    "2005": 0.86787,
    "2006": 0.86432,
    "2007": 0.86111,
    "2008": 0.85791,
    "2009": 0.85455,
    "2010": 0.85085,
    "2011": 0.84767,
    "2012": 0.844,
    "2013": 0.84073,
    "2014": 0.83719,
    "2015": 0.83315,
    "2016": 0.83018,
    "2017": 0.8274,
    "2018": 0.82382,
    "2019": 0.8199,
    "2020": 0.81579,
    "2021": 0.81223,
    "2022": 0.80939,
    "2023": 0.80554,
    "2024": 0.80306,
    "GeoAreaCode": 520,
    "GeoAreaName": "Nauru"
  },
  {
    "2000": 0.84871,
    "2001": 0.84852,
    "2002": 0.84821,
    "2003": 0.84808,
    "2004": 0.84804,
    "2005": 0.84796,
    "2006": 0.84806,
    "2007": 0.84799,
    "2008": 0.84802,
    "2009": 0.84803,
    "2010": 0.84796,
    "2011": 0.84796,
    "2012": 0.84793,
    "2013": 0.84789,
    "2014": 0.84791,
    "2015": 0.84763,
    "2016": 0.84757,
    "2017": 0.84741,
    "2018": 0.84735,
    "2019": 0.8472,
    "2020": 0.84708,
    "2021": 0.84699,
    "2022": 0.84674,
    "2023": 0.84667,
    "2024": 0.8467,
    "GeoAreaCode": 524,
    "GeoAreaName": "Nepal"
  },
  {
    "2000": 0.94622,
    "2001": 0.94289,
    "2002": 0.94016,
    "2003": 0.93754,
    "2004": 0.93519,
    "2005": 0.93349,
    "2006": 0.93177,
    "2007": 0.93024,
    "2008": 0.92888,
    "2009": 0.92759,
    "2010": 0.92625,
    "2011": 0.92495,
    "2012": 0.92343,
    "2013": 0.92196,
    "2014": 0.92067,
    "2015": 0.91921,
    "2016": 0.91761,
    "2017": 0.91627,
    "2018": 0.9146,
    "2019": 0.9128,
    "2020": 0.91195,
    "2021": 0.91072,
    "2022": 0.90918,
    "2023": 0.90779,
    "2024": 0.90634,
    "GeoAreaCode": 528,
    "GeoAreaName": "Netherlands"
  },
  {
    "2000": 0.70301,
    "2001": 0.69979,
    "2002": 0.69691,
    "2003": 0.69384,
    "2004": 0.69055,
    "2005": 0.68796,
    "2006": 0.68471,
    "2007": 0.6814,
    "2008": 0.67907,
    "2009": 0.67616,
    "2010": 0.67354,
    "2011": 0.67082,
    "2012": 0.66691,
    "2013": 0.66412,
    "2014": 0.66089,
    "2015": 0.65799,
    "2016": 0.65527,
    "2017": 0.65257,
    "2018": 0.6482,
    "2019": 0.6461,
    "2020": 0.64241,
    "2021": 0.63965,
    "2022": 0.63688,
    "2023": 0.63323,
    "2024": 0.63076,
    "GeoAreaCode": 540,
    "GeoAreaName": "New Caledonia"
  },
  {
    "2000": 0.70336,
    "2001": 0.69913,
    "2002": 0.69472,
    "2003": 0.69124,
    "2004": 0.6876,
    "2005": 0.68475,
    "2006": 0.68214,
    "2007": 0.67994,
    "2008": 0.67797,
    "2009": 0.67587,
    "2010": 0.67347,
    "2011": 0.67122,
    "2012": 0.66893,
    "2013": 0.66648,
    "2014": 0.66405,
    "2015": 0.66141,
    "2016": 0.65934,
    "2017": 0.65628,
    "2018": 0.65399,
    "2019": 0.65103,
    "2020": 0.6478,
    "2021": 0.64568,
    "2022": 0.64326,
    "2023": 0.64031,
    "2024": 0.63792,
    "GeoAreaCode": 554,
    "GeoAreaName": "New Zealand"
  },
  {
    "2000": 0.8704,
    "2001": 0.86901,
    "2002": 0.86758,
    "2003": 0.86601,
    "2004": 0.86457,
    "2005": 0.86262,
    "2006": 0.86029,
    "2007": 0.85821,
    "2008": 0.85583,
    "2009": 0.85365,
    "2010": 0.85138,
    "2011": 0.84932,
    "2012": 0.84687,
    "2013": 0.84457,
    "2014": 0.84225,
    "2015": 0.84021,
    "2016": 0.83754,
    "2017": 0.83508,
    "2018": 0.83293,
    "2019": 0.8299,
    "2020": 0.8276,
    "2021": 0.82493,
    "2022": 0.82291,
    "2023": 0.82039,
    "2024": 0.81792,
    "GeoAreaCode": 558,
    "GeoAreaName": "Nicaragua"
  },
  {
    "2000": 0.95257,
    "2001": 0.95157,
    "2002": 0.95036,
    "2003": 0.94929,
    "2004": 0.94816,
    "2005": 0.94695,
    "2006": 0.94596,
    "2007": 0.94487,
    "2008": 0.94397,
    "2009": 0.94289,
    "2010": 0.94177,
    "2011": 0.94067,
    "2012": 0.93947,
    "2013": 0.93829,
    "2014": 0.93749,
    "2015": 0.93647,
    "2016": 0.93527,
    "2017": 0.93449,
    "2018": 0.93369,
    "2019": 0.93276,
    "2020": 0.93174,
    "2021": 0.93093,
    "2022": 0.93016,
    "2023": 0.92901,
    "2024": 0.92867,
    "GeoAreaCode": 562,
    "GeoAreaName": "Niger"
  },
  {
    "2000": 0.85955,
    "2001": 0.85942,
    "2002": 0.85932,
    "2003": 0.85906,
    "2004": 0.85894,
    "2005": 0.85868,
    "2006": 0.85842,
    "2007": 0.85803,
    "2008": 0.85776,
    "2009": 0.85736,
    "2010": 0.85708,
    "2011": 0.85682,
    "2012": 0.85651,
    "2013": 0.85634,
    "2014": 0.85611,
    "2015": 0.85582,
    "2016": 0.85569,
    "2017": 0.85547,
    "2018": 0.85524,
    "2019": 0.855,
    "2020": 0.85486,
    "2021": 0.85472,
    "2022": 0.85447,
    "2023": 0.85426,
    "2024": 0.85403,
    "GeoAreaCode": 566,
    "GeoAreaName": "Nigeria"
  },
  {
    "2000": 0.77464,
    "2001": 0.78473,
    "2002": 0.80611,
    "2003": 0.82643,
    "2004": 0.83752,
    "2005": 0.8408,
    "2006": 0.84157,
    "2007": 0.8395,
    "2008": 0.83757,
    "2009": 0.83533,
    "2010": 0.83301,
    "2011": 0.8314,
    "2012": 0.82901,
    "2013": 0.82737,
    "2014": 0.82495,
    "2015": 0.82263,
    "2016": 0.8203,
    "2017": 0.81842,
    "2018": 0.81618,
    "2019": 0.81439,
    "2020": 0.81268,
    "2021": 0.81025,
    "2022": 0.80783,
    "2023": 0.80545,
    "2024": 0.80411,
    "GeoAreaCode": 570,
    "GeoAreaName": "Niue"
  },
  {
    "2000": 0.75773,
    "2001": 0.75502,
    "2002": 0.7511,
    "2003": 0.74832,
    "2004": 0.74498,
    "2005": 0.74246,
    "2006": 0.74018,
    "2007": 0.73618,
    "2008": 0.73361,
    "2009": 0.73069,
    "2010": 0.72744,
    "2011": 0.72497,
    "2012": 0.72039,
    "2013": 0.71683,
    "2014": 0.71494,
    "2015": 0.71032,
    "2016": 0.7079,
    "2017": 0.70385,
    "2018": 0.69948,
    "2019": 0.69746,
    "2020": 0.69252,
    "2021": 0.69176,
    "2022": 0.68804,
    "2023": 0.68438,
    "2024": 0.68102,
    "GeoAreaCode": 574,
    "GeoAreaName": "Norfolk Island"
  },
  {
    "2000": 0.93833,
    "2001": 0.93819,
    "2002": 0.93804,
    "2003": 0.93754,
    "2004": 0.93709,
    "2005": 0.93645,
    "2006": 0.93566,
    "2007": 0.93487,
    "2008": 0.93408,
    "2009": 0.93406,
    "2010": 0.93289,
    "2011": 0.93249,
    "2012": 0.93169,
    "2013": 0.93091,
    "2014": 0.93059,
    "2015": 0.92996,
    "2016": 0.92974,
    "2017": 0.92896,
    "2018": 0.92811,
    "2019": 0.92736,
    "2020": 0.92652,
    "2021": 0.92574,
    "2022": 0.92494,
    "2023": 0.92423,
    "2024": 0.92363,
    "GeoAreaCode": 807,
    "GeoAreaName": "North Macedonia"
  },
  {
    "2000": 0.92731,
    "2001": 0.92459,
    "2002": 0.92194,
    "2003": 0.91925,
    "2004": 0.91673,
    "2005": 0.91375,
    "2006": 0.91126,
    "2007": 0.90787,
    "2008": 0.90545,
    "2009": 0.9026,
    "2010": 0.89981,
    "2011": 0.89657,
    "2012": 0.89401,
    "2013": 0.89092,
    "2014": 0.88831,
    "2015": 0.88546,
    "2016": 0.88222,
    "2017": 0.87942,
    "2018": 0.8767,
    "2019": 0.87353,
    "2020": 0.87063,
    "2021": 0.86862,
    "2022": 0.86558,
    "2023": 0.86298,
    "2024": 0.86003,
    "GeoAreaCode": 15,
    "GeoAreaName": "Northern Africa"
  },
  {
    "2000": 0.90066,
    "2001": 0.89775,
    "2002": 0.89475,
    "2003": 0.89219,
    "2004": 0.88901,
    "2005": 0.88629,
    "2006": 0.88324,
    "2007": 0.88014,
    "2008": 0.87708,
    "2009": 0.87442,
    "2010": 0.8718,
    "2011": 0.86838,
    "2012": 0.8656,
    "2013": 0.86235,
    "2014": 0.86012,
    "2015": 0.85659,
    "2016": 0.8536,
    "2017": 0.85105,
    "2018": 0.84797,
    "2019": 0.84502,
    "2020": 0.84223,
    "2021": 0.83969,
    "2022": 0.83638,
    "2023": 0.83405,
    "2024": 0.83105,
    "GeoAreaCode": 747,
    "GeoAreaName": "Northern Africa and Western Asia"
  },
  {
    "2000": 0.85893,
    "2001": 0.85795,
    "2002": 0.85698,
    "2003": 0.85592,
    "2004": 0.85503,
    "2005": 0.85416,
    "2006": 0.85303,
    "2007": 0.85192,
    "2008": 0.8511,
    "2009": 0.85031,
    "2010": 0.84947,
    "2011": 0.84868,
    "2012": 0.84791,
    "2013": 0.84697,
    "2014": 0.84617,
    "2015": 0.84503,
    "2016": 0.84422,
    "2017": 0.84347,
    "2018": 0.8426,
    "2019": 0.84201,
    "2020": 0.84103,
    "2021": 0.84026,
    "2022": 0.8395,
    "2023": 0.83841,
    "2024": 0.83766,
    "GeoAreaCode": 21,
    "GeoAreaName": "Northern America"
  },
  {
    "2000": 0.67008,
    "2001": 0.66383,
    "2002": 0.65685,
    "2003": 0.651,
    "2004": 0.64639,
    "2005": 0.6416,
    "2006": 0.63704,
    "2007": 0.63411,
    "2008": 0.6311,
    "2009": 0.62851,
    "2010": 0.62511,
    "2011": 0.62204,
    "2012": 0.6186,
    "2013": 0.61467,
    "2014": 0.61174,
    "2015": 0.60741,
    "2016": 0.60451,
    "2017": 0.5997,
    "2018": 0.59537,
    "2019": 0.59233,
    "2020": 0.58874,
    "2021": 0.5852,
    "2022": 0.58016,
    "2023": 0.57758,
    "2024": 0.57418,
    "GeoAreaCode": 580,
    "GeoAreaName": "Northern Mariana Islands"
  },
  {
    "2000": 0.95619,
    "2001": 0.95563,
    "2002": 0.95504,
    "2003": 0.95467,
    "2004": 0.95443,
    "2005": 0.95419,
    "2006": 0.95395,
    "2007": 0.95389,
    "2008": 0.95372,
    "2009": 0.9536,
    "2010": 0.95342,
    "2011": 0.95313,
    "2012": 0.9527,
    "2013": 0.9522,
    "2014": 0.95172,
    "2015": 0.95132,
    "2016": 0.95099,
    "2017": 0.95074,
    "2018": 0.95059,
    "2019": 0.95051,
    "2020": 0.9504,
    "2021": 0.95032,
    "2022": 0.95019,
    "2023": 0.95015,
    "2024": 0.95004,
    "GeoAreaCode": 578,
    "GeoAreaName": "Norway"
  },
  {
    "2000": 0.86624,
    "2001": 0.86284,
    "2002": 0.85998,
    "2003": 0.85668,
    "2004": 0.85366,
    "2005": 0.85026,
    "2006": 0.84709,
    "2007": 0.84421,
    "2008": 0.84137,
    "2009": 0.83843,
    "2010": 0.83549,
    "2011": 0.83257,
    "2012": 0.82887,
    "2013": 0.82572,
    "2014": 0.82256,
    "2015": 0.81942,
    "2016": 0.81597,
    "2017": 0.81228,
    "2018": 0.80955,
    "2019": 0.80608,
    "2020": 0.8035,
    "2021": 0.79982,
    "2022": 0.79605,
    "2023": 0.79326,
    "2024": 0.78993,
    "GeoAreaCode": 9,
    "GeoAreaName": "Oceania"
  },
  {
    "2000": 0.86235,
    "2001": 0.85824,
    "2002": 0.85471,
    "2003": 0.85097,
    "2004": 0.8472,
    "2005": 0.84327,
    "2006": 0.83964,
    "2007": 0.8356,
    "2008": 0.83186,
    "2009": 0.82836,
    "2010": 0.8251,
    "2011": 0.82129,
    "2012": 0.81731,
    "2013": 0.81321,
    "2014": 0.80884,
    "2015": 0.80521,
    "2016": 0.80124,
    "2017": 0.7972,
    "2018": 0.79349,
    "2019": 0.78964,
    "2020": 0.78499,
    "2021": 0.78173,
    "2022": 0.77729,
    "2023": 0.77315,
    "2024": 0.7697,
    "GeoAreaCode": 543,
    "GeoAreaName": "Oceania (exc. Australia and New Zealand)"
  },
  {
    "2000": 0.93862,
    "2001": 0.93616,
    "2002": 0.93364,
    "2003": 0.93061,
    "2004": 0.92827,
    "2005": 0.926,
    "2006": 0.92268,
    "2007": 0.92086,
    "2008": 0.9181,
    "2009": 0.91499,
    "2010": 0.9135,
    "2011": 0.91108,
    "2012": 0.90861,
    "2013": 0.9063,
    "2014": 0.90389,
    "2015": 0.90202,
    "2016": 0.89953,
    "2017": 0.89788,
    "2018": 0.89477,
    "2019": 0.89232,
    "2020": 0.8893,
    "2021": 0.88793,
    "2022": 0.88535,
    "2023": 0.88414,
    "2024": 0.88146,
    "GeoAreaCode": 512,
    "GeoAreaName": "Oman"
  },
  {
    "2000": 0.92143,
    "2001": 0.91579,
    "2002": 0.91134,
    "2003": 0.90776,
    "2004": 0.90371,
    "2005": 0.89857,
    "2006": 0.89495,
    "2007": 0.89027,
    "2008": 0.88735,
    "2009": 0.88379,
    "2010": 0.87944,
    "2011": 0.87597,
    "2012": 0.8716,
    "2013": 0.86732,
    "2014": 0.86257,
    "2015": 0.85831,
    "2016": 0.85415,
    "2017": 0.84928,
    "2018": 0.84516,
    "2019": 0.84147,
    "2020": 0.83639,
    "2021": 0.83203,
    "2022": 0.82858,
    "2023": 0.82436,
    "2024": 0.81979,
    "GeoAreaCode": 586,
    "GeoAreaName": "Pakistan"
  },
  {
    "2000": 0.88515,
    "2001": 0.87666,
    "2002": 0.866,
    "2003": 0.85892,
    "2004": 0.84995,
    "2005": 0.84119,
    "2006": 0.83089,
    "2007": 0.82155,
    "2008": 0.81133,
    "2009": 0.80096,
    "2010": 0.79055,
    "2011": 0.78161,
    "2012": 0.77228,
    "2013": 0.76289,
    "2014": 0.75353,
    "2015": 0.74409,
    "2016": 0.73536,
    "2017": 0.72623,
    "2018": 0.71488,
    "2019": 0.70625,
    "2020": 0.69469,
    "2021": 0.68614,
    "2022": 0.67486,
    "2023": 0.66509,
    "2024": 0.65483,
    "GeoAreaCode": 585,
    "GeoAreaName": "Palau"
  },
  {
    "2000": 0.74547,
    "2001": 0.74387,
    "2002": 0.74259,
    "2003": 0.74135,
    "2004": 0.7403,
    "2005": 0.73906,
    "2006": 0.73793,
    "2007": 0.73717,
    "2008": 0.7362,
    "2009": 0.73514,
    "2010": 0.73414,
    "2011": 0.73288,
    "2012": 0.73181,
    "2013": 0.73051,
    "2014": 0.72964,
    "2015": 0.72807,
    "2016": 0.72697,
    "2017": 0.72581,
    "2018": 0.72456,
    "2019": 0.72324,
    "2020": 0.72209,
    "2021": 0.72113,
    "2022": 0.72004,
    "2023": 0.71905,
    "2024": 0.7176,
    "GeoAreaCode": 591,
    "GeoAreaName": "Panama"
  },
  {
    "2000": 0.90016,
    "2001": 0.8966,
    "2002": 0.89372,
    "2003": 0.88984,
    "2004": 0.88708,
    "2005": 0.88343,
    "2006": 0.88019,
    "2007": 0.87698,
    "2008": 0.87375,
    "2009": 0.87106,
    "2010": 0.86816,
    "2011": 0.86459,
    "2012": 0.86077,
    "2013": 0.85775,
    "2014": 0.85381,
    "2015": 0.85067,
    "2016": 0.84683,
    "2017": 0.84282,
    "2018": 0.83944,
    "2019": 0.83637,
    "2020": 0.83291,
    "2021": 0.8286,
    "2022": 0.82591,
    "2023": 0.82248,
    "2024": 0.81862,
    "GeoAreaCode": 598,
    "GeoAreaName": "Papua New Guinea"
  },
  {
    "2000": 0.95179,
    "2001": 0.95166,
    "2002": 0.9515,
    "2003": 0.95147,
    "2004": 0.95153,
    "2005": 0.95153,
    "2006": 0.95163,
    "2007": 0.95168,
    "2008": 0.95168,
    "2009": 0.95181,
    "2010": 0.95176,
    "2011": 0.95173,
    "2012": 0.95167,
    "2013": 0.95166,
    "2014": 0.95162,
    "2015": 0.95153,
    "2016": 0.95155,
    "2017": 0.95148,
    "2018": 0.95148,
    "2019": 0.95146,
    "2020": 0.95143,
    "2021": 0.95144,
    "2022": 0.95144,
    "2023": 0.95141,
    "2024": 0.95141,
    "GeoAreaCode": 600,
    "GeoAreaName": "Paraguay"
  },
  {
    "2000": 0.74143,
    "2001": 0.74115,
    "2002": 0.74084,
    "2003": 0.7405,
    "2004": 0.74026,
    "2005": 0.74014,
    "2006": 0.74001,
    "2007": 0.74004,
    "2008": 0.73985,
    "2009": 0.73972,
    "2010": 0.73953,
    "2011": 0.73928,
    "2012": 0.7391,
    "2013": 0.73901,
    "2014": 0.73897,
    "2015": 0.73891,
    "2016": 0.7388,
    "2017": 0.73875,
    "2018": 0.73874,
    "2019": 0.73867,
    "2020": 0.73866,
    "2021": 0.73859,
    "2022": 0.7386,
    "2023": 0.73853,
    "2024": 0.73849,
    "GeoAreaCode": 604,
    "GeoAreaName": "Peru"
  },
  {
    "2000": 0.75458,
    "2001": 0.75106,
    "2002": 0.74695,
    "2003": 0.7431,
    "2004": 0.74007,
    "2005": 0.73572,
    "2006": 0.73167,
    "2007": 0.72832,
    "2008": 0.72547,
    "2009": 0.72203,
    "2010": 0.7191,
    "2011": 0.71544,
    "2012": 0.71202,
    "2013": 0.70828,
    "2014": 0.70497,
    "2015": 0.70104,
    "2016": 0.69673,
    "2017": 0.69329,
    "2018": 0.68873,
    "2019": 0.68533,
    "2020": 0.68198,
    "2021": 0.67761,
    "2022": 0.67374,
    "2023": 0.67057,
    "2024": 0.66782,
    "GeoAreaCode": 608,
    "GeoAreaName": "Philippines"
  },
  {
    "2000": 0.80051,
    "2001": 0.79568,
    "2002": 0.79191,
    "2003": 0.7871,
    "2004": 0.78357,
    "2005": 0.77867,
    "2006": 0.77445,
    "2007": 0.77107,
    "2008": 0.76764,
    "2009": 0.76386,
    "2010": 0.76042,
    "2011": 0.7556,
    "2012": 0.75169,
    "2013": 0.74721,
    "2014": 0.7431,
    "2015": 0.73951,
    "2016": 0.73472,
    "2017": 0.73082,
    "2018": 0.7258,
    "2019": 0.72281,
    "2020": 0.71779,
    "2021": 0.71454,
    "2022": 0.70958,
    "2023": 0.70604,
    "2024": 0.7016,
    "GeoAreaCode": 612,
    "GeoAreaName": "Pitcairn"
  },
  {
    "2000": 0.95201,
    "2001": 0.95301,
    "2002": 0.95402,
    "2003": 0.95502,
    "2004": 0.95599,
    "2005": 0.957,
    "2006": 0.95793,
    "2007": 0.95886,
    "2008": 0.95964,
    "2009": 0.96001,
    "2010": 0.96099,
    "2011": 0.96207,
    "2012": 0.9632,
    "2013": 0.96456,
    "2014": 0.96608,
    "2015": 0.96749,
    "2016": 0.96874,
    "2017": 0.96982,
    "2018": 0.97093,
    "2019": 0.97193,
    "2020": 0.97308,
    "2021": 0.97378,
    "2022": 0.97491,
    "2023": 0.97557,
    "2024": 0.97614,
    "GeoAreaCode": 616,
    "GeoAreaName": "Poland"
  },
  {
    "2000": 0.90297,
    "2001": 0.90232,
    "2002": 0.90168,
    "2003": 0.90097,
    "2004": 0.90044,
    "2005": 0.89986,
    "2006": 0.8994,
    "2007": 0.89914,
    "2008": 0.89946,
    "2009": 0.89985,
    "2010": 0.90062,
    "2011": 0.90155,
    "2012": 0.90226,
    "2013": 0.90254,
    "2014": 0.90228,
    "2015": 0.90174,
    "2016": 0.90115,
    "2017": 0.90062,
    "2018": 0.90015,
    "2019": 0.89945,
    "2020": 0.899,
    "2021": 0.89852,
    "2022": 0.89818,
    "2023": 0.89786,
    "2024": 0.89737,
    "GeoAreaCode": 620,
    "GeoAreaName": "Portugal"
  },
  {
    "2000": 0.71182,
    "2001": 0.70998,
    "2002": 0.70818,
    "2003": 0.70658,
    "2004": 0.70523,
    "2005": 0.70407,
    "2006": 0.70312,
    "2007": 0.70243,
    "2008": 0.70172,
    "2009": 0.70109,
    "2010": 0.7003,
    "2011": 0.69943,
    "2012": 0.69892,
    "2013": 0.69793,
    "2014": 0.69704,
    "2015": 0.69629,
    "2016": 0.69471,
    "2017": 0.69334,
    "2018": 0.69109,
    "2019": 0.68959,
    "2020": 0.6881,
    "2021": 0.68629,
    "2022": 0.68543,
    "2023": 0.68462,
    "2024": 0.68419,
    "GeoAreaCode": 630,
    "GeoAreaName": "Puerto Rico"
  },
  {
    "2000": 0.90865,
    "2001": 0.9036,
    "2002": 0.89882,
    "2003": 0.89539,
    "2004": 0.89036,
    "2005": 0.88669,
    "2006": 0.88294,
    "2007": 0.87839,
    "2008": 0.87519,
    "2009": 0.87172,
    "2010": 0.86777,
    "2011": 0.86365,
    "2012": 0.85989,
    "2013": 0.85574,
    "2014": 0.85207,
    "2015": 0.84703,
    "2016": 0.8442,
    "2017": 0.84041,
    "2018": 0.83568,
    "2019": 0.83216,
    "2020": 0.82918,
    "2021": 0.82579,
    "2022": 0.82098,
    "2023": 0.81683,
    "2024": 0.8131,
    "GeoAreaCode": 634,
    "GeoAreaName": "Qatar"
  },
  {
    "2000": 0.78776,
    "2001": 0.78391,
    "2002": 0.78037,
    "2003": 0.7766,
    "2004": 0.77266,
    "2005": 0.76728,
    "2006": 0.76243,
    "2007": 0.75736,
    "2008": 0.75194,
    "2009": 0.74729,
    "2010": 0.74291,
    "2011": 0.7375,
    "2012": 0.73422,
    "2013": 0.72859,
    "2014": 0.7238,
    "2015": 0.7195,
    "2016": 0.71519,
    "2017": 0.71034,
    "2018": 0.7066,
    "2019": 0.70088,
    "2020": 0.6969,
    "2021": 0.69208,
    "2022": 0.68631,
    "2023": 0.6838,
    "2024": 0.67826,
    "GeoAreaCode": 410,
    "GeoAreaName": "Republic of Korea"
  },
  {
    "2000": 0.96585,
    "2001": 0.96585,
    "2002": 0.96602,
    "2003": 0.96607,
    "2004": 0.96623,
    "2005": 0.96646,
    "2006": 0.96654,
    "2007": 0.96682,
    "2008": 0.96724,
    "2009": 0.96739,
    "2010": 0.96758,
    "2011": 0.96801,
    "2012": 0.96842,
    "2013": 0.96881,
    "2014": 0.9693,
    "2015": 0.96982,
    "2016": 0.97034,
    "2017": 0.97062,
    "2018": 0.97084,
    "2019": 0.9711,
    "2020": 0.97128,
    "2021": 0.97149,
    "2022": 0.97174,
    "2023": 0.97197,
    "2024": 0.97225,
    "GeoAreaCode": 498,
    "GeoAreaName": "Moldova"
  },
  {
    "2000": 0.68546,
    "2001": 0.67861,
    "2002": 0.67138,
    "2003": 0.66488,
    "2004": 0.65854,
    "2005": 0.65336,
    "2006": 0.64738,
    "2007": 0.64476,
    "2008": 0.63996,
    "2009": 0.63618,
    "2010": 0.62962,
    "2011": 0.62541,
    "2012": 0.61932,
    "2013": 0.61286,
    "2014": 0.60504,
    "2015": 0.59963,
    "2016": 0.59304,
    "2017": 0.58705,
    "2018": 0.58194,
    "2019": 0.57622,
    "2020": 0.56926,
    "2021": 0.56323,
    "2022": 0.55884,
    "2023": 0.55334,
    "2024": 0.54535,
    "GeoAreaCode": 638,
    "GeoAreaName": "Réunion"
  },
  {
    "2000": 0.88813,
    "2001": 0.88793,
    "2002": 0.88781,
    "2003": 0.88776,
    "2004": 0.88756,
    "2005": 0.8874,
    "2006": 0.88721,
    "2007": 0.88705,
    "2008": 0.88689,
    "2009": 0.88677,
    "2010": 0.8866,
    "2011": 0.88659,
    "2012": 0.88649,
    "2013": 0.8866,
    "2014": 0.88691,
    "2015": 0.88713,
    "2016": 0.8873,
    "2017": 0.88723,
    "2018": 0.88711,
    "2019": 0.88686,
    "2020": 0.88662,
    "2021": 0.88642,
    "2022": 0.88615,
    "2023": 0.88604,
    "2024": 0.88585,
    "GeoAreaCode": 642,
    "GeoAreaName": "Romania"
  },
  {
    "2000": 0.9534,
    "2001": 0.95286,
    "2002": 0.95241,
    "2003": 0.95192,
    "2004": 0.9515,
    "2005": 0.95087,
    "2006": 0.95039,
    "2007": 0.94993,
    "2008": 0.94944,
    "2009": 0.94901,
    "2010": 0.94861,
    "2011": 0.94826,
    "2012": 0.94805,
    "2013": 0.94778,
    "2014": 0.94758,
    "2015": 0.9474,
    "2016": 0.94724,
    "2017": 0.94706,
    "2018": 0.94685,
    "2019": 0.94667,
    "2020": 0.94656,
    "2021": 0.9463,
    "2022": 0.9461,
    "2023": 0.94596,
    "2024": 0.94576,
    "GeoAreaCode": 643,
    "GeoAreaName": "Russian Federation"
  },
  {
    "2000": 0.88638,
    "2001": 0.88637,
    "2002": 0.88635,
    "2003": 0.88634,
    "2004": 0.88633,
    "2005": 0.8863,
    "2006": 0.88628,
    "2007": 0.88626,
    "2008": 0.88625,
    "2009": 0.88623,
    "2010": 0.88622,
    "2011": 0.88621,
    "2012": 0.88619,
    "2013": 0.88618,
    "2014": 0.88618,
    "2015": 0.88618,
    "2016": 0.88617,
    "2017": 0.88616,
    "2018": 0.88616,
    "2019": 0.88615,
    "2020": 0.88615,
    "2021": 0.88615,
    "2022": 0.88615,
    "2023": 0.88615,
    "2024": 0.88615,
    "GeoAreaCode": 646,
    "GeoAreaName": "Rwanda"
  },
  {
    "2000": 0.96323,
    "2001": 0.96255,
    "2002": 0.96255,
    "2003": 0.96255,
    "2004": 0.96255,
    "2005": 0.96433,
    "2006": 0.96668,
    "2007": 0.96917,
    "2008": 0.9716,
    "2009": 0.97364,
    "2010": 0.97398,
    "2011": 0.97426,
    "2012": 0.97446,
    "2013": 0.97462,
    "2014": 0.97479,
    "2015": 0.97494,
    "2016": 0.97512,
    "2017": 0.97539,
    "2018": 0.97559,
    "2019": 0.97564,
    "2020": 0.97596,
    "2021": 0.97624,
    "2022": 0.97653,
    "2023": 0.97688,
    "2024": 0.97728,
    "GeoAreaCode": 652,
    "GeoAreaName": "Saint Barthélemy"
  },
  {
    "2000": 0.6313,
    "2001": 0.63036,
    "2002": 0.62958,
    "2003": 0.62952,
    "2004": 0.63023,
    "2005": 0.63157,
    "2006": 0.63365,
    "2007": 0.63695,
    "2008": 0.63931,
    "2009": 0.64054,
    "2010": 0.6415,
    "2011": 0.64214,
    "2012": 0.6426,
    "2013": 0.64329,
    "2014": 0.64359,
    "2015": 0.64404,
    "2016": 0.64407,
    "2017": 0.64313,
    "2018": 0.64298,
    "2019": 0.64227,
    "2020": 0.64169,
    "2021": 0.64152,
    "2022": 0.64157,
    "2023": 0.64172,
    "2024": 0.64217,
    "GeoAreaCode": 654,
    "GeoAreaName": "Saint Helena"
  },
  {
    "2000": 0.49133,
    "2001": 0.49,
    "2002": 0.48831,
    "2003": 0.48677,
    "2004": 0.48502,
    "2005": 0.48353,
    "2006": 0.48203,
    "2007": 0.48033,
    "2008": 0.47888,
    "2009": 0.47734,
    "2010": 0.47581,
    "2011": 0.474,
    "2012": 0.47247,
    "2013": 0.47092,
    "2014": 0.46957,
    "2015": 0.46764,
    "2016": 0.46611,
    "2017": 0.46424,
    "2018": 0.4632,
    "2019": 0.4613,
    "2020": 0.45983,
    "2021": 0.4583,
    "2022": 0.45649,
    "2023": 0.45477,
    "2024": 0.45295,
    "GeoAreaCode": 659,
    "GeoAreaName": "Saint Kitts and Nevis"
  },
  {
    "2000": 0.81072,
    "2001": 0.80915,
    "2002": 0.80804,
    "2003": 0.8063,
    "2004": 0.8049,
    "2005": 0.80383,
    "2006": 0.80244,
    "2007": 0.8009,
    "2008": 0.79983,
    "2009": 0.79838,
    "2010": 0.79702,
    "2011": 0.79552,
    "2012": 0.79413,
    "2013": 0.79245,
    "2014": 0.79108,
    "2015": 0.78961,
    "2016": 0.78825,
    "2017": 0.78693,
    "2018": 0.78528,
    "2019": 0.7839,
    "2020": 0.78207,
    "2021": 0.78081,
    "2022": 0.77899,
    "2023": 0.77785,
    "2024": 0.77613,
    "GeoAreaCode": 662,
    "GeoAreaName": "Saint Lucia"
  },
  {
    "2000": 0.95805,
    "2001": 0.95606,
    "2002": 0.95494,
    "2003": 0.95335,
    "2004": 0.95196,
    "2005": 0.95102,
    "2006": 0.94982,
    "2007": 0.94874,
    "2008": 0.94739,
    "2009": 0.94604,
    "2010": 0.94436,
    "2011": 0.94371,
    "2012": 0.94183,
    "2013": 0.94033,
    "2014": 0.93889,
    "2015": 0.93744,
    "2016": 0.93526,
    "2017": 0.93468,
    "2018": 0.93254,
    "2019": 0.93096,
    "2020": 0.9294,
    "2021": 0.92799,
    "2022": 0.92644,
    "2023": 0.92507,
    "2024": 0.92348,
    "GeoAreaCode": 663,
    "GeoAreaName": "Saint Martin (French Part)"
  },
  {
    "2000": 0.88455,
    "2001": 0.8843,
    "2002": 0.88447,
    "2003": 0.88437,
    "2004": 0.88413,
    "2005": 0.88357,
    "2006": 0.88321,
    "2007": 0.88242,
    "2008": 0.88209,
    "2009": 0.8813,
    "2010": 0.88056,
    "2011": 0.88027,
    "2012": 0.87886,
    "2013": 0.87864,
    "2014": 0.87727,
    "2015": 0.87711,
    "2016": 0.87645,
    "2017": 0.87636,
    "2018": 0.87653,
    "2019": 0.87666,
    "2020": 0.87675,
    "2021": 0.87719,
    "2022": 0.87679,
    "2023": 0.87716,
    "2024": 0.87749,
    "GeoAreaCode": 666,
    "GeoAreaName": "Saint Pierre and Miquelon"
  },
  {
    "2000": 0.7662,
    "2001": 0.7649,
    "2002": 0.76392,
    "2003": 0.76288,
    "2004": 0.76161,
    "2005": 0.76063,
    "2006": 0.7598,
    "2007": 0.75921,
    "2008": 0.75821,
    "2009": 0.75744,
    "2010": 0.75662,
    "2011": 0.75572,
    "2012": 0.75465,
    "2013": 0.75338,
    "2014": 0.7522,
    "2015": 0.75126,
    "2016": 0.75005,
    "2017": 0.74907,
    "2018": 0.74802,
    "2019": 0.74661,
    "2020": 0.7456,
    "2021": 0.74453,
    "2022": 0.74374,
    "2023": 0.74225,
    "2024": 0.74161,
    "GeoAreaCode": 670,
    "GeoAreaName": "Saint Vincent and the Grenadines"
  },
  {
    "2000": 0.79065,
    "2001": 0.78956,
    "2002": 0.78853,
    "2003": 0.78778,
    "2004": 0.78645,
    "2005": 0.78543,
    "2006": 0.78491,
    "2007": 0.78401,
    "2008": 0.78317,
    "2009": 0.78153,
    "2010": 0.78127,
    "2011": 0.77808,
    "2012": 0.77716,
    "2013": 0.7753,
    "2014": 0.7746,
    "2015": 0.77269,
    "2016": 0.77175,
    "2017": 0.76962,
    "2018": 0.76885,
    "2019": 0.76666,
    "2020": 0.7662,
    "2021": 0.76434,
    "2022": 0.7623,
    "2023": 0.76245,
    "2024": 0.75995,
    "GeoAreaCode": 882,
    "GeoAreaName": "Samoa"
  },
  {
    "2000": 0.91675,
    "2001": 0.91675,
    "2002": 0.91675,
    "2003": 0.91675,
    "2004": 0.91675,
    "2005": 0.91266,
    "2006": 0.90855,
    "2007": 0.90445,
    "2008": 0.90032,
    "2009": 0.89624,
    "2010": 0.89218,
    "2011": 0.88812,
    "2012": 0.88409,
    "2013": 0.88043,
    "2014": 0.87665,
    "2015": 0.87324,
    "2016": 0.86913,
    "2017": 0.86507,
    "2018": 0.86094,
    "2019": 0.85678,
    "2020": 0.85263,
    "2021": 0.8485,
    "2022": 0.84443,
    "2023": 0.84158,
    "2024": 0.83789,
    "GeoAreaCode": 674,
    "GeoAreaName": "San Marino"
  },
  {
    "2000": 0.78435,
    "2001": 0.78454,
    "2002": 0.78432,
    "2003": 0.78458,
    "2004": 0.78474,
    "2005": 0.78645,
    "2006": 0.7884,
    "2007": 0.79051,
    "2008": 0.79197,
    "2009": 0.79451,
    "2010": 0.79457,
    "2011": 0.79457,
    "2012": 0.7946,
    "2013": 0.7946,
    "2014": 0.7946,
    "2015": 0.79461,
    "2016": 0.79461,
    "2017": 0.79461,
    "2018": 0.79462,
    "2019": 0.79463,
    "2020": 0.79464,
    "2021": 0.79464,
    "2022": 0.79466,
    "2023": 0.79467,
    "2024": 0.79467,
    "GeoAreaCode": 678,
    "GeoAreaName": "Sao Tome and Principe"
  },
  {
    "2000": 0.95242,
    "2001": 0.94987,
    "2002": 0.94713,
    "2003": 0.94477,
    "2004": 0.94243,
    "2005": 0.94002,
    "2006": 0.93712,
    "2007": 0.93488,
    "2008": 0.93196,
    "2009": 0.92912,
    "2010": 0.92729,
    "2011": 0.92488,
    "2012": 0.92263,
    "2013": 0.91976,
    "2014": 0.91736,
    "2015": 0.91545,
    "2016": 0.91329,
    "2017": 0.90988,
    "2018": 0.90749,
    "2019": 0.9054,
    "2020": 0.90235,
    "2021": 0.9002,
    "2022": 0.89764,
    "2023": 0.89508,
    "2024": 0.89265,
    "GeoAreaCode": 682,
    "GeoAreaName": "Saudi Arabia"
  },
  {
    "2000": 0.94824,
    "2001": 0.94745,
    "2002": 0.94702,
    "2003": 0.94622,
    "2004": 0.94571,
    "2005": 0.94493,
    "2006": 0.94425,
    "2007": 0.9435,
    "2008": 0.94287,
    "2009": 0.94219,
    "2010": 0.94157,
    "2011": 0.94091,
    "2012": 0.94025,
    "2013": 0.93955,
    "2014": 0.93896,
    "2015": 0.93826,
    "2016": 0.93767,
    "2017": 0.93695,
    "2018": 0.93651,
    "2019": 0.9359,
    "2020": 0.93519,
    "2021": 0.93446,
    "2022": 0.93402,
    "2023": 0.93352,
    "2024": 0.93278,
    "GeoAreaCode": 686,
    "GeoAreaName": "Senegal"
  },
  {
    "2000": 0.92724,
    "2001": 0.92701,
    "2002": 0.92677,
    "2003": 0.9266,
    "2004": 0.92685,
    "2005": 0.92698,
    "2006": 0.92722,
    "2007": 0.92667,
    "2008": 0.92615,
    "2009": 0.92604,
    "2010": 0.9255,
    "2011": 0.92496,
    "2012": 0.92459,
    "2013": 0.92437,
    "2014": 0.92405,
    "2015": 0.92367,
    "2016": 0.92353,
    "2017": 0.92292,
    "2018": 0.9225,
    "2019": 0.92169,
    "2020": 0.92129,
    "2021": 0.92067,
    "2022": 0.92013,
    "2023": 0.91957,
    "2024": 0.91919,
    "GeoAreaCode": 688,
    "GeoAreaName": "Serbia"
  },
  {
    "2000": 0.76236,
    "2001": 0.75918,
    "2002": 0.75611,
    "2003": 0.75304,
    "2004": 0.75013,
    "2005": 0.74698,
    "2006": 0.74404,
    "2007": 0.7401,
    "2008": 0.73736,
    "2009": 0.73363,
    "2010": 0.73069,
    "2011": 0.72706,
    "2012": 0.72227,
    "2013": 0.71924,
    "2014": 0.71617,
    "2015": 0.71188,
    "2016": 0.70785,
    "2017": 0.70337,
    "2018": 0.69783,
    "2019": 0.69479,
    "2020": 0.68939,
    "2021": 0.68449,
    "2022": 0.67963,
    "2023": 0.67567,
    "2024": 0.6706,
    "GeoAreaCode": 690,
    "GeoAreaName": "Seychelles"
  },
  {
    "2000": 0.93661,
    "2001": 0.93659,
    "2002": 0.93654,
    "2003": 0.93643,
    "2004": 0.93645,
    "2005": 0.93647,
    "2006": 0.93643,
    "2007": 0.93639,
    "2008": 0.93633,
    "2009": 0.9363,
    "2010": 0.93625,
    "2011": 0.93624,
    "2012": 0.93621,
    "2013": 0.93621,
    "2014": 0.93621,
    "2015": 0.93621,
    "2016": 0.93607,
    "2017": 0.936,
    "2018": 0.93589,
    "2019": 0.93574,
    "2020": 0.9356,
    "2021": 0.93547,
    "2022": 0.93549,
    "2023": 0.93546,
    "2024": 0.93548,
    "GeoAreaCode": 694,
    "GeoAreaName": "Sierra Leone"
  },
  {
    "2000": 0.91408,
    "2001": 0.91035,
    "2002": 0.90716,
    "2003": 0.9042,
    "2004": 0.90124,
    "2005": 0.89833,
    "2006": 0.89574,
    "2007": 0.8939,
    "2008": 0.89104,
    "2009": 0.88929,
    "2010": 0.88658,
    "2011": 0.88291,
    "2012": 0.87999,
    "2013": 0.87734,
    "2014": 0.87327,
    "2015": 0.86951,
    "2016": 0.86628,
    "2017": 0.86327,
    "2018": 0.859,
    "2019": 0.8575,
    "2020": 0.85339,
    "2021": 0.84999,
    "2022": 0.84579,
    "2023": 0.84341,
    "2024": 0.84002,
    "GeoAreaCode": 702,
    "GeoAreaName": "Singapore"
  },
  {
    "2000": 0.97269,
    "2001": 0.97213,
    "2002": 0.97257,
    "2003": 0.97257,
    "2004": 0.97213,
    "2005": 0.97257,
    "2006": 0.975,
    "2007": 0.97857,
    "2008": 0.97898,
    "2009": 0.98266,
    "2010": 0.98296,
    "2011": 0.98325,
    "2012": 0.98337,
    "2013": 0.9836,
    "2014": 0.98374,
    "2015": 0.98392,
    "2016": 0.98405,
    "2017": 0.98417,
    "2018": 0.98444,
    "2019": 0.98468,
    "2020": 0.98482,
    "2021": 0.98505,
    "2022": 0.98527,
    "2023": 0.98572,
    "2024": 0.98613,
    "GeoAreaCode": 534,
    "GeoAreaName": "Sint Maarten (Dutch part)"
  },
  {
    "2000": 0.97117,
    "2001": 0.97111,
    "2002": 0.97109,
    "2003": 0.97103,
    "2004": 0.97102,
    "2005": 0.97074,
    "2006": 0.97043,
    "2007": 0.97017,
    "2008": 0.96991,
    "2009": 0.96967,
    "2010": 0.96943,
    "2011": 0.96925,
    "2012": 0.96915,
    "2013": 0.96926,
    "2014": 0.96931,
    "2015": 0.96948,
    "2016": 0.96942,
    "2017": 0.9693,
    "2018": 0.96913,
    "2019": 0.96878,
    "2020": 0.96846,
    "2021": 0.96826,
    "2022": 0.96792,
    "2023": 0.96765,
    "2024": 0.9674,
    "GeoAreaCode": 703,
    "GeoAreaName": "Slovakia"
  },
  {
    "2000": 0.92291,
    "2001": 0.92264,
    "2002": 0.92241,
    "2003": 0.92221,
    "2004": 0.92205,
    "2005": 0.9214,
    "2006": 0.92079,
    "2007": 0.92014,
    "2008": 0.91954,
    "2009": 0.91896,
    "2010": 0.9183,
    "2011": 0.91774,
    "2012": 0.9172,
    "2013": 0.91685,
    "2014": 0.91663,
    "2015": 0.91619,
    "2016": 0.91588,
    "2017": 0.9153,
    "2018": 0.9147,
    "2019": 0.91406,
    "2020": 0.91356,
    "2021": 0.91287,
    "2022": 0.91233,
    "2023": 0.91182,
    "2024": 0.91121,
    "GeoAreaCode": 705,
    "GeoAreaName": "Slovenia"
  },
  {
    "2000": 0.78298,
    "2001": 0.78012,
    "2002": 0.77686,
    "2003": 0.77375,
    "2004": 0.77062,
    "2005": 0.7677,
    "2006": 0.7645,
    "2007": 0.761,
    "2008": 0.75804,
    "2009": 0.75572,
    "2010": 0.75288,
    "2011": 0.74941,
    "2012": 0.74599,
    "2013": 0.74272,
    "2014": 0.73936,
    "2015": 0.73596,
    "2016": 0.73255,
    "2017": 0.7291,
    "2018": 0.7255,
    "2019": 0.72229,
    "2020": 0.7186,
    "2021": 0.71572,
    "2022": 0.71185,
    "2023": 0.70937,
    "2024": 0.70541,
    "GeoAreaCode": 722,
    "GeoAreaName": "Small island developing States (SIDS)"
  },
  {
    "2000": 0.83014,
    "2001": 0.82736,
    "2002": 0.82443,
    "2003": 0.82168,
    "2004": 0.81843,
    "2005": 0.81504,
    "2006": 0.81218,
    "2007": 0.80863,
    "2008": 0.80593,
    "2009": 0.80279,
    "2010": 0.80013,
    "2011": 0.79678,
    "2012": 0.794,
    "2013": 0.79074,
    "2014": 0.78716,
    "2015": 0.78409,
    "2016": 0.77961,
    "2017": 0.77719,
    "2018": 0.77377,
    "2019": 0.77074,
    "2020": 0.76751,
    "2021": 0.76332,
    "2022": 0.76055,
    "2023": 0.7577,
    "2024": 0.75465,
    "GeoAreaCode": 90,
    "GeoAreaName": "Solomon Islands"
  },
  {
    "2000": 0.96269,
    "2001": 0.95959,
    "2002": 0.95703,
    "2003": 0.95405,
    "2004": 0.95171,
    "2005": 0.94818,
    "2006": 0.94553,
    "2007": 0.94305,
    "2008": 0.94028,
    "2009": 0.93746,
    "2010": 0.93491,
    "2011": 0.9324,
    "2012": 0.92952,
    "2013": 0.92666,
    "2014": 0.92383,
    "2015": 0.92088,
    "2016": 0.9187,
    "2017": 0.91537,
    "2018": 0.91266,
    "2019": 0.90998,
    "2020": 0.90711,
    "2021": 0.90432,
    "2022": 0.90188,
    "2023": 0.89913,
    "2024": 0.89615,
    "GeoAreaCode": 706,
    "GeoAreaName": "Somalia"
  },
  {
    "2000": 0.82398,
    "2001": 0.82152,
    "2002": 0.81883,
    "2003": 0.81622,
    "2004": 0.8137,
    "2005": 0.81107,
    "2006": 0.80867,
    "2007": 0.80663,
    "2008": 0.80405,
    "2009": 0.8017,
    "2010": 0.79967,
    "2011": 0.79727,
    "2012": 0.79495,
    "2013": 0.79274,
    "2014": 0.79064,
    "2015": 0.78813,
    "2016": 0.78526,
    "2017": 0.78304,
    "2018": 0.78063,
    "2019": 0.77811,
    "2020": 0.77606,
    "2021": 0.77402,
    "2022": 0.77077,
    "2023": 0.76877,
    "2024": 0.767,
    "GeoAreaCode": 710,
    "GeoAreaName": "South Africa"
  },
  {
    "2000": 0.91423,
    "2001": 0.91464,
    "2002": 0.91453,
    "2003": 0.91541,
    "2004": 0.91527,
    "2005": 0.91555,
    "2006": 0.91616,
    "2007": 0.91719,
    "2008": 0.91798,
    "2009": 0.91826,
    "2010": 0.91892,
    "2011": 0.92028,
    "2012": 0.92268,
    "2013": 0.9259,
    "2014": 0.9302,
    "2015": 0.93518,
    "2016": 0.93884,
    "2017": 0.94126,
    "2018": 0.94256,
    "2019": 0.9429,
    "2020": 0.94336,
    "2021": 0.94358,
    "2022": 0.94401,
    "2023": 0.94417,
    "2024": 0.94432,
    "GeoAreaCode": 239,
    "GeoAreaName": "South Georgia and the South Sandwich Islands"
  },
  {
    "2000": 0.93468,
    "2001": 0.93437,
    "2002": 0.93397,
    "2003": 0.93363,
    "2004": 0.93333,
    "2005": 0.93309,
    "2006": 0.93284,
    "2007": 0.93254,
    "2008": 0.93225,
    "2009": 0.93192,
    "2010": 0.93152,
    "2011": 0.9312,
    "2012": 0.93078,
    "2013": 0.93048,
    "2014": 0.93007,
    "2015": 0.92985,
    "2016": 0.92957,
    "2017": 0.92927,
    "2018": 0.92895,
    "2019": 0.9287,
    "2020": 0.92847,
    "2021": 0.92822,
    "2022": 0.92779,
    "2023": 0.92749,
    "2024": 0.92738,
    "GeoAreaCode": 728,
    "GeoAreaName": "South Sudan"
  },
  {
    "2000": 0.80476,
    "2001": 0.80083,
    "2002": 0.79685,
    "2003": 0.79293,
    "2004": 0.78859,
    "2005": 0.78448,
    "2006": 0.77992,
    "2007": 0.77621,
    "2008": 0.7723,
    "2009": 0.76887,
    "2010": 0.76515,
    "2011": 0.76079,
    "2012": 0.75665,
    "2013": 0.75235,
    "2014": 0.74778,
    "2015": 0.74315,
    "2016": 0.73888,
    "2017": 0.7354,
    "2018": 0.73074,
    "2019": 0.72645,
    "2020": 0.72245,
    "2021": 0.71752,
    "2022": 0.71349,
    "2023": 0.71028,
    "2024": 0.70586,
    "GeoAreaCode": 35,
    "GeoAreaName": "South-Eastern Asia"
  },
  {
    "2000": 0.7519,
    "2001": 0.7485,
    "2002": 0.74487,
    "2003": 0.74118,
    "2004": 0.73728,
    "2005": 0.73375,
    "2006": 0.72998,
    "2007": 0.7263,
    "2008": 0.72315,
    "2009": 0.7197,
    "2010": 0.71648,
    "2011": 0.71284,
    "2012": 0.70899,
    "2013": 0.70494,
    "2014": 0.70073,
    "2015": 0.69715,
    "2016": 0.69408,
    "2017": 0.69056,
    "2018": 0.68591,
    "2019": 0.68217,
    "2020": 0.67806,
    "2021": 0.67587,
    "2022": 0.67121,
    "2023": 0.6678,
    "2024": 0.66533,
    "GeoAreaCode": 34,
    "GeoAreaName": "Southern Asia"
  },
  {
    "2000": 0.87853,
    "2001": 0.87803,
    "2002": 0.87746,
    "2003": 0.877,
    "2004": 0.87646,
    "2005": 0.87586,
    "2006": 0.87525,
    "2007": 0.87454,
    "2008": 0.87381,
    "2009": 0.87312,
    "2010": 0.87242,
    "2011": 0.87172,
    "2012": 0.87095,
    "2013": 0.87036,
    "2014": 0.86959,
    "2015": 0.86881,
    "2016": 0.86805,
    "2017": 0.86715,
    "2018": 0.86636,
    "2019": 0.86534,
    "2020": 0.86458,
    "2021": 0.86386,
    "2022": 0.86322,
    "2023": 0.86268,
    "2024": 0.86217,
    "GeoAreaCode": 724,
    "GeoAreaName": "Spain"
  },
  {
    "2000": 0.64003,
    "2001": 0.63669,
    "2002": 0.63255,
    "2003": 0.63048,
    "2004": 0.62637,
    "2005": 0.62329,
    "2006": 0.61938,
    "2007": 0.6157,
    "2008": 0.61266,
    "2009": 0.60906,
    "2010": 0.60545,
    "2011": 0.60191,
    "2012": 0.59899,
    "2013": 0.59518,
    "2014": 0.59148,
    "2015": 0.58806,
    "2016": 0.58436,
    "2017": 0.58065,
    "2018": 0.5771,
    "2019": 0.57389,
    "2020": 0.56932,
    "2021": 0.56663,
    "2022": 0.56397,
    "2023": 0.55891,
    "2024": 0.55486,
    "GeoAreaCode": 144,
    "GeoAreaName": "Sri Lanka"
  },
  {
    "2000": 0.90032,
    "2001": 0.9,
    "2002": 0.89979,
    "2003": 0.89973,
    "2004": 0.89967,
    "2005": 0.89963,
    "2006": 0.89963,
    "2007": 0.89962,
    "2008": 0.89963,
    "2009": 0.89962,
    "2010": 0.8996,
    "2011": 0.89962,
    "2012": 0.89962,
    "2013": 0.89971,
    "2014": 0.89992,
    "2015": 0.90017,
    "2016": 0.9004,
    "2017": 0.90056,
    "2018": 0.90058,
    "2019": 0.90056,
    "2020": 0.90056,
    "2021": 0.90055,
    "2022": 0.90054,
    "2023": 0.90054,
    "2024": 0.90053,
    "GeoAreaCode": 275,
    "GeoAreaName": "State of Palestine"
  },
  {
    "2000": 0.79446,
    "2001": 0.79086,
    "2002": 0.78733,
    "2003": 0.78438,
    "2004": 0.78067,
    "2005": 0.77736,
    "2006": 0.77355,
    "2007": 0.77058,
    "2008": 0.76698,
    "2009": 0.76434,
    "2010": 0.76073,
    "2011": 0.75732,
    "2012": 0.75343,
    "2013": 0.75022,
    "2014": 0.7468,
    "2015": 0.74251,
    "2016": 0.73868,
    "2017": 0.73604,
    "2018": 0.73168,
    "2019": 0.72851,
    "2020": 0.72441,
    "2021": 0.72149,
    "2022": 0.71747,
    "2023": 0.71457,
    "2024": 0.71058,
    "GeoAreaCode": 202,
    "GeoAreaName": "Sub-Saharan Africa"
  },
  {
    "2000": 0.96945,
    "2001": 0.96693,
    "2002": 0.96473,
    "2003": 0.9621,
    "2004": 0.95979,
    "2005": 0.95731,
    "2006": 0.95471,
    "2007": 0.95223,
    "2008": 0.94941,
    "2009": 0.94729,
    "2010": 0.94518,
    "2011": 0.94283,
    "2012": 0.94012,
    "2013": 0.93815,
    "2014": 0.93565,
    "2015": 0.93353,
    "2016": 0.93089,
    "2017": 0.92875,
    "2018": 0.92673,
    "2019": 0.92441,
    "2020": 0.92226,
    "2021": 0.91985,
    "2022": 0.91735,
    "2023": 0.91517,
    "2024": 0.9128,
    "GeoAreaCode": 729,
    "GeoAreaName": "Sudan"
  },
  {
    "2000": 0.99304,
    "2001": 0.99305,
    "2002": 0.99302,
    "2003": 0.99301,
    "2004": 0.99301,
    "2005": 0.99305,
    "2006": 0.99308,
    "2007": 0.99309,
    "2008": 0.99313,
    "2009": 0.99311,
    "2010": 0.9931,
    "2011": 0.99307,
    "2012": 0.99304,
    "2013": 0.99303,
    "2014": 0.99301,
    "2015": 0.993,
    "2016": 0.99299,
    "2017": 0.99295,
    "2018": 0.99294,
    "2019": 0.99289,
    "2020": 0.99287,
    "2021": 0.99286,
    "2022": 0.99285,
    "2023": 0.99284,
    "2024": 0.99283,
    "GeoAreaCode": 740,
    "GeoAreaName": "Suriname"
  },
  {
    "2000": 0.92182,
    "2001": 0.92089,
    "2002": 0.91877,
    "2003": 0.91827,
    "2004": 0.91676,
    "2005": 0.91562,
    "2006": 0.91469,
    "2007": 0.91405,
    "2008": 0.9139,
    "2009": 0.91382,
    "2010": 0.91371,
    "2011": 0.91317,
    "2012": 0.91186,
    "2013": 0.90856,
    "2014": 0.90581,
    "2015": 0.90332,
    "2016": 0.90194,
    "2017": 0.90013,
    "2018": 0.89965,
    "2019": 0.89993,
    "2020": 0.90064,
    "2021": 0.90103,
    "2022": 0.90128,
    "2023": 0.90175,
    "2024": 0.9024,
    "GeoAreaCode": 744,
    "GeoAreaName": "Svalbard and Jan Mayen Islands"
  },
  {
    "2000": 0.99226,
    "2001": 0.99223,
    "2002": 0.99218,
    "2003": 0.99216,
    "2004": 0.99213,
    "2005": 0.99203,
    "2006": 0.99193,
    "2007": 0.99183,
    "2008": 0.99172,
    "2009": 0.99163,
    "2010": 0.99153,
    "2011": 0.99153,
    "2012": 0.99153,
    "2013": 0.99164,
    "2014": 0.99193,
    "2015": 0.99222,
    "2016": 0.99246,
    "2017": 0.99247,
    "2018": 0.99247,
    "2019": 0.99245,
    "2020": 0.99244,
    "2021": 0.99243,
    "2022": 0.99243,
    "2023": 0.99243,
    "2024": 0.99243,
    "GeoAreaCode": 752,
    "GeoAreaName": "Sweden"
  },
  {
    "2000": 0.97357,
    "2001": 0.97351,
    "2002": 0.97348,
    "2003": 0.97346,
    "2004": 0.97329,
    "2005": 0.97286,
    "2006": 0.97232,
    "2007": 0.97175,
    "2008": 0.9712,
    "2009": 0.97062,
    "2010": 0.97003,
    "2011": 0.96948,
    "2012": 0.96905,
    "2013": 0.96872,
    "2014": 0.96846,
    "2015": 0.96829,
    "2016": 0.9679,
    "2017": 0.96756,
    "2018": 0.96705,
    "2019": 0.96638,
    "2020": 0.96585,
    "2021": 0.96531,
    "2022": 0.96476,
    "2023": 0.96431,
    "2024": 0.96383,
    "GeoAreaCode": 756,
    "GeoAreaName": "Switzerland"
  },
  {
    "2000": 0.9508,
    "2001": 0.95042,
    "2002": 0.9499,
    "2003": 0.94963,
    "2004": 0.94972,
    "2005": 0.95004,
    "2006": 0.95027,
    "2007": 0.9513,
    "2008": 0.95172,
    "2009": 0.95177,
    "2010": 0.95177,
    "2011": 0.95174,
    "2012": 0.95172,
    "2013": 0.95177,
    "2014": 0.95205,
    "2015": 0.95256,
    "2016": 0.95292,
    "2017": 0.95318,
    "2018": 0.95322,
    "2019": 0.95314,
    "2020": 0.95311,
    "2021": 0.95304,
    "2022": 0.953,
    "2023": 0.95297,
    "2024": 0.95293,
    "GeoAreaCode": 760,
    "GeoAreaName": "Syrian Arab Republic"
  },
  {
    "2000": 0.98956,
    "2001": 0.98932,
    "2002": 0.98908,
    "2003": 0.98903,
    "2004": 0.989,
    "2005": 0.98896,
    "2006": 0.98897,
    "2007": 0.98897,
    "2008": 0.98897,
    "2009": 0.98897,
    "2010": 0.98901,
    "2011": 0.98902,
    "2012": 0.98905,
    "2013": 0.98905,
    "2014": 0.98905,
    "2015": 0.98903,
    "2016": 0.98902,
    "2017": 0.989,
    "2018": 0.98899,
    "2019": 0.98898,
    "2020": 0.98896,
    "2021": 0.98895,
    "2022": 0.98893,
    "2023": 0.98892,
    "2024": 0.98891,
    "GeoAreaCode": 762,
    "GeoAreaName": "Tajikistan"
  },
  {
    "2000": 0.82744,
    "2001": 0.82448,
    "2002": 0.82149,
    "2003": 0.81849,
    "2004": 0.81594,
    "2005": 0.81334,
    "2006": 0.81015,
    "2007": 0.80729,
    "2008": 0.805,
    "2009": 0.80281,
    "2010": 0.79994,
    "2011": 0.79743,
    "2012": 0.79385,
    "2013": 0.79123,
    "2014": 0.7886,
    "2015": 0.78575,
    "2016": 0.78203,
    "2017": 0.77951,
    "2018": 0.77658,
    "2019": 0.7737,
    "2020": 0.77138,
    "2021": 0.76866,
    "2022": 0.76536,
    "2023": 0.76191,
    "2024": 0.75962,
    "GeoAreaCode": 764,
    "GeoAreaName": "Thailand"
  },
  {
    "2000": 0.92183,
    "2001": 0.91857,
    "2002": 0.91508,
    "2003": 0.91155,
    "2004": 0.90787,
    "2005": 0.90408,
    "2006": 0.90091,
    "2007": 0.89852,
    "2008": 0.89526,
    "2009": 0.89162,
    "2010": 0.88803,
    "2011": 0.88555,
    "2012": 0.88145,
    "2013": 0.87775,
    "2014": 0.87397,
    "2015": 0.87088,
    "2016": 0.86672,
    "2017": 0.86374,
    "2018": 0.85912,
    "2019": 0.85618,
    "2020": 0.85275,
    "2021": 0.8492,
    "2022": 0.84524,
    "2023": 0.84271,
    "2024": 0.83855,
    "GeoAreaCode": 626,
    "GeoAreaName": "Timor-Leste"
  },
  {
    "2000": 0.87732,
    "2001": 0.87722,
    "2002": 0.87708,
    "2003": 0.87711,
    "2004": 0.87691,
    "2005": 0.87675,
    "2006": 0.87668,
    "2007": 0.87646,
    "2008": 0.87603,
    "2009": 0.87574,
    "2010": 0.87543,
    "2011": 0.87493,
    "2012": 0.87456,
    "2013": 0.87418,
    "2014": 0.87375,
    "2015": 0.87325,
    "2016": 0.87278,
    "2017": 0.87236,
    "2018": 0.87197,
    "2019": 0.87145,
    "2020": 0.87107,
    "2021": 0.87063,
    "2022": 0.87018,
    "2023": 0.86989,
    "2024": 0.86955,
    "GeoAreaCode": 768,
    "GeoAreaName": "Togo"
  },
  {
    "2000": 0.89877,
    "2001": 0.89671,
    "2002": 0.89385,
    "2003": 0.89194,
    "2004": 0.88967,
    "2005": 0.88831,
    "2006": 0.88578,
    "2007": 0.88437,
    "2008": 0.88189,
    "2009": 0.88009,
    "2010": 0.87721,
    "2011": 0.87435,
    "2012": 0.87081,
    "2013": 0.8696,
    "2014": 0.86703,
    "2015": 0.86417,
    "2016": 0.86197,
    "2017": 0.85953,
    "2018": 0.85684,
    "2019": 0.85512,
    "2020": 0.85292,
    "2021": 0.85019,
    "2022": 0.84798,
    "2023": 0.84583,
    "2024": 0.84282,
    "GeoAreaCode": 772,
    "GeoAreaName": "Tokelau"
  },
  {
    "2000": 0.75926,
    "2001": 0.75842,
    "2002": 0.75793,
    "2003": 0.75708,
    "2004": 0.75649,
    "2005": 0.75543,
    "2006": 0.75407,
    "2007": 0.75254,
    "2008": 0.75103,
    "2009": 0.74852,
    "2010": 0.74711,
    "2011": 0.74562,
    "2012": 0.74327,
    "2013": 0.74202,
    "2014": 0.73951,
    "2015": 0.7378,
    "2016": 0.73632,
    "2017": 0.73387,
    "2018": 0.73197,
    "2019": 0.73041,
    "2020": 0.72873,
    "2021": 0.7266,
    "2022": 0.72512,
    "2023": 0.72319,
    "2024": 0.72206,
    "GeoAreaCode": 776,
    "GeoAreaName": "Tonga"
  },
  {
    "2000": 0.89668,
    "2001": 0.89548,
    "2002": 0.89425,
    "2003": 0.89313,
    "2004": 0.89189,
    "2005": 0.89034,
    "2006": 0.8893,
    "2007": 0.88833,
    "2008": 0.88735,
    "2009": 0.88618,
    "2010": 0.88495,
    "2011": 0.88376,
    "2012": 0.88234,
    "2013": 0.88136,
    "2014": 0.88,
    "2015": 0.87855,
    "2016": 0.87791,
    "2017": 0.87657,
    "2018": 0.87544,
    "2019": 0.874,
    "2020": 0.87262,
    "2021": 0.87168,
    "2022": 0.86976,
    "2023": 0.86961,
    "2024": 0.86847,
    "GeoAreaCode": 780,
    "GeoAreaName": "Trinidad and Tobago"
  },
  {
    "2000": 0.95042,
    "2001": 0.94973,
    "2002": 0.94929,
    "2003": 0.94914,
    "2004": 0.94908,
    "2005": 0.94904,
    "2006": 0.94935,
    "2007": 0.94944,
    "2008": 0.94946,
    "2009": 0.94938,
    "2010": 0.94923,
    "2011": 0.94917,
    "2012": 0.94926,
    "2013": 0.94902,
    "2014": 0.94902,
    "2015": 0.94931,
    "2016": 0.94934,
    "2017": 0.94913,
    "2018": 0.94923,
    "2019": 0.949,
    "2020": 0.94907,
    "2021": 0.94892,
    "2022": 0.94895,
    "2023": 0.94905,
    "2024": 0.94906,
    "GeoAreaCode": 788,
    "GeoAreaName": "Tunisia"
  },
  {
    "2000": 0.90839,
    "2001": 0.90797,
    "2002": 0.9076,
    "2003": 0.90727,
    "2004": 0.90685,
    "2005": 0.90644,
    "2006": 0.90608,
    "2007": 0.90544,
    "2008": 0.90518,
    "2009": 0.90484,
    "2010": 0.90444,
    "2011": 0.90423,
    "2012": 0.90405,
    "2013": 0.90387,
    "2014": 0.90365,
    "2015": 0.90344,
    "2016": 0.90311,
    "2017": 0.90291,
    "2018": 0.90251,
    "2019": 0.9021,
    "2020": 0.90168,
    "2021": 0.90143,
    "2022": 0.90102,
    "2023": 0.90073,
    "2024": 0.90052,
    "GeoAreaCode": 792,
    "GeoAreaName": "Türkiye"
  },
  {
    "2000": 0.97947,
    "2001": 0.97891,
    "2002": 0.97841,
    "2003": 0.97782,
    "2004": 0.97748,
    "2005": 0.97725,
    "2006": 0.97713,
    "2007": 0.97699,
    "2008": 0.97695,
    "2009": 0.97684,
    "2010": 0.97669,
    "2011": 0.97657,
    "2012": 0.97646,
    "2013": 0.97629,
    "2014": 0.97616,
    "2015": 0.97604,
    "2016": 0.97591,
    "2017": 0.97576,
    "2018": 0.97566,
    "2019": 0.97555,
    "2020": 0.97546,
    "2021": 0.97538,
    "2022": 0.97527,
    "2023": 0.97515,
    "2024": 0.97505,
    "GeoAreaCode": 795,
    "GeoAreaName": "Turkmenistan"
  },
  {
    "2000": 0.88275,
    "2001": 0.88127,
    "2002": 0.87979,
    "2003": 0.87887,
    "2004": 0.8778,
    "2005": 0.87663,
    "2006": 0.87547,
    "2007": 0.87439,
    "2008": 0.87356,
    "2009": 0.87221,
    "2010": 0.87116,
    "2011": 0.87003,
    "2012": 0.86879,
    "2013": 0.86734,
    "2014": 0.86645,
    "2015": 0.86537,
    "2016": 0.86394,
    "2017": 0.86243,
    "2018": 0.86144,
    "2019": 0.86039,
    "2020": 0.85922,
    "2021": 0.85807,
    "2022": 0.85705,
    "2023": 0.85561,
    "2024": 0.85461,
    "GeoAreaCode": 796,
    "GeoAreaName": "Turks and Caicos Islands"
  },
  {
    "2000": 0.90029,
    "2001": 0.89769,
    "2002": 0.89422,
    "2003": 0.89034,
    "2004": 0.88703,
    "2005": 0.88443,
    "2006": 0.8812,
    "2007": 0.87812,
    "2008": 0.87478,
    "2009": 0.87153,
    "2010": 0.86867,
    "2011": 0.86445,
    "2012": 0.86027,
    "2013": 0.85649,
    "2014": 0.85385,
    "2015": 0.84951,
    "2016": 0.84732,
    "2017": 0.84321,
    "2018": 0.84018,
    "2019": 0.83584,
    "2020": 0.83418,
    "2021": 0.83092,
    "2022": 0.82703,
    "2023": 0.8231,
    "2024": 0.82,
    "GeoAreaCode": 798,
    "GeoAreaName": "Tuvalu"
  },
  {
    "2000": 0.81194,
    "2001": 0.80924,
    "2002": 0.807,
    "2003": 0.80376,
    "2004": 0.80086,
    "2005": 0.79807,
    "2006": 0.79494,
    "2007": 0.79162,
    "2008": 0.78892,
    "2009": 0.7858,
    "2010": 0.78299,
    "2011": 0.77956,
    "2012": 0.77697,
    "2013": 0.77366,
    "2014": 0.77162,
    "2015": 0.76836,
    "2016": 0.76558,
    "2017": 0.7623,
    "2018": 0.75877,
    "2019": 0.75621,
    "2020": 0.7533,
    "2021": 0.74986,
    "2022": 0.74668,
    "2023": 0.74373,
    "2024": 0.74002,
    "GeoAreaCode": 800,
    "GeoAreaName": "Uganda"
  },
  {
    "2000": 0.93405,
    "2001": 0.93383,
    "2002": 0.93346,
    "2003": 0.93339,
    "2004": 0.93336,
    "2005": 0.93342,
    "2006": 0.93361,
    "2007": 0.93392,
    "2008": 0.93416,
    "2009": 0.93441,
    "2010": 0.93463,
    "2011": 0.93493,
    "2012": 0.93522,
    "2013": 0.93555,
    "2014": 0.93582,
    "2015": 0.9361,
    "2016": 0.93632,
    "2017": 0.93649,
    "2018": 0.93674,
    "2019": 0.93691,
    "2020": 0.93701,
    "2021": 0.93723,
    "2022": 0.93734,
    "2023": 0.93746,
    "2024": 0.93766,
    "GeoAreaCode": 804,
    "GeoAreaName": "Ukraine"
  },
  {
    "2000": 0.9034,
    "2001": 0.90047,
    "2002": 0.89804,
    "2003": 0.89486,
    "2004": 0.89237,
    "2005": 0.88983,
    "2006": 0.88691,
    "2007": 0.88385,
    "2008": 0.88121,
    "2009": 0.87862,
    "2010": 0.87681,
    "2011": 0.87389,
    "2012": 0.87145,
    "2013": 0.86936,
    "2014": 0.86635,
    "2015": 0.86361,
    "2016": 0.86122,
    "2017": 0.85882,
    "2018": 0.85607,
    "2019": 0.85344,
    "2020": 0.85093,
    "2021": 0.84853,
    "2022": 0.84555,
    "2023": 0.84305,
    "2024": 0.84088,
    "GeoAreaCode": 784,
    "GeoAreaName": "United Arab Emirates"
  },
  {
    "2000": 0.97458,
    "2001": 0.9741,
    "2002": 0.97364,
    "2003": 0.97322,
    "2004": 0.973,
    "2005": 0.97296,
    "2006": 0.97289,
    "2007": 0.97294,
    "2008": 0.973,
    "2009": 0.97311,
    "2010": 0.97318,
    "2011": 0.97325,
    "2012": 0.97327,
    "2013": 0.97328,
    "2014": 0.9733,
    "2015": 0.97329,
    "2016": 0.9733,
    "2017": 0.97333,
    "2018": 0.97337,
    "2019": 0.97342,
    "2020": 0.97347,
    "2021": 0.97348,
    "2022": 0.97354,
    "2023": 0.97358,
    "2024": 0.97363,
    "GeoAreaCode": 826,
    "GeoAreaName": "United Kingdom"
  },
  {
    "2000": 0.76734,
    "2001": 0.76345,
    "2002": 0.75957,
    "2003": 0.75532,
    "2004": 0.75166,
    "2005": 0.74733,
    "2006": 0.74388,
    "2007": 0.73995,
    "2008": 0.73642,
    "2009": 0.73336,
    "2010": 0.72994,
    "2011": 0.726,
    "2012": 0.72225,
    "2013": 0.71818,
    "2014": 0.71443,
    "2015": 0.71,
    "2016": 0.70663,
    "2017": 0.70271,
    "2018": 0.69876,
    "2019": 0.69453,
    "2020": 0.69061,
    "2021": 0.68696,
    "2022": 0.68377,
    "2023": 0.68047,
    "2024": 0.67552,
    "GeoAreaCode": 834,
    "GeoAreaName": "United Republic of Tanzania"
  },
  {
    "2000": 0.84871,
    "2001": 0.84861,
    "2002": 0.8483,
    "2003": 0.84793,
    "2004": 0.84727,
    "2005": 0.84713,
    "2006": 0.84702,
    "2007": 0.84696,
    "2008": 0.84633,
    "2009": 0.8461,
    "2010": 0.8456,
    "2011": 0.84518,
    "2012": 0.84458,
    "2013": 0.84427,
    "2014": 0.84443,
    "2015": 0.84399,
    "2016": 0.84327,
    "2017": 0.8434,
    "2018": 0.84372,
    "2019": 0.84398,
    "2020": 0.84329,
    "2021": 0.84304,
    "2022": 0.84212,
    "2023": 0.84185,
    "2024": 0.84159,
    "GeoAreaCode": 581,
    "GeoAreaName": "United States Minor Outlying Islands"
  },
  {
    "2000": 0.85227,
    "2001": 0.85126,
    "2002": 0.85031,
    "2003": 0.84937,
    "2004": 0.84843,
    "2005": 0.84757,
    "2006": 0.8465,
    "2007": 0.84556,
    "2008": 0.84468,
    "2009": 0.84373,
    "2010": 0.84302,
    "2011": 0.84239,
    "2012": 0.84138,
    "2013": 0.84065,
    "2014": 0.83962,
    "2015": 0.83884,
    "2016": 0.83809,
    "2017": 0.83715,
    "2018": 0.83618,
    "2019": 0.83558,
    "2020": 0.83466,
    "2021": 0.83404,
    "2022": 0.83348,
    "2023": 0.8324,
    "2024": 0.83189,
    "GeoAreaCode": 840,
    "GeoAreaName": "United States of America"
  },
  {
    "2000": 0.81893,
    "2001": 0.81886,
    "2002": 0.81874,
    "2003": 0.81866,
    "2004": 0.81857,
    "2005": 0.81844,
    "2006": 0.81834,
    "2007": 0.81826,
    "2008": 0.81825,
    "2009": 0.81813,
    "2010": 0.81801,
    "2011": 0.81794,
    "2012": 0.81783,
    "2013": 0.81776,
    "2014": 0.81765,
    "2015": 0.81748,
    "2016": 0.81739,
    "2017": 0.81729,
    "2018": 0.81715,
    "2019": 0.81701,
    "2020": 0.81693,
    "2021": 0.81678,
    "2022": 0.81671,
    "2023": 0.8166,
    "2024": 0.81645,
    "GeoAreaCode": 850,
    "GeoAreaName": "United States Virgin Islands"
  },
  {
    "2000": 0.90309,
    "2001": 0.90355,
    "2002": 0.90388,
    "2003": 0.9044,
    "2004": 0.90486,
    "2005": 0.90528,
    "2006": 0.90575,
    "2007": 0.90612,
    "2008": 0.90645,
    "2009": 0.90687,
    "2010": 0.90724,
    "2011": 0.90752,
    "2012": 0.90788,
    "2013": 0.90815,
    "2014": 0.90849,
    "2015": 0.90881,
    "2016": 0.90906,
    "2017": 0.90936,
    "2018": 0.90968,
    "2019": 0.90994,
    "2020": 0.91029,
    "2021": 0.9107,
    "2022": 0.9109,
    "2023": 0.91119,
    "2024": 0.91148,
    "GeoAreaCode": 858,
    "GeoAreaName": "Uruguay"
  },
  {
    "2000": 0.97951,
    "2001": 0.97858,
    "2002": 0.9778,
    "2003": 0.97704,
    "2004": 0.97648,
    "2005": 0.97606,
    "2006": 0.97571,
    "2007": 0.97549,
    "2008": 0.97525,
    "2009": 0.97503,
    "2010": 0.97485,
    "2011": 0.9744,
    "2012": 0.97405,
    "2013": 0.97368,
    "2014": 0.97323,
    "2015": 0.97262,
    "2016": 0.97229,
    "2017": 0.97185,
    "2018": 0.97131,
    "2019": 0.97095,
    "2020": 0.97075,
    "2021": 0.97027,
    "2022": 0.96985,
    "2023": 0.9696,
    "2024": 0.9692,
    "GeoAreaCode": 860,
    "GeoAreaName": "Uzbekistan"
  },
  {
    "2000": 0.73741,
    "2001": 0.73424,
    "2002": 0.73123,
    "2003": 0.72811,
    "2004": 0.72504,
    "2005": 0.7219,
    "2006": 0.71903,
    "2007": 0.71603,
    "2008": 0.71311,
    "2009": 0.71116,
    "2010": 0.70831,
    "2011": 0.70533,
    "2012": 0.70175,
    "2013": 0.69894,
    "2014": 0.69616,
    "2015": 0.69249,
    "2016": 0.68988,
    "2017": 0.6869,
    "2018": 0.68408,
    "2019": 0.68061,
    "2020": 0.67726,
    "2021": 0.67467,
    "2022": 0.67214,
    "2023": 0.66938,
    "2024": 0.66557,
    "GeoAreaCode": 548,
    "GeoAreaName": "Vanuatu"
  },
  {
    "2000": 0.85095,
    "2001": 0.84961,
    "2002": 0.84835,
    "2003": 0.8467,
    "2004": 0.84539,
    "2005": 0.84369,
    "2006": 0.84203,
    "2007": 0.84014,
    "2008": 0.83828,
    "2009": 0.83639,
    "2010": 0.83432,
    "2011": 0.83275,
    "2012": 0.83091,
    "2013": 0.82878,
    "2014": 0.82681,
    "2015": 0.82469,
    "2016": 0.82285,
    "2017": 0.8212,
    "2018": 0.81894,
    "2019": 0.81711,
    "2020": 0.81527,
    "2021": 0.81317,
    "2022": 0.81105,
    "2023": 0.80933,
    "2024": 0.80723,
    "GeoAreaCode": 862,
    "GeoAreaName": "Venezuela"
  },
  {
    "2000": 0.79367,
    "2001": 0.78966,
    "2002": 0.78592,
    "2003": 0.78246,
    "2004": 0.77821,
    "2005": 0.77485,
    "2006": 0.77076,
    "2007": 0.76661,
    "2008": 0.76333,
    "2009": 0.75929,
    "2010": 0.75597,
    "2011": 0.75209,
    "2012": 0.74825,
    "2013": 0.74372,
    "2014": 0.73986,
    "2015": 0.73639,
    "2016": 0.73263,
    "2017": 0.72853,
    "2018": 0.72416,
    "2019": 0.7205,
    "2020": 0.71679,
    "2021": 0.71286,
    "2022": 0.70871,
    "2023": 0.70577,
    "2024": 0.70141,
    "GeoAreaCode": 704,
    "GeoAreaName": "Viet Nam"
  },
  {
    "2000": 0.89987,
    "2001": 0.89585,
    "2002": 0.89382,
    "2003": 0.89172,
    "2004": 0.88871,
    "2005": 0.88585,
    "2006": 0.88379,
    "2007": 0.88104,
    "2008": 0.87841,
    "2009": 0.87594,
    "2010": 0.87347,
    "2011": 0.86998,
    "2012": 0.86709,
    "2013": 0.86454,
    "2014": 0.86148,
    "2015": 0.85848,
    "2016": 0.85576,
    "2017": 0.85366,
    "2018": 0.85,
    "2019": 0.84821,
    "2020": 0.84525,
    "2021": 0.84191,
    "2022": 0.8396,
    "2023": 0.83687,
    "2024": 0.83383,
    "GeoAreaCode": 876,
    "GeoAreaName": "Wallis and Futuna Islands"
  },
  {
    "2000": 0.88481,
    "2001": 0.88169,
    "2002": 0.87868,
    "2003": 0.87598,
    "2004": 0.87265,
    "2005": 0.87001,
    "2006": 0.86697,
    "2007": 0.86388,
    "2008": 0.86103,
    "2009": 0.85804,
    "2010": 0.8555,
    "2011": 0.85268,
    "2012": 0.85035,
    "2013": 0.84706,
    "2014": 0.84442,
    "2015": 0.84102,
    "2016": 0.83866,
    "2017": 0.83588,
    "2018": 0.83226,
    "2019": 0.82931,
    "2020": 0.82711,
    "2021": 0.82382,
    "2022": 0.82096,
    "2023": 0.81797,
    "2024": 0.81495,
    "GeoAreaCode": 145,
    "GeoAreaName": "Western Asia"
  },
  {
    "2000": 0.96828,
    "2001": 0.96686,
    "2002": 0.96675,
    "2003": 0.96753,
    "2004": 0.96781,
    "2005": 0.96971,
    "2006": 0.97083,
    "2007": 0.97124,
    "2008": 0.97121,
    "2009": 0.97139,
    "2010": 0.97132,
    "2011": 0.97125,
    "2012": 0.97111,
    "2013": 0.97097,
    "2014": 0.97079,
    "2015": 0.97064,
    "2016": 0.9705,
    "2017": 0.97036,
    "2018": 0.97017,
    "2019": 0.97006,
    "2020": 0.96992,
    "2021": 0.96988,
    "2022": 0.9698,
    "2023": 0.9698,
    "2024": 0.96978,
    "GeoAreaCode": 732,
    "GeoAreaName": "Western Sahara"
  },
  {
    "2000": 0.80132,
    "2001": 0.7976,
    "2002": 0.79459,
    "2003": 0.79127,
    "2004": 0.78777,
    "2005": 0.78442,
    "2006": 0.78118,
    "2007": 0.77758,
    "2008": 0.77485,
    "2009": 0.77215,
    "2010": 0.76878,
    "2011": 0.76536,
    "2012": 0.76194,
    "2013": 0.75889,
    "2014": 0.7554,
    "2015": 0.75134,
    "2016": 0.74815,
    "2017": 0.74467,
    "2018": 0.74146,
    "2019": 0.73733,
    "2020": 0.73467,
    "2021": 0.73128,
    "2022": 0.7282,
    "2023": 0.72403,
    "2024": 0.72127,
    "GeoAreaCode": 1,
    "GeoAreaName": "World"
  },
  {
    "2000": 0.92941,
    "2001": 0.92691,
    "2002": 0.92387,
    "2003": 0.92108,
    "2004": 0.91843,
    "2005": 0.91583,
    "2006": 0.9129,
    "2007": 0.91066,
    "2008": 0.90807,
    "2009": 0.90575,
    "2010": 0.90302,
    "2011": 0.90049,
    "2012": 0.89752,
    "2013": 0.89473,
    "2014": 0.89176,
    "2015": 0.8896,
    "2016": 0.88679,
    "2017": 0.88378,
    "2018": 0.88149,
    "2019": 0.87898,
    "2020": 0.87613,
    "2021": 0.87293,
    "2022": 0.87014,
    "2023": 0.86869,
    "2024": 0.86603,
    "GeoAreaCode": 887,
    "GeoAreaName": "Yemen"
  },
  {
    "2000": 0.87567,
    "2001": 0.87557,
    "2002": 0.87555,
    "2003": 0.87558,
    "2004": 0.87555,
    "2005": 0.87545,
    "2006": 0.87546,
    "2007": 0.87543,
    "2008": 0.87541,
    "2009": 0.87538,
    "2010": 0.87538,
    "2011": 0.87534,
    "2012": 0.87537,
    "2013": 0.87534,
    "2014": 0.8754,
    "2015": 0.87536,
    "2016": 0.87538,
    "2017": 0.87538,
    "2018": 0.8754,
    "2019": 0.87539,
    "2020": 0.87546,
    "2021": 0.87548,
    "2022": 0.87545,
    "2023": 0.87553,
    "2024": 0.87547,
    "GeoAreaCode": 894,
    "GeoAreaName": "Zambia"
  },
  {
    "2000": 0.79598,
    "2001": 0.79533,
    "2002": 0.79472,
    "2003": 0.79404,
    "2004": 0.79389,
    "2005": 0.7937,
    "2006": 0.7936,
    "2007": 0.79354,
    "2008": 0.79348,
    "2009": 0.79347,
    "2010": 0.79341,
    "2011": 0.79333,
    "2012": 0.79315,
    "2013": 0.79297,
    "2014": 0.79277,
    "2015": 0.7926,
    "2016": 0.79256,
    "2017": 0.79254,
    "2018": 0.79252,
    "2019": 0.7925,
    "2020": 0.79249,
    "2021": 0.79248,
    "2022": 0.79247,
    "2023": 0.79247,
    "2024": 0.79247,
    "GeoAreaCode": 716,
    "GeoAreaName": "Zimbabwe"
  }
]